{
  "common": {
    "show_password": "顯示密碼",
    "hide_password": "隱藏密碼",
    "loading": "載入中…",
    "retry": "重試",
    "error": "發生錯誤",
    "none": "—",
    "cancel": "取消",
    "back": "返回",
    "copy": "複製",
    "done": "完成",
    "save": "儲存",
    "edit": "編輯",
    "close": "關閉",
    "list_sep": "、",
    "list_sep2": "；",
    "colon": "：",
    "paren": "（{{x}}）",
    "saving": "儲存中…",
    "yes": "有",
    "on": "開",
    "off": "關",
    "device_id": "設備 ID",
    "action_delete": "刪除",
    "action_remove": "移除",
    "action_update_fw": "開始更新",
    "action_apply": "套用",
    "action_change": "改設定",
    "action_revoke": "撤銷",
    "action_purge": "清除資料",
    "action_reboot": "重新開機",
    "confirm_type": "輸入「{{name}}」確認",
    "action_end": "終止",
    "action_sign_out": "登出",
    "op_failed": "操作沒有完成，請稍後再試。（代碼：{{code}}）",
    "state_unknown": "未知",
    "pick_date": "選日期",
    "dt24_bad": "請寫成 2026-10-13 22:25（24 小時制）",
    "on_this_page": "這一頁："
  },
  "auth": {
    "title": "登入",
    "email": "Email",
    "password": "密碼",
    "submit": "登入",
    "submitting": "登入中…",
    "err_INVALID_CREDENTIALS": "帳號或密碼錯誤",
    "err_RATE_LIMITED": "嘗試太多次，請稍後再試",
    "err_NETWORK": "無法連線，請檢查網路",
    "err_IDENTITY_UNAVAILABLE": "帳號服務暫時無法連線",
    "err_default": "登入失敗（{{code}}）",
    "reason_SESSION_IDLE": "閒置太久，已自動登出。請重新登入。",
    "err_SESSION_IDLE": "閒置太久，請重新登入",
    "err_PASSKEY_REQUIRED": "這個帳號請用 passkey 登入",
    "reason_SESSION_REAUTH": "值班帳號每 12 小時要重新登入。",
    "hint": "用 {{brand}} App 的同一個帳號登入：自己的設備、組織授權給你的、別人分享給你的，都在這裡。",
    "forgot": "忘記密碼？",
    "forgot_title": "重設密碼",
    "forgot_hint": "輸入帳號的 email，我們會寄重設連結給你。",
    "forgot_submit": "寄出重設連結",
    "forgot_sent": "如果這個 email 有帳號，重設連結已經寄出。請一併檢查垃圾郵件。",
    "forgot_back": "回到登入",
    "no_account": "還沒有帳號？",
    "signup": "註冊",
    "signup_title": "註冊帳號",
    "signup_hint": "這個帳號也能登入 {{brand}} App。之後被組織邀請或別人分享設備給你，用同一個帳號就看得到。",
    "signup_submit": "建立帳號",
    "pending_invite": "登入後會自動接受你點的邀請。",
    "err_EMAIL_EXISTS": "這個 email 已有帳號，請直接登入",
    "err_WEAK_PASSWORD": "密碼太短或太常見",
    "err_SIGNUP_CLOSED": "這個服務不再開放註冊",
    "err_BRAND_OFFBOARDING": "這個品牌已停止新註冊",
    "reason_other": "已登出，請重新登入。"
  },
  "nav": {
    "overview": "總覽",
    "live": "即時影像",
    "playback": "回放",
    "events": "事件與警報",
    "map": "地圖",
    "devices": "設備",
    "ai": "AI 分析",
    "backup": "異地備份",
    "exports": "匯出與證據",
    "people": "人員與存取",
    "audit": "稽核",
    "billing": "方案與帳單",
    "rules": "自動化規則",
    "sites": "組織與場域",
    "org": "組織設定",
    "account": "我的帳號"
  },
  "shell": {
    "scope_all": "全部（我自己的 + 組織授權給我 + 別人分享給我）",
    "language": "語言",
    "logout": "登出",
    "env": "環境",
    "env_badge": "環境：{{env}}",
    "scope": "範圍",
    "present_end": "展示結束"
  },
  "planned": {
    "title": "{{name}}：規劃中",
    "body": "這個模組排在 {{milestone}} 交付，規格見 plan/vms-web-v0.md。",
    "spec": "規格章節"
  },
  "overview": {
    "title": "總覽",
    "homes": "$t(leaf.cur)",
    "devices": "設備",
    "online": "在線",
    "offline": "離線",
    "role": "角色",
    "no_homes": "目前沒有任何$t(leaf.cur)或場域。請用 App 建立$t(leaf.cur)，或請組織管理員授權。",
    "open_devices": "看設備",
    "cameras": "畫面（在線 / 全部）",
    "recent_events": "最近事件",
    "devices_n_one": "{{count}} 台",
    "devices_n_other": "{{count}} 台",
    "channels_note_one": "另有 {{count}} 個 NVR 通道",
    "channels_note_other": "另有 {{count}} 個 NVR 通道",
    "devices_tip": "設備 = 實體台數，不含 NVR 通道（一台 NVR 算 1）",
    "offline_tip": "NVR 在線、只有通道離線時只算通道",
    "online_rate": "設備在線率 {{pct}}%",
    "cameras_tip": "畫面 = 攝影機或通道；一台 NVR 有幾個通道就算幾個畫面。點了在影像牆打開",
    "recorders_bad": "{{bad}} / {{total}} 異常",
    "recorders_tip": "錄影主機 = NVR 與 Kinio Station（含 Mac / Windows 版）",
    "basis_auto": "以最近平均錄影 {{mbps}} Mbps、{{gb}} GB 循環覆寫估算",
    "basis_off": "以最近平均錄影 {{mbps}} Mbps、剩下 {{gb}} GB 估算（不覆寫）",
    "fw_outdated_one": "{{count}} 台有新版",
    "fw_outdated_other": "{{count}} 台有新版",
    "fw_all_latest_one": "{{count}} 台已是最新",
    "fw_all_latest_other": "{{count}} 台已是最新",
    "fw_tip": "只算設備本體（NVR 通道跟著 NVR）；跟「設備 › 韌體」同一份資料",
    "todo_title": "需要處理",
    "todo_none": "目前沒有需要處理的事。",
    "todo_offline": "離線：{{devices}} 台設備、{{channels}} 個通道",
    "todo_storage_one": "{{count}} 台錄影主機儲存異常",
    "todo_storage_other": "{{count}} 台錄影主機儲存異常",
    "todo_cert_one": "{{count}} 台憑證已過期或快到期",
    "todo_cert_other": "{{count}} 台憑證已過期或快到期",
    "todo_fw_one": "{{count}} 台有新版韌體",
    "todo_fw_other": "{{count}} 台有新版韌體",
    "todo_alarms_one": "{{count}} 則警報還沒處理",
    "todo_alarms_other": "{{count}} 則警報還沒處理",
    "todo_gaps_one": "{{count}} 台攝影機過去 24 小時錄影有缺口",
    "todo_gaps_other": "{{count}} 台攝影機過去 24 小時錄影有缺口",
    "gap_cam_reason": "{{name}}（{{reason}}）",
    "and_more_one": " 等 {{count}} 台",
    "and_more_other": " 等 {{count}} 台",
    "act_view": "查看",
    "act_check": "檢查",
    "act_update": "看韌體",
    "act_handle": "處理警報",
    "act_playback": "回放",
    "recent_alarms": "最近警報",
    "no_alarms": "最近沒有警報",
    "unknown_device": "已移除的設備",
    "home_online": "{{on}} / {{total}} 台在線",
    "armed_hint": "布防模式：決定哪些偵測算警報",
    "fw_item": "{{name}}（目前 {{v}}）",
    "no_new_alarms_open_one": "最近沒有新警報；還有 {{count}} 則較早的警報還沒處理。",
    "no_new_alarms_open_other": "最近沒有新警報；還有 {{count}} 則較早的警報還沒處理。",
    "open_alarms": "還沒處理的警報",
    "open_alarms_more": "看全部 {{count}} 則",
    "fw_all_latest_card_one": "全部最新（{{count}} 台）",
    "fw_all_latest_card_other": "全部最新（{{count}} 台）",
    "fw_unknown_note_one": "{{count}} 台讀不到版本",
    "fw_unknown_note_other": "{{count}} 台讀不到版本",
    "recorders_ok_one": "{{count}} 台正常",
    "recorders_ok_other": "{{count}} 台正常",
    "offline_short": "{{devices}} 台 · {{channels}} 通道",
    "offline_dev_only_one": "{{count}} 台",
    "offline_dev_only_other": "{{count}} 台",
    "offline_ch_only_one": "{{count}} 個通道",
    "offline_ch_only_other": "{{count}} 個通道",
    "todo_alarms_more_one": "{{count}}+ 則警報還沒處理",
    "todo_alarms_more_other": "{{count}}+ 則警報還沒處理",
    "todo_alarms_counting": "有警報還沒處理（計算中）",
    "unlisted_open_one": "另有 {{count}} 則來自未登記或已移除的設備，不算在內",
    "unlisted_open_other": "另有 {{count}} 則來自未登記或已移除的設備，不算在內"
  },
  "devices": {
    "title": "設備",
    "search": "搜尋名稱、機種",
    "col_name": "名稱",
    "col_home": "$t(leaf.cur) / 場域",
    "col_model": "機種",
    "col_kind": "類型",
    "col_fw": "韌體",
    "col_status": "狀態",
    "col_last_seen": "最後上線",
    "online": "在線",
    "offline": "離線",
    "unknown": "未知",
    "empty": "沒有設備",
    "count_one": "共 {{count}} 台",
    "count_other": "共 {{count}} 台",
    "home_failed": "{{home}} 讀取失敗：{{err}}",
    "expand": "展開",
    "collapse": "收合",
    "channels": "{{n}} 路",
    "watch": "觀看",
    "kind_native": "Kinio",
    "kind_child": "通道 / 子設備",
    "kind_lscloud": "LS Cloud",
    "kind_swann": "Swann",
    "filter_status": "狀態",
    "filter_all": "全部狀態",
    "view": "檢視",
    "view_table": "表格",
    "view_tree": "依位置",
    "col_recording": "雲端錄影",
    "col_ai": "AI",
    "col_location": "位置",
    "seat_event": "事件席次",
    "seat_continuous": "全時席次",
    "reason_keepalive_timeout": "連線逾時",
    "reason_gateway_lost": "平台連線中斷",
    "reason_missed_check_in": "休眠後沒回報",
    "reason_clean_close": "設備主動斷線",
    "reason_probe_timeout": "探測逾時",
    "reason_superseded": "被新連線取代",
    "reason_channel_offline": "通道離線",
    "reason_read_error": "讀取失敗",
    "reason_other": "原因不明",
    "count2_one": "{{count}} 台設備 · {{channels}} 個通道",
    "count2_other": "{{count}} 台設備 · {{channels}} 個通道",
    "count_tip": "設備 = 實體台數（一台 NVR 算 1）；通道另外算",
    "filter_cert": "只看憑證快到期的",
    "filter_type": "類型",
    "type_all": "全部類型",
    "type_camera": "攝影機",
    "type_recorder": "錄影主機",
    "type_sensor": "感測器",
    "cols": "欄位 ▾",
    "col_reason": "離線原因",
    "col_actions": "動作",
    "more": "{{name}} 的更多動作",
    "model_generic": "RTSP 攝影機（沒有型號資訊）",
    "model_unknown": "還沒取得型號",
    "model_onvif": "ONVIF 攝影機"
  },
  "live": {
    "cameras": "攝影機",
    "no_cameras": "沒有可觀看的攝影機",
    "layout": "版面",
    "autofill": "填滿在線攝影機",
    "empty_cell": "從左側點選或拖曳攝影機到這裡",
    "back_to_wall": "回影像牆",
    "expand": "放大",
    "remove": "移出影像牆",
    "connecting": "連線中…",
    "offline": "設備離線",
    "no_video": "已連線，設備沒有送影像軌",
    "failed": "無法觀看（{{code}}）",
    "err_DEVICE_OFFLINE": "設備離線",
    "err_CHANNEL_OFFLINE": "通道離線",
    "err_HARDWARE_ERROR": "設備影像引擎錯誤；持續發生請重新啟動設備",
    "err_FORBIDDEN": "沒有權限觀看這台設備",
    "err_NO_WEBRTC": "瀏覽器不支援 WebRTC",
    "slow_first_frame": "已連線，還沒收到畫面（電池 / HaLow 攝影機可能在休眠）",
    "err_MAX_SESSIONS_REACHED": "此設備同時觀看已達上限，請先關閉其他畫面",
    "err_VIEWER_LIMIT": "此設備同時觀看已達上限，請先關閉其他畫面",
    "watch_playback": "回放",
    "budget_note": "這台電腦同時解碼上限 {{budget}} 路；另外 {{n}} 格顯示預覽，點「轉即時」或放大才開即時。",
    "preview": "預覽",
    "go_live": "轉即時",
    "stream_main": "高畫質",
    "stream_sub": "省流量",
    "reconnect_wait": "{{s}} 秒後自動重連（第 {{n}} 次）",
    "reconnecting": "重新連線中…（第 {{n}} 次）",
    "err_STALLED": "影像中斷",
    "err_NETWORK": "網路中斷",
    "err_CONNECT_TIMEOUT": "連線逾時",
    "err_SIGNAL_CLOSED": "連線中斷",
    "err_SESSION_REVOKED": "登入已失效（在別處登出或重設了密碼），請重新登入",
    "err_ACCESS_REVOKED": "觀看權限已被收回",
    "err_CODEC_UNSUPPORTED": "此通道編碼（H.265）瀏覽器無法播放，請將此通道子碼流改為 H.264",
    "err_INVALID_PAYLOAD": "無法建立連線（請求格式不符）",
    "path_lan": "區網",
    "path_direct": "直連",
    "path_relay": "中繼",
    "zoom_reset": "{{z}}× 還原",
    "zoom_hint": "滾輪放大、拖曳移動、雙擊還原",
    "snapshot": "快照（下載）",
    "replay": "倒退 30 秒回看",
    "stream_switch": "切換畫質：省流量 / 高畫質（目前：{{s}}）",
    "stream_manual": "手動",
    "custom_grid": "自訂",
    "custom_cols": "欄",
    "custom_rows": "列",
    "custom_apply": "套用",
    "err_RELAY_IDLE": "中繼連線閒置太久，已中斷",
    "err_RELAY_LIMIT": "中繼連線單次 30 分鐘到了，已中斷",
    "relay_idle_warn": "中繼連線閒置中，{{s}} 秒後中斷",
    "relay_continue": "繼續觀看",
    "talk": "按住說話",
    "talking": "說話中…",
    "talk_starting": "開啟麥克風…",
    "talk_hint": "按住說話，放開停止（聚焦後也可以按住空白鍵）",
    "listen_on": "開啟現場聲音",
    "listen_off": "關閉現場聲音",
    "talk_forbidden": "你沒有這台設備的對講權限",
    "talk_incapable": "這台設備不支援對講",
    "talk_busy": "另一位使用者正在對講",
    "talk_denied": "瀏覽器沒有允許使用麥克風",
    "talk_error": "對講開啟失敗，請再試一次",
    "talk_unavailable": "影像連上後才能對講",
    "no_live_n_one": "{{count}} 台現在不能看即時影像",
    "no_live_n_other": "{{count}} 台現在不能看即時影像",
    "ms_popout": "開到另一個螢幕（電視牆）",
    "ms_pick_screen": "放到哪個螢幕",
    "ms_this_screen": "這個螢幕",
    "ms_drag_hint": "已開新視窗；把它拖到要放的螢幕，按 F11 全螢幕。",
    "ms_blocked": "瀏覽器擋了彈出視窗，請允許這個網站開彈出視窗。",
    "ms_restore": "還原多螢幕配置（{{n}}）",
    "ms_wall": "影像牆（另一個螢幕）",
    "ms_f11": "按 F11 全螢幕",
    "ms_alarm_here": "警報在這個視窗跳出",
    "ms_claim_alarm": "這個視窗跳警報",
    "ms_close_wall": "關閉這面牆",
    "ms_budget_shared": "其他螢幕已用掉解碼預算 {{used}} / {{total}} 路",
    "snapshot_at": "快照 {{at}}",
    "scope_changed": "範圍已換到 {{name}}（{{n}} 個畫面）。",
    "scope_fill": "用這個範圍填滿牆",
    "scope_keep": "保留目前的牆",
    "overflow_n_one": "還有 {{count}} 個畫面在下一頁",
    "overflow_n_other": "還有 {{count}} 個畫面在下一頁",
    "overflow_next": "下一頁",
    "more_grids": "更多版型",
    "ms_popout_hint": "另開一個只有影像牆的視窗，可以拖到另一個螢幕全螢幕顯示",
    "grid_key": "{{n}} 格（快捷鍵 {{key}}）",
    "stream_main_short": "高",
    "stream_sub_short": "省",
    "conn_info": "連線資訊（路徑、編碼、解析度）",
    "tile_more": "{{name}} 的更多動作（畫質、連線資訊、聲音、快照、回看、PTZ）",
    "slow_first_frame_wired": "已連線，等第一個畫面…",
    "slow_connect": "連線比平常久…",
    "wall_out_of_scope_one": "牆上有 {{count}} 格不在目前範圍",
    "wall_out_of_scope_other": "牆上有 {{count}} 格不在目前範圍",
    "wall_fill_scope": "換成本範圍",
    "out_of_scope_tile": "這一格不在目前範圍（在 {{where}}）",
    "scope_changed_all_on": "範圍已換到 {{name}}（{{n}} 個畫面都已經在牆上）。",
    "scope_ack": "知道了",
    "autofill_all_on": "範圍內的畫面都已經在牆上",
    "wall_pruned_one": "{{count}} 個畫面已不在你能看的清單（攝影機被移走、解綁或沒有權限了），已從牆上移除。",
    "wall_pruned_other": "{{count}} 個畫面已不在你能看的清單（攝影機被移走、解綁或沒有權限了），已從牆上移除。",
    "wall_pruned_undo": "復原",
    "wall_pruned_ok": "知道了",
    "cell_gone": "這台攝影機已不在你的清單",
    "cell_no_live": "這台設備沒有即時影像",
    "err_UNREACHABLE": "連不上畫面（設備狀態是在線）",
    "err_ICE_FAILED": "連線中斷，正在重連…",
    "failed_retrying": "連線中斷，正在重連…",
    "failed_plain": "無法觀看",
    "reconnect_now": "立刻重連",
    "focus": "專注",
    "focus_tip": "收起選單，影像填滿畫面（Shift+F）",
    "focus_exit": "離開專注（Esc）",
    "empty_cell_focus": "離開專注模式後可加入攝影機"
  },
  "events": {
    "search": "搜尋類型、設備、$t(leaf.cur)",
    "count": "{{n}} 筆",
    "empty": "沒有符合的事件",
    "class_motion": "動態",
    "class_sensor": "感測器",
    "class_system": "系統",
    "class_other": "其他",
    "live_new": "即時",
    "class_alarm": "警報",
    "class_detection": "偵測",
    "mark_all_seen": "全部標為已看",
    "unseen_n": "{{n}} 則未看的警報與偵測",
    "thumb_alt": "事件縮圖",
    "cls_name": {
      "motion": "移動",
      "person": "人",
      "human": "人",
      "vehicle": "車輛",
      "pet": "動物",
      "package": "包裹",
      "ai_label": "AI 偵測",
      "sound": "聲音",
      "alarm": "警報",
      "tamper": "遮擋或破壞",
      "contact": "門窗",
      "occupancy": "有人 / 無人",
      "doorbell": "門鈴",
      "call": "呼叫",
      "connection": "連線",
      "storage": "儲存",
      "recording": "錄影",
      "power": "電源",
      "ota": "韌體更新",
      "credential": "憑證",
      "system": "系統",
      "security_mode": "警戒模式",
      "bookmark": "書籤"
    },
    "type_unknown": "其他事件",
    "chip_tip": "點一下只看這一類，再點一次回到全部；按住 ⌘ / Ctrl 可以多選",
    "more": "更多",
    "unregistered_channel": "{{parent}} / CH{{n}}（未登記的通道）",
    "device_unknown": "不在清單裡的設備",
    "tab_alarms": "警報",
    "tab_alarms_n_one": "警報（未處理 {{count}}）",
    "tab_alarms_n_other": "警報（未處理 {{count}}）",
    "tab_all": "全部事件",
    "tab_saved": "已存搜尋",
    "other_channels": "其他通道（{{n}}）",
    "device_unknown_tail": "不在清單裡的設備（…{{tail}}）",
    "tag": {
      "person": "人",
      "human": "人",
      "vehicle": "車",
      "car": "車",
      "animal": "動物",
      "pet": "寵物",
      "dog": "狗",
      "cat": "貓",
      "package": "包裹",
      "face": "人臉",
      "bark": "狗叫",
      "glass_break": "玻璃破裂",
      "baby_cry": "哭聲",
      "smoke_alarm": "煙霧警報聲",
      "motion": "動態",
      "sound": "聲音",
      "bicycle": "腳踏車",
      "motorcycle": "機車"
    },
    "other_devices": "其他（{{n}}）",
    "times_n": "× {{n}} 次（最早 {{since}}）",
    "times_only": "× {{n}} 次",
    "ep_lasted": "持續 {{dur}}",
    "ep_open": "進行中",
    "ep_stale": "沒有收到結束紀錄",
    "ep_end_only": "結束",
    "times_counting": "計算中",
    "all_loaded": "已載入全部 {{n}} 次（合併成 {{rows}} 列）",
    "no_thumb": "沒有縮圖",
    "tab_alarms_more_one": "警報（未處理 {{count}}+）",
    "tab_alarms_more_other": "警報（未處理 {{count}}+）",
    "ep_lasted_lt1": "持續不到 1 秒",
    "tab_alarms_counting": "警報（計算中）",
    "compose": {
      "multi_press_n": "連按 {{count}} 下",
      "contact_opened": "打開",
      "contact_closed": "關閉",
      "leak_detected": "偵測到漏水",
      "leak_cleared": "漏水解除",
      "occupied": "有人",
      "unoccupied": "無人",
      "ai_detected": "AI {{what}}"
    },
    "lens_chip_a11y": "{{name}}的事件"
  },
  "playback": {
    "recording_sd": "記憶卡",
    "day": "日期",
    "pick_time": "拖曳或點下方時間軸選擇要回放的時間",
    "timeline": "錄影時間軸",
    "type_continuous": "連續",
    "type_event": "事件",
    "no_recording_after": "這個時間之後沒有錄影",
    "tunnel_idle": "回放通道未開",
    "tunnel_opening": "建立回放通道…",
    "tunnel_open": "回放通道已連線",
    "tunnel_failed": "回放通道失敗",
    "tunnel_closed": "回放通道已關閉",
    "err_MAX_SESSIONS_REACHED": "設備同時連線已達上限（即時影像與回放共用），請先關閉其他畫面",
    "err_VIEWER_LIMIT": "設備同時連線已達上限（即時影像與回放共用），請先關閉其他畫面",
    "err_CHANNEL_OFFLINE": "通道離線",
    "err_HARDWARE_ERROR": "設備影像引擎錯誤；持續發生請重新啟動設備",
    "err_CODEC_UNSUPPORTED": "此通道編碼（H.265）瀏覽器無法播放，請將此通道子碼流改為 H.264",
    "err_INVALID_PAYLOAD": "無法建立連線（請求格式不符）",
    "err_TUNNEL_TIMEOUT": "回放通道逾時",
    "unified": "時間軸",
    "all_sources": "檢視全部來源",
    "src_cloud": "雲端",
    "src_nvr": "NVR 硬碟",
    "src_sd": "SD 卡",
    "src_edge": "ONVIF edge",
    "src_backup": "異地備份",
    "gap": "缺口",
    "gap_offline": "設備離線",
    "gap_retention": "超出保留期",
    "gap_unknown": "來源未知（設備連不上）",
    "gap_not_recorded": "無錄影",
    "gaps_title_one": "{{count}} 個缺口",
    "gaps_title_other": "{{count}} 個缺口",
    "summary": "{{spans}} 段錄影、{{gaps}} 個缺口",
    "source_changed": "來源切換：{{from}} → {{to}}。",
    "end_of_day": "這天之後沒有更多錄影",
    "zoom_in": "放大",
    "zoom_out": "縮小",
    "pan_back": "往前",
    "pan_forward": "往後",
    "zoom_span": "視窗 {{span}}",
    "hours": "{{n}} 小時",
    "minutes": "{{n}} 分鐘",
    "dst_day": "日光節約日（{{h}} 小時）",
    "err_no_recording_after": "這個時間之後沒有錄影",
    "err_TUNNEL_NOT_READY": "回放通道還沒連上，稍候再試",
    "err_TUNNEL_FAILED": "回放通道失敗，設備本地錄影暫時看不到",
    "tz": "時區",
    "tz_site": "場域時區",
    "tz_browser": "瀏覽器時區",
    "src_node": "電腦端",
    "src_phone": "手機本機",
    "gap_paused": "暫停：{{reason}}",
    "unknown_node_offline": "未知（電腦目前離線）",
    "unknown_node_pending": "未知（電腦還沒回報）",
    "unknown_phone_offline": "未知（手機目前離線）",
    "err_NODE_PLAYBACK_UNAVAILABLE": "電腦端的錄影回放尚未提供（這段有錄影，在電腦端）",
    "pause_app_background": "App 在背景",
    "pause_killed": "App 被關閉",
    "pause_updating": "更新中",
    "pause_schedule": "排程",
    "pause_home_mode": "主人在家",
    "pause_thermal": "過熱",
    "pause_battery_low": "電量低",
    "pause_storage_full": "空間已滿",
    "pause_camera_busy": "攝影機被占用",
    "pause_permission": "缺少攝影機權限",
    "pause_local_network_denied": "缺少本地網路權限",
    "pause_mic_denied": "缺少麥克風權限",
    "pause_plan_limit": "超過方案台數",
    "pause_in_pocket": "手機被收起",
    "pause_user": "手動暫停",
    "pause_source_unreachable": "電腦連不到攝影機",
    "pause_not_recorded": "依錄影方式不錄",
    "prev_month": "上個月",
    "next_month": "下個月",
    "day_has_rec": "{{day}}（有錄影）",
    "day_legend": "有底色的日子有錄影（雲端或設備本機）",
    "event_density": "事件密度",
    "events_n_one": "{{count}} 則事件",
    "events_n_other": "{{count}} 則事件",
    "speed": "速度",
    "frame_back": "上一格",
    "frame_fwd": "下一格",
    "timeline_aria": "回放時間軸（拖曳捲動、滾輪縮放；← / → 移動、Shift + ← / → 上下一個事件、空白鍵播放 / 暫停）",
    "seam": "已折疊 {{d}} 沒有事件的時段",
    "dur_hm": "{{h}} 小時 {{m}} 分",
    "only_events": "只看有事件的時段",
    "no_events_day": "這天沒有事件",
    "end_of_events": "這天之後沒有更多事件",
    "group_person": "人",
    "group_vehicle": "車",
    "group_animal": "動物",
    "group_package": "包裹",
    "group_sound": "聲音",
    "group_sensor": "感測器",
    "group_alarm": "警報",
    "group_motion": "移動",
    "skipped_from": "{{gaps}}，已從 {{at}} 開始播。",
    "err_local_unreachable": "讀不到 {{name}} 的 {{src}}錄影（設備沒有回應）。",
    "err_source_unreachable": "讀不到這段錄影（{{src}}）。請稍後重試。",
    "err_decode": "瀏覽器播不了這段錄影（格式不支援或檔案損壞）。",
    "err_generic": "這段錄影播不出來。請稍後重試。",
    "err_detail": "詳細",
    "no_sources": "這台攝影機沒有任何錄影來源：沒有 SD 卡或錄影主機，雲端錄影也沒有開。",
    "no_recording_unreachable": "這一天沒有讀到錄影：有來源連不上（設備離線或沒回應），可能還有錄影沒顯示出來。",
    "no_recording_day": "這一天沒有任何來源的錄影。可能原因：",
    "go_last_day": "看最近有錄影的一天（{{day}}）",
    "err_overlay": "這段播不出來（原因在下方）",
    "err_local_offline": "{{name}} 離線，讀不到它的本地錄影。",
    "err_cloud_unreachable": "雲端錄影暫時讀不到，請稍後再試。",
    "err_no_cloud": "這台沒有雲端錄影。",
    "err_forbidden": "你沒有這台的回放權限。",
    "try_cloud": "改看雲端錄影",
    "try_source": "改看{{src}}",
    "go_nearest": "跳到最近的錄影",
    "buy_seats": "購買席次",
    "gap_none_span": "{{from}}–{{to}} 沒有錄影",
    "why_overwritten": "{{src}}已循環覆寫（舊的錄影會被新的蓋掉）",
    "why_no_cloud": "沒有開雲端錄影",
    "why_schedule": "錄影排程沒有涵蓋這段時間",
    "why_offline": "{{name}} 這段時間離線",
    "no_rec_events_one": "這天有 {{count}} 筆事件，但沒有錄影可以播。",
    "no_rec_events_other": "這天有 {{count}} 筆事件，但沒有錄影可以播。",
    "from_event": "從事件：{{name}} · {{cam}} · {{at}}",
    "from_event_generic": "事件",
    "from_event_dismiss": "拿掉這個標示",
    "drag_hint": "拖曳時間軸換時間，中間的線就是播放位置；點一下直接跳過去。",
    "hint_ok": "知道了",
    "settings": "時間軸設定（時區、圖例、只看有事件的時段、檢視全部來源）",
    "modes": "回放模式",
    "mode_single": "單路",
    "day_no_rec": "這天沒有錄影",
    "why_local_unreachable": "{{name}} 的 {{src}}錄影目前讀不到（設備沒有回應）。",
    "why_local_offline": "{{name}} 離線，讀不到它的 {{src}}錄影。",
    "why_cloud_no_clip": "{{name}} 在這段時間沒有雲端片段（雲端只存事件片段）。",
    "why_cloud_retention": "這段已超過雲端保存期限（{{n}} 天）。",
    "why_local_empty": "{{src}}在這段時間也沒有錄影（可能已循環覆寫，或排程沒錄這段）。",
    "retry_local": "重試讀 {{src}}",
    "seek_no_rec": "{{at}} 沒有錄影，從 {{from}} 開始播。",
    "fallback": "讀不到 {{dev}} 的 {{src}}，改播{{to}}的錄影（{{at}} 起）。",
    "cam_not_found": "找不到這台攝影機（可能已移除，或你沒有回放權限）。請在左邊或上方選一台。",
    "pick_camera": "選一台攝影機…",
    "slow": "{{src}}的錄影載入很久，還沒有畫面。",
    "slow_fallback": "{{src}}的錄影 {{sec}} 秒還沒有畫面，已改看{{to}}（{{at}} 起）。",
    "avoid_broken": "{{dev}} 的 {{src}}剛才讀不到，先播{{to}}（{{at}} 起）。",
    "src_missing": "這台在這段時間沒有{{src}}的錄影，改用其他來源。",
    "back_to": "改回{{src}}",
    "src_pinned": "你選的來源：換攝影機也會沿用",
    "src_auto_hint": "自動選的來源（最近播得出來的優先）",
    "src_auto": "改回自動選來源",
    "play": "▶ 播放",
    "pause": "⏸ 暫停",
    "sound_on": "🔇 開聲音",
    "sound_off": "🔊 關聲音",
    "fullscreen": "⛶ 全螢幕",
    "cloud_suspect": "這段雲端片段可能不完整（片段長度不合理），畫面可能是綠色或停住。",
    "cloud_suspect_switched": "這段雲端片段可能不完整（片段長度不合理），已改看{{to}}（{{at}} 起）。",
    "events_n_more": "超過 {{count}} 則事件（只標了前 {{count}} 則）",
    "slow_tier_hint": "網路不夠快，回放會斷斷續續。建議把錄影畫質改成標準（只影響之後的錄影）。",
    "slow_tier_switch": "改成標準",
    "slow_tier_never": "不再提示",
    "slow_tier_close": "關閉",
    "slow_tier_done": "已改成標準。之後的錄影會用標準畫質，已錄的照舊。",
    "slow_tier_sent": "已送出，攝影機連上後會改成標準。",
    "slow_tier_hint_no_write": "網路不夠快，回放會斷斷續續。有這台設定權限的人可以把錄影畫質改成標準。",
    "slow_tier_failed": "沒改成，請到設備的「錄影與儲存」分頁 › 錄影畫質再試一次。",
    "err_local_host_limit": "{{name}} 的錄影主機同時最多 {{n}} 路本地回放，這一路沒有載入；可以改看單路。"
  },
  "map": {
    "plans": "平面圖",
    "upload": "上傳平面圖",
    "place_devices": "擺放設備",
    "pick_device": "先點選設備，再點平面圖放下",
    "click_to_place": "點平面圖上的位置放下",
    "done": "完成",
    "edit": "編輯擺放",
    "delete": "刪除平面圖",
    "confirm_delete": "刪除平面圖「{{name}}」？",
    "no_map_key": "地圖需要品牌方申請的 Google / 百度 key（brands/<Brand>/vms/vms.yaml maps.*）。平面圖模式不受影響。",
    "empty": "還沒有平面圖。上傳樓層圖（PNG / JPG / SVG / WebP，20 MB 內）後把攝影機與感測器擺上去。",
    "rotate_left": "向左轉 15°",
    "rotate_right": "向右轉 15°",
    "remove": "移除",
    "load_demo": "載入範例平面圖（自動擺放）",
    "demo_name": "範例 1F",
    "owner": "上傳到",
    "conflict": "資料已被別人改過，已重新讀取，請再操作一次",
    "empty_readonly": "還沒有平面圖；$t(leaf.cur)擁有者 / 管理員 或組織管理員可以上傳。",
    "mode_map": "地圖",
    "mode_plan": "平面圖",
    "load_failed": "地圖載入失敗：{{err}}",
    "fallback": "{{from}} 載入失敗，已改用 {{to}}",
    "provider": "地圖",
    "provider_google": "Google",
    "provider_baidu": "百度",
    "provider_dev": "開發用底圖",
    "dev_basemap": "開發環境：品牌還沒有 Google / 百度地圖金鑰，先用開發用底圖（正式環境不會出現）。",
    "health_ok": "正常",
    "health_warn": "有設備離線",
    "health_alarm": "警報中",
    "sites": "場域",
    "set_location": "在地圖上點選位置",
    "click_map_home": "點地圖設定這個場域的位置",
    "click_map_to_place": "點地圖放下（再點一次設備可以移動）",
    "overlays": "平面圖疊圖",
    "align": "對齊",
    "opacity": "透明度",
    "heading": "朝向",
    "fov": "視角",
    "range": "距離",
    "move": "移動",
    "align_title": "對齊「{{name}}」",
    "align_help": "在平面圖上點一個點，再到地圖上點同一個位置；2 點 = 平移旋轉縮放，3 點 = 可修正變形。",
    "align_click_img": "點平面圖上的第 {{n}} 點",
    "align_click_map": "到地圖上點第 {{n}} 點的實際位置",
    "align_save": "套用（{{n}} 點）",
    "align_reset": "重來",
    "align_clear": "取消疊圖",
    "align_bad": "控制點不能重疊或共線",
    "align_ready": "3 點都選好了，按「套用」",
    "timezone": "時區",
    "timezone_unset": "時區（未設，用瀏覽器）",
    "events_recent": "最近事件（{{n}}）",
    "events_results": "搜尋結果（{{n}}）",
    "events_clear": "清除搜尋結果",
    "events_title": "事件",
    "events_none": "沒有事件",
    "events_playback": "回放這一段",
    "events_help": "有事件的設備在圖上閃爍；點一筆會標出那台設備。只有已經擺到圖上的設備看得到位置。",
    "search_placeholder": "搜尋地址或地名",
    "search": "搜尋",
    "search_none": "找不到這個地址",
    "search_busy": "地址搜尋太頻繁，稍後再試",
    "search_attrib": "開發用地址搜尋：© OpenStreetMap 貢獻者（Nominatim）",
    "tiles_failed": "地圖底圖暫時載入不了。",
    "use_plan": "改用平面圖",
    "alarms_only": "只看警報",
    "unplaced_devices_one": "還沒放到地圖上的設備（{{count}}）· {{home}}",
    "unplaced_devices_other": "還沒放到地圖上的設備（{{count}}）· {{home}}",
    "placed_devices_one": "已放上地圖（{{count}}）",
    "placed_devices_other": "已放上地圖（{{count}}）",
    "all_placed": "這個場域的設備都放上地圖了。",
    "timezone_change": "改",
    "timezone_edit": "改時區",
    "site_health_alarm": "紅：這裡有設備正在警報",
    "site_health_warn": "黃：這裡有設備離線",
    "site_health_ok": "綠：這裡的設備都正常",
    "location_set": "位置：已設定",
    "location_unset": "位置：未設定",
    "location_pick": "設定",
    "location_move": "移動",
    "timezone_label": "時區：{{tz}}",
    "timezone_unset_short": "未設（用瀏覽器）",
    "unplaced_devices_ch": "還沒放到地圖上的設備（{{count}}，含 {{ch}} 個通道）· {{home}}"
  },
  "mfa": {
    "title": "兩步驟驗證",
    "code_body": "開啟驗證 App（Google Authenticator、Microsoft Authenticator 等），輸入 6 位數驗證碼。",
    "code": "驗證碼",
    "recovery_hint": "手機不在身邊？輸入一組備援碼（xxxx-xxxx）。",
    "verify": "驗證",
    "enroll_title": "設定兩步驟驗證",
    "enroll_body": "用驗證 App 掃描 QR code，再輸入 App 顯示的 6 位數驗證碼。",
    "first_code": "App 顯示的驗證碼",
    "enable": "啟用兩步驟驗證",
    "recovery_title": "備援碼",
    "saved_continue": "我已妥善保存，繼續",
    "qr_alt": "驗證 App 設定 QR code",
    "manual_entry": "無法掃描？手動輸入金鑰：",
    "recovery_notice": "每組備援碼只能用一次。請存放在安全的地方（密碼管理器或紙本），這是遺失手機時唯一的登入方式，之後不會再顯示。",
    "copy_codes": "複製全部",
    "section": "兩步驟驗證",
    "enabled": "已啟用",
    "disabled": "未啟用",
    "required_policy": "你參加的組織要求兩步驟驗證",
    "recovery_remaining": "剩 {{n}} 組備援碼",
    "regenerate": "重新產生備援碼",
    "regenerate_body": "舊的備援碼會全部作廢。請輸入目前的驗證碼。",
    "disable": "停用兩步驟驗證",
    "disable_body": "停用後只靠密碼登入。請輸入密碼與目前的驗證碼。",
    "err_MFA_CODE_INVALID": "驗證碼錯誤或已使用過",
    "err_MFA_TOKEN_INVALID": "驗證逾時，請重新輸入密碼",
    "err_RATE_LIMITED": "嘗試太多次，請稍後再試",
    "err_INVALID_CREDENTIALS": "密碼錯誤",
    "err_MFA_REQUIRED": "請輸入驗證碼",
    "err_MFA_ALREADY_ENABLED": "兩步驟驗證已啟用",
    "err_MFA_NOT_SETUP": "尚未設定兩步驟驗證",
    "err_MFA_REQUIRED_BY_POLICY": "你參加的組織要求兩步驟驗證：至少要保留一種（TOTP 或 passkey）",
    "err_SESSION_UNKNOWN": "登入狀態已更新，請再試一次",
    "err_NETWORK": "無法連線，請檢查網路",
    "err_IDENTITY_UNAVAILABLE": "帳號服務暫時無法連線",
    "err_default": "驗證失敗（{{code}}）"
  },
  "stepup": {
    "title": "重新驗證身分",
    "body": "這是敏感操作（授權、停用成員等），請在 5 分鐘內重新驗證。",
    "code_hint": "有開兩步驟驗證：打開驗證 App（Google Authenticator 等），輸入 Kinio 那一筆現在的 6 位數。沒開就留空，只填密碼。",
    "submit": "驗證並繼續",
    "code": "兩步驟驗證碼",
    "code_optional": "兩步驟驗證碼（有開才要填）",
    "code_hint_on": "打開驗證 App（Google Authenticator、Microsoft Authenticator 等），輸入 Kinio 那一筆現在的 6 位數；手機不在身邊可以輸入一組備援碼（xxxx-xxxx）。"
  },
  "settings": {
    "security": "安全性",
    "org": "組織",
    "notifications": "通知"
  },
  "activate": {
    "title": "接受邀請",
    "bad_link": "邀請連結不完整或已失效，請向邀請你的人索取新的邀請。",
    "done": "帳號 {{email}} 已建立並加入。請回登入頁登入。",
    "to_login": "前往登入",
    "body": "你被邀請加入一個組織（或有人分享設備給你）。已經有帳號就直接登入；還沒有就用這個邀請註冊（email 是受邀的那個，不能改）。",
    "display_name": "顯示名稱（選填）",
    "password_hint": "至少 8 個字元，避免常見密碼。",
    "password_again": "再輸入一次密碼",
    "mismatch": "兩次輸入的密碼不一樣",
    "submit": "註冊並加入",
    "err_INVITE_GONE": "邀請已失效或已使用，請管理員重新邀請",
    "err_ACCOUNT_EXISTS": "這個 email 已有帳號，請直接登入",
    "err_WEAK_PASSWORD": "密碼太短或太常見",
    "err_INVITE_EMAIL_MISMATCH": "邀請的 email 跟你登入的帳號不同",
    "err_default": "啟用失敗（{{code}}）",
    "have_account": "我已經有帳號，登入",
    "no_account": "我還沒有帳號，註冊",
    "register_body": "設定密碼後就會建立帳號並加入。這個帳號也能登入品牌 App。",
    "done_existing": "這個 email 已經有帳號，已直接加入。請用原本的密碼登入。",
    "done_share": "分享已生效，設備會出現在「別人分享給我」。",
    "err_INVITE_EMAIL_MISMATCH_masked": "這個邀請是給 {{email}} 的，請改用那個帳號登入。",
    "err_ALREADY_MEMBER": "你已經是這個組織的成員",
    "err_ORG_SUSPENDED": "這個組織已被停用，不能加入",
    "err_EMAIL_NOT_VERIFIED": "先驗證你的 email，才能接受邀請。",
    "org": "組織",
    "invited_by": "邀請人",
    "invited_email": "受邀 email",
    "expires": "到期",
    "already_member": "你已經是這個組織的成員（{{role}}）。",
    "accept": "接受並加入",
    "joined": "已加入「{{name}}」。組織的設備會出現在「組織授權給我」。",
    "joined_short": "已接受邀請。",
    "switch_account": "登出，換帳號",
    "to_devices": "前往設備",
    "joined_org": "已加入「{{name}}」。"
  },
  "org": {
    "err_default": "操作失敗（{{code}}）",
    "err_VERSION_CONFLICT": "資料已被別人更新，請重新整理後再試",
    "err_REAUTH_REQUIRED": "需要重新驗證身分才能執行",
    "err_SITE_CYCLE": "不能把場域搬到自己底下",
    "err_CROSS_TREE": "場域不在同一棵樹",
    "err_SITE_ARCHIVED": "場域已封存",
    "err_OUT_OF_ANCHOR": "設備不在這個場域範圍內",
    "err_OUT_OF_SITE": "指定的設備不在授權場域內",
    "err_SITE_NOT_RELATED": "授權的場域要是這個$t(leaf.cur)所在場域的上層或下層",
    "err_EMPTY_SCOPE": "範圍內沒有任何設備",
    "err_GRANT_TOO_LONG": "授權最長 90 天",
    "err_NOT_ACTIVE_ORG_MEMBER": "對象不是這個組織在職的成員",
    "err_ROLE_NOT_GRANT": "這個角色不是資料授權角色",
    "err_NO_ACTIONS": "至少選一個動作",
    "err_BAD_SITE": "場域資料不正確（名稱 1–64 字）",
    "err_BAD_TIMEZONE": "時區格式不正確（例如 Asia/Taipei）",
    "err_ALREADY_MEMBER": "對方已經是成員",
    "err_TOO_MANY_INVITES": "待接受的邀請太多，請先撤銷不用的",
    "err_LAST_ORG_ADMIN": "至少要保留一位組織管理員",
    "err_SELF": "不能停用自己",
    "err_LIMIT": "已達上限",
    "err_ORG_LIMIT": "每人最多建立 5 個組織（你的家不算）",
    "err_FORBIDDEN": "沒有權限",
    "err_NOT_FOUND": "找不到資料",
    "err_NETWORK": "無法連線，請檢查網路",
    "no_site_permission": "你沒有管理這個組織場域的權限，請洽組織管理員。",
    "create_title": "建立組織",
    "create_body": "公司、店、社區、保全、安裝商都可以建組織：有自己的場域樹、成員、角色與安全政策。你是擁有者。每人最多建 5 個（你的家不算）。",
    "name": "組織名稱",
    "create": "建立",
    "sites_title": "{{name}} 的場域",
    "add_root_site": "新增場域",
    "revoked_grants": "已撤銷 {{n}} 筆受影響的授權",
    "no_sites": "還沒有場域。先新增總部或第一個據點。",
    "kind_site": "據點",
    "kind_building": "建築",
    "kind_floor": "樓層",
    "kind_zone": "區域",
    "archived": "已封存",
    "add_child": "新增子場域",
    "add_home": "新增$t(leaf.cur)",
    "archive": "封存",
    "restore": "恢復",
    "home": "$t(leaf.cur)",
    "add_child_of": "在「{{name}}」底下新增",
    "edit_site": "編輯「{{name}}」",
    "add_home_at": "在「{{name}}」新增$t(leaf.cur)",
    "home_body": "$t(leaf.cur)是設備實際所在的空間（例如「我家」「A 棟監控」）。設備配對進這個$t(leaf.cur)後，就能依角色與授權使用。",
    "home_name": "$t(leaf.cur)名稱",
    "kind": "類型",
    "site_name": "名稱",
    "timezone": "時區",
    "parent": "上層場域",
    "parent_root": "（最上層）",
    "move_warning": "搬移會撤銷不再涵蓋的授權。",
    "pick": "組織",
    "err_OWNS_HOMES": "他還是$t(leaf.cur)的管理人，請先交接",
    "err_HOME_UNASSIGNED": "這個$t(leaf.cur)目前無人管理，請組織管理員先接管",
    "err_NOT_OWNER": "交接要由現任管理人發起",
    "err_REASON_REQUIRED": "請填寫理由",
    "err_IDEMPOTENCY_KEY_REQUIRED": "請重新整理後再試",
    "err_HOME_NOT_FOUND": "找不到這個$t(leaf.cur)",
    "err_WOULD_LOCK_OUT": "儲存後你會被擋在外面（目前的 IP 不在清單內，或這次登入沒有兩步驟驗證）",
    "err_BAD_CIDR": "IP / CIDR 格式不正確",
    "err_IP_NOT_ALLOWED": "組織的安全政策不允許從這個網路存取",
    "err_BAD_SCHEDULE": "時段設定不正確",
    "my_orgs": "我的組織",
    "my_orgs_hint": "每個帳號都有自己的家（個人組織，不能離開或刪除）；也可以另建組織（公司、店、社區…），或被邀請加入別的組織。各組織彼此看不到。",
    "kind_col": "種類",
    "kind_personal": "個人",
    "kind_team": "團體",
    "personal_badge": "我的家",
    "requires_mfa": "要求兩步驟驗證",
    "manage": "管理",
    "leave": "離開",
    "leave_confirm": "離開「{{name}}」？",
    "leave_body": "只會失去這個組織給你的權限；你自己的家、其他組織與別人分享給你的都不受影響。之後要回來得再被邀請。",
    "created": "已建立「{{name}}」，你是擁有者。",
    "personal_hint": "這是你的家（個人組織）：在這裡新增$t(leaf.cur)與場域、邀請家人。不能離開、轉移或刪除，跟著帳號。",
    "team_hint": "團體組織：組織角色只管組織事務；看影像要有$t(leaf.cur)角色或場域授權。",
    "member_count_one": "{{count}} 位成員",
    "member_count_other": "{{count}} 位成員",
    "owner_transfer": "轉移擁有權",
    "owner_transfer_of": "轉移「{{name}}」的擁有權",
    "owner_transfer_hint": "新擁有者要是在職的管理員；你會變成管理員。會通知雙方與其他管理員。",
    "new_owner": "新擁有者",
    "no_admins": "還沒有其他管理員：先在成員分頁把要接手的人設為管理員。",
    "owner_transfer_done": "擁有權已轉移。",
    "delete": "刪除組織",
    "delete_confirm": "刪除「{{name}}」？",
    "delete_body": "成員會全部離開、分享給這個組織的分享會結束。組織還有$t(leaf.cur)時不能刪，要先刪除或移走$t(leaf.cur)。這個動作不能復原。",
    "err_ORG_NOT_EMPTY": "組織還有$t(leaf.cur)，先刪除或移走這些$t(leaf.cur)：",
    "err_INVALID_NAME": "組織名稱要 2–60 字",
    "err_OWNER_REQUIRED": "只有擁有者能做這件事",
    "err_OWNER_CANNOT_LEAVE": "擁有者不能離開：你的家跟著帳號；團體組織請先轉移擁有權",
    "err_OWNER_ROLE": "擁有者的角色只能用轉移擁有權改",
    "err_PERSONAL_ORG": "你的家（個人組織）不能轉移或刪除",
    "err_TARGET_NOT_ORG_ADMIN": "對象要是這個組織在職的管理員",
    "err_NOT_AN_ORG_MEMBER": "對方已經不是這個組織的成員",
    "err_ORG_SUSPENDED": "這個組織已被停用，不能做任何變更",
    "err_ORG_MFA_REQUIRED": "這個組織要求兩步驟驗證：開啟後重新登入",
    "err_ORG_NOT_FOUND": "找不到這個組織",
    "err_DEV_HOME_NOT_ALLOWED": "在這個環境建組織或$t(leaf.cur)要先開放",
    "err_TEST_IDENTITY_REQUIRED": "在這個環境只有測試帳號能建組織或$t(leaf.cur)",
    "err_FEATURE_DISABLED": "這個環境不提供這項功能",
    "err_BAD_EMAIL": "email 格式不正確",
    "err_BAD_ROLE": "這個角色不能用在這裡",
    "err_INVALID_ROLE": "這個角色不能用在這個組織",
    "err_INVITE_GONE": "邀請已失效或已使用",
    "err_SHARE_EXISTS": "已經有一筆同樣用途的分享，請在原本那筆調整",
    "err_SHARE_NOT_FOUND": "找不到這筆分享",
    "err_SHARE_SCOPE_EXCEEDED": "超過分享的範圍",
    "err_GRANT_EXCEEDS_ROLE": "不能分享你自己沒有的權限",
    "err_INVALID_SCOPE": "勾選的權限不能用在這裡",
    "err_INVALID_GRANTEE": "分享對象不正確",
    "err_SCOPE_EXPAND": "只能縮小，要擴大請重新分享",
    "err_TOO_LONG": "期限超過這種用途的上限",
    "err_REQUEST_GONE": "分享請求已失效或已使用",
    "err_ORG_NOT_VERIFIED": "這個組織還沒通過這種用途的審核",
    "err_NOT_A_RENEWAL": "這個代碼不是續約請求",
    "err_NOT_INSTALL": "只有安裝分享能完成安裝",
    "err_EMAIL_EXISTS": "這個 email 已有帳號",
    "err_BAD_TARGET": "選的設備不在這個$t(leaf.cur)",
    "err_BAD_POLICY": "政策設定不正確",
    "err_SITE_NOT_FOUND": "找不到這個場域",
    "rename": "改名",
    "rename_of": "改「{{name}}」的名稱",
    "err_USE_ORG_API": "請改成離開組織",
    "err_USER_NOT_FOUND": "對方要先是這個組織的成員",
    "err_UNAVAILABLE": "暫時無法使用，稍後再試",
    "err_NOT_ORG_HOME": "$t(leaf.cur)不在選的節點底下",
    "err_IDEMPOTENCY_CONFLICT": "同一個請求的內容變了，請關掉對話框重來",
    "err_IDEMPOTENCY_IN_PROGRESS": "上一個請求還在處理，稍後再試",
    "err_RATE_LIMITED": "太頻繁了，請稍後再試",
    "err_CLAIM_NOT_FOUND": "序號或訂單號對不上",
    "levels_hint": "結構樹上每一層的名字（例：區域 › 據點 › 樓層 › 戶），也用在路徑與報表。",
    "err_SHARE_KIND_NOT_ALLOWED": "Kinio Node 與 Wi-Fi 基地台不能分享（沒有影像或資料可以交給對方），請拿掉這兩種設備再送出。"
  },
  "people": {
    "members": "成員",
    "grants": "授權",
    "roles": "角色",
    "home_members": "$t(leaf.cur)成員",
    "members_of": "{{name}} 的成員",
    "invite": "邀請成員",
    "members_hint": "成員能看到的設備由$t(leaf.cur)角色與場域授權決定（組織角色只管組織事務）；停用或移出的成員 30 秒內會被中斷即時影像與回放。",
    "name": "人員",
    "role": "角色",
    "status": "狀態",
    "org_perms": "組織權限",
    "joined": "加入時間",
    "all_perms": "全部",
    "edit_perms": "權限",
    "suspend": "停用",
    "reactivate": "恢復",
    "pending_invites": "待接受的邀請",
    "expires": "{{date}} 到期",
    "revoke_invite": "撤銷",
    "org_role_org_admin": "管理員",
    "org_role_developer": "開發者",
    "status_active": "正常",
    "status_suspended": "已停用",
    "status_left": "已離開",
    "edit_perms_of": "{{name}} 的組織權限",
    "perms_hint": "組織權限不含看影像；看影像要另外在「存取權」給。",
    "perm_org_sites": "場域與人員",
    "perm_org_sites_desc": "管理場域樹、$t(leaf.cur)、授權",
    "perm_org_audit": "稽核",
    "perm_org_audit_desc": "查看稽核日誌",
    "perm_org_billing": "帳單",
    "perm_org_billing_desc": "方案、付款與用量",
    "invite_link_body": "{{email}} 還沒有帳號，已寄出邀請信。也可以把這個連結直接交給對方（7 天內有效）：",
    "invite_body": "一律用 email 邀請：對方已經有帳號就直接加入、會收到通知；還沒有帳號就寄邀請信，用邀請註冊後加入（7 天內有效）。",
    "invite_role_hint": "「成員」本身沒有任何設備權限，要在「存取權」分頁〔＋ 給存取權〕另外給；只有擁有者能邀請管理員。",
    "send_invite": "送出邀請",
    "filter_user": "篩選人員",
    "all_users": "全部人員",
    "show_revoked": "顯示已撤銷",
    "assign": "指派授權",
    "grants_hint": "授權 = 人 × 場域 × 設備範圍 × 期限。場域搬移或設備換位置後，需按「刷新」重新展開目標。",
    "no_grants": "還沒有授權。",
    "site": "場域",
    "home": "$t(leaf.cur)",
    "scope": "設備範圍",
    "expires_col": "到期",
    "incl_desc": "（含子場域）",
    "scope_all": "場域內全部",
    "scope_list": "指定 {{n}} 台",
    "targets": "{{n}} 個目標",
    "grant_active": "有效",
    "grant_expired": "已到期",
    "grant_revoked": "已撤銷",
    "refresh": "刷新",
    "refresh_hint": "依目前的場域與設備位置重新展開目標（可延長期限）",
    "revoke": "撤銷",
    "revoke_confirm": "確定撤銷？對方 30 秒內會失去這些設備的存取。",
    "assigned": "已授權，展開為 {{n}} 個設備目標：",
    "include_descendants": "包含子場域",
    "no_related_homes": "這個場域的上下層沒有$t(leaf.cur)",
    "custom_actions": "自訂動作…",
    "actions": "動作",
    "scope_all_desc": "場域內全部設備（之後新增的要刷新）",
    "scope_list_desc": "只限指定設備",
    "devices": "設備清單",
    "days": "有效天數",
    "days_hint": "最長 90 天，到期前可刷新延長。",
    "stepup_note": "送出時可能要求重新驗證身分。",
    "new_role": "新增角色",
    "role_kind": "類型",
    "kind_grant": "資料授權",
    "kind_home_admin": "$t(leaf.cur)管理",
    "kind_org_admin": "組織管理",
    "kind_org_permission": "組織權限",
    "system": "系統",
    "pending_apply": "新增的動作不會自動套用到既有授權：有 {{n}} 筆授權待套用，按〔套用〕才生效。",
    "pending_chip": "{{n}} 筆待套用",
    "apply": "套用",
    "apply_title": "套用到既有授權",
    "apply_confirm": "把「{{role}}」目前的動作套用到 {{n}} 筆還沒更新的授權？各授權另外勾選的動作會保留。",
    "applied": "已套用到 {{n}} 筆授權。",
    "edit_role": "編輯角色",
    "role_name": "角色名稱",
    "role_desc": "說明",
    "role_edit_note": "拿掉動作會立刻縮減所有使用這個角色的授權；加入的動作要按〔套用〕才會加到既有授權。",
    "home_members_hint": "$t(leaf.cur)角色只給本組織的成員；家人要先加入你的家（成員分頁）。這裡列出你看得到的成員。",
    "members_hidden": "你透過組織授權存取這個$t(leaf.cur)，看不到成員名單。",
    "hrole_owner": "擁有者",
    "hrole_admin": "管理員",
    "hrole_member": "成員",
    "hrole_guest": "訪客",
    "hrole_undefined": "授權",
    "access": "權限來源",
    "access_of": "{{name}} 的權限來源",
    "src_org": "組織",
    "src_homes": "$t(leaf.cur)角色",
    "src_grants": "場域授權（{{n}} 筆有效）",
    "src_note": "組織角色本身不帶影像權；看影像要有$t(leaf.cur)角色或場域授權。",
    "owns_homes": "他還是以下$t(leaf.cur)的管理人，請先到「組織與場域」交接；確定沒有接任者才設為無人管理：",
    "unassign_owned": "沒有接任者，這些$t(leaf.cur)改為「無人管理」（之後只能由組織管理員接管）",
    "left_done": "已移出：撤銷 {{grants}} 筆授權、移除 {{homes}} 個$t(leaf.cur)角色、{{unassigned}} 個$t(leaf.cur)改為無人管理。",
    "schedule": "時段限制",
    "schedule_on": "只在指定時段有效（場域時區 {{tz}}）",
    "dow_1": "一",
    "dow_2": "二",
    "dow_3": "三",
    "dow_4": "四",
    "dow_5": "五",
    "dow_6": "六",
    "dow_7": "日",
    "from": "開始",
    "to": "結束",
    "duty_mode": "值班操作台帳號",
    "duty_mode_desc": "閒置不登出、每 12 小時重新登入、不能匯出錄影",
    "duty_badge": "值班",
    "org_role_owner": "擁有者",
    "org_role_member": "成員",
    "org_role_guest": "訪客",
    "org_role_factory_ops": "產線",
    "role_of": "{{name}} 的角色",
    "members_hint_personal": "加入你家的人（例如家人）：管理員看得到、也管得到全部$t(leaf.cur)；成員看得到全部$t(leaf.cur)；訪客預設看不到設備，逐台開放。",
    "invite_body_personal": "邀請家人加入你的家。對方已經有帳號就直接加入；沒有就寄邀請信（7 天內有效）。",
    "invite_role_hint_personal": "管理員看得到也管得到全部$t(leaf.cur)；成員看得到全部$t(leaf.cur)；訪客預設看不到設備。只有擁有者能邀請管理員。",
    "invite_joined": "{{email}} 已經有帳號，已直接加入並收到通知。",
    "invite_here": "在這個網站接受邀請的連結：",
    "perm_org_devices": "設備庫存",
    "perm_org_devices_desc": "看庫存、認領、預先指派與收編（不含看影像）",
    "remove": "移出",
    "remove_of": "移出 {{name}}",
    "remove_body": "只收回這個組織給他的權限（$t(leaf.cur)角色、場域授權、分享給本組織的設備）；他自己的家、其他組織、別人分享給他的都不受影響。30 秒內停止他在這個組織的即時影像。帳號本身保留（可再邀請）。",
    "invited_by": "{{name}} 邀請",
    "perm_org_support": "問題回報",
    "perm_org_support_desc": "回報問題、看本組織的回報（不含看影像）"
  },
  "roles": {
    "role-org-admin": "組織管理員",
    "role-org-admin_desc": "組織、場域樹、成員、帳單、稽核；看影像要另外授權",
    "role-site-admin": "場域管理員",
    "role-site-admin_desc": "範圍內$t(leaf.cur)的管理員：設備、授權、錄影政策",
    "role-operator": "操作員",
    "role-operator_desc": "即時、回放、對講、PTZ、警報器",
    "role-viewer": "觀看者",
    "role-viewer_desc": "即時與事件",
    "role-technician": "安裝技師",
    "role-technician_desc": "對焦調角度、設定；不看回放與事件歷史",
    "role-auditor": "稽核員",
    "role-auditor_desc": "稽核日誌"
  },
  "actions": {
    "device": {
      "read": "看設備",
      "control": "控制設備",
      "install": "安裝設備",
      "diagnose": "遠端偵測"
    },
    "media": {
      "live": "即時影像",
      "talk": "對講"
    },
    "recording": {
      "read": "回放",
      "export": "匯出錄影"
    },
    "event": {
      "read": "看事件"
    },
    "case": {
      "read": "看案件",
      "handle": "處理案件"
    },
    "alarm": {
      "receive": "收警報"
    },
    "security": {
      "arm": "遠端布防",
      "disarm": "遠端撤防"
    },
    "home": {
      "profile": {
        "read": "看$t(leaf.cur)資料"
      }
    },
    "install": {
      "complete": "完成安裝"
    }
  },
  "audit": {
    "pick_org": "選擇要查看的組織。",
    "action": "動作",
    "all_actions": "全部動作",
    "actor": "操作者",
    "all_actors": "全部操作者",
    "empty": "沒有符合的紀錄。",
    "system": "系統",
    "more": "載入更早的紀錄",
    "a_org_create": "建立組織",
    "a_site_create": "新增場域",
    "a_site_update": "修改場域",
    "a_home_create": "新增$t(leaf.cur)",
    "a_home_member_add": "指派$t(leaf.cur)成員",
    "a_device_location": "設備換位置",
    "a_grant_create": "指派授權",
    "a_grant_refresh": "刷新授權",
    "a_grant_revoke": "撤銷授權",
    "a_role_create": "新增角色",
    "a_role_update": "修改角色",
    "a_member_update": "修改成員",
    "a_member_join": "成員加入",
    "a_member_activate": "接受邀請加入",
    "a_member_leave": "成員離開",
    "a_home_owner_handover": "管理人交接",
    "a_home_owner_takeover": "受控接管",
    "a_home_unassigned": "$t(leaf.cur)改為無人管理",
    "a_org_security_policy": "修改安全政策",
    "a_member_service_roles": "設定服務角色",
    "a_member_duty_mode": "設定值班帳號",
    "a_billing_checkout": "開始購買",
    "a_billing_seat_assign": "指派席次",
    "a_billing_seat_unassign": "解除席次",
    "a_ai_consent_grant": "雲端 AI 同意",
    "a_ai_consent_exclusions": "雲端 AI 排除清單",
    "a_ai_consent_revoke": "撤回雲端 AI 同意",
    "a_ai_usage_threshold": "雲端 AI 額度提醒",
    "a_test_hook_billing_contract": "測試掛鉤：合約",
    "search": "搜尋動作、設備、內容、IP",
    "export_csv": "匯出 CSV（最近 30 天）",
    "export_failed": "匯出失敗，請稍後再試",
    "a_device_settings": "設備設定變更",
    "a_device_command": "設備命令",
    "a_member_invite": "邀請成員",
    "a_member_invite_revoke": "撤銷邀請",
    "a_member_role": "改組織角色",
    "a_member_remove": "移出成員",
    "a_org_owner_transfer": "轉移擁有權",
    "a_org_delete": "刪除組織",
    "a_share_create": "分享給個人",
    "a_share_request": "發分享請求",
    "a_share_request_cancel": "撤回分享請求",
    "a_share_accept": "同意分享給組織",
    "a_share_shrink": "縮小分享",
    "a_share_revoke": "撤銷分享",
    "a_share_end": "組織終止分享",
    "a_share_handover": "交屋",
    "a_share_grantee_removed": "對方移除分享",
    "range": "日期範圍",
    "r_today": "今天",
    "r_yesterday": "昨天",
    "r_7d": "過去 7 天",
    "r_custom": "自訂",
    "from": "開始日期",
    "to": "結束日期",
    "g_media": "影像存取",
    "g_control": "設備控制",
    "g_settings": "設定變更",
    "g_perms": "權限",
    "g_account": "帳號",
    "g_export": "匯出",
    "g_billing": "帳單",
    "g_other": "其他",
    "g_all": "全部{{group}}",
    "line": "{{who}} {{what}}",
    "line_target": "{{who}} {{what}}：{{target}}",
    "unknown_device": "一台設備",
    "unknown_user": "已離開的成員",
    "unknown_home": "一個$t(leaf.cur)",
    "unknown_node": "一個節點",
    "src_local": "本地錄影",
    "src_cloud": "雲端錄影",
    "f_device_ref": "設備",
    "f_device": "設備",
    "f_user_id": "對象",
    "f_target_user_id": "對象",
    "f_home_id": "$t(leaf.cur)",
    "f_node_id": "節點",
    "f_source": "來源",
    "f_reason": "理由",
    "f_keys": "改了哪些設定",
    "f_command": "命令",
    "f_path": "連線方式",
    "f_from": "播放起點",
    "f_ip": "IP",
    "tech": "技術細節（複製給客服）",
    "s_device_settings": "{{who}} 變更了 {{target}} 的設定",
    "s_device_command": "{{who}} 對 {{target}} 下了命令",
    "s_device_rpc": "{{who}} 對 {{target}} 下了命令",
    "s_device_control": "{{who}} 操作了 {{target}}",
    "s_device_location": "{{who}} 改了 {{target}} 的位置",
    "s_media_session_start": "{{who}} 開始看 {{target}} 的即時影像",
    "s_media_session_end": "{{who}} 結束看 {{target}} 的即時影像",
    "s_recording_playback": "{{who}} 看了 {{target}} 的{{src}}",
    "s_recording_download": "{{who}} 下載了 {{target}} 的錄影",
    "s_recording_delete": "{{who}} 刪除了 {{target}} 的錄影",
    "s_grant_create": "{{who}} 給 {{target}} 場域授權",
    "s_grant_refresh": "{{who}} 刷新了 {{target}} 的場域授權",
    "s_grant_revoke": "{{who}} 撤銷了 {{target}} 的場域授權",
    "s_member_invite": "{{who}} 邀請了新成員",
    "s_member_role": "{{who}} 改了 {{target}} 的組織角色",
    "s_member_remove": "{{who}} 把 {{target}} 移出組織",
    "s_member_update": "{{who}} 改了 {{target}} 的成員設定",
    "s_member_join": "{{target}} 加入組織",
    "s_node_assignment_create": "{{who}} 在 {{target}} 指派了人",
    "s_node_assignment_revoke": "{{who}} 撤銷了 {{target}} 的一筆指派",
    "s_node_assignment_update": "{{who}} 改了 {{target}} 的一筆指派",
    "s_node_block_inheritance": "{{who}} 改了 {{target}} 的中斷繼承",
    "s_audit_export": "{{who}} 匯出了稽核紀錄",
    "s_billing_seat_assign": "{{who}} 指派了雲錄席次",
    "a_device_rpc": "設備遠端呼叫",
    "a_media_session_start": "開始看即時影像",
    "a_media_session_end": "結束看即時影像",
    "a_recording_playback": "回放錄影",
    "a_recording_download": "下載錄影",
    "a_recording_delete": "刪除錄影",
    "a_recording_policy_update": "改錄影設定",
    "a_node_assignment_create": "節點指派",
    "a_node_assignment_update": "改節點指派",
    "a_node_assignment_revoke": "撤銷節點指派",
    "a_node_create": "新增節點",
    "a_node_update": "修改節點",
    "a_node_move": "搬移節點",
    "a_node_archive": "停用節點",
    "a_node_block_inheritance": "中斷繼承",
    "a_node_self_assign": "指派自己",
    "a_role_apply": "套用角色變更",
    "a_member_group_create": "新增成員群組",
    "a_member_group_update": "修改成員群組",
    "a_member_group_delete": "刪除成員群組",
    "a_audit_export": "匯出稽核",
    "a_org_rename": "改組織名稱",
    "a_org_tree_settings": "改層級名稱",
    "a_home_delete": "刪除$t(leaf.cur)",
    "a_home_move_node": "搬移$t(leaf.cur)",
    "line_generic_target": "{{who}} 對 {{target}} 做了一項操作",
    "line_generic": "{{who}} 做了一項操作",
    "times_one": "× {{count}} 次",
    "times_other": "× {{count}} 次",
    "see_all": "到稽核頁看全部",
    "only_device": "只看 {{name}}",
    "clear_device": "不限設備",
    "a_media_live": "看即時影像",
    "s_media_watched": "{{who}} 看了 {{target}} 的即時影像 {{dur}}",
    "dur_s": "{{s}} 秒",
    "dur_ms": "{{m}} 分 {{s}} 秒",
    "s_media_replayed": "{{who}} 看了 {{target}} 的本地錄影 {{dur}}",
    "paren": "（{{v}}）",
    "mode_write": "（可輸入）",
    "mode_read": "（唯讀）",
    "mac_tail": "MAC 尾碼 {{v}}",
    "fleet_cmd_other": "一個指令",
    "fleet_cmd_reboot": "重新開機",
    "fleet_cmd_identify": "閃燈找設備",
    "fleet_cmd_site_wifi_set": "設定場域 Wi-Fi",
    "fleet_cmd_wifi_set": "設定 Wi-Fi",
    "fleet_cmd_ttl_config": "設定 UART（TTL）",
    "fleet_cmd_ttl_open": "打開 UART（TTL）",
    "fleet_cmd_ttl_close": "關閉 UART（TTL）",
    "fleet_cmd_caps": "讀取能力",
    "fleet_cmd_ota_update": "更新韌體",
    "fleet_cmd_host_nodes": "列出接著的 Node",
    "fleet_cmd_host_power": "開關 Node 電源",
    "fleet_cmd_host_reset": "重設 Node",
    "fleet_cmd_host_ota": "更新 Node 韌體",
    "fleet_cmd_host_flash": "燒錄 Node",
    "fleet_cmd_host_wifi": "設定 Node Wi-Fi",
    "fleet_cmd_host_health": "讀取 Node 健康",
    "fleet_cmd_host_imeas": "量測電流",
    "org_status_active": "啟用",
    "org_status_suspended": "停權",
    "org_status_closed": "關閉",
    "s_recording_read": "{{who}} 查看了 {{target}} 的錄影清單",
    "s_fleet_console_ticket": "{{who}} 取得 {{target}} 的終端機連線{{mode}}",
    "s_fleet_console_open": "{{who}} 開了 {{target}} 的終端機{{mode}}",
    "s_fleet_console_close": "{{who}} 結束了 {{target}} 的終端機",
    "s_fleet_console_writer": "{{who}} 取得 {{target}} 終端機的輸入權",
    "s_fleet_command": "{{who}} 對 {{target}} 下指令「{{cmd}}」",
    "s_fleet_local_credential": "{{who}} 設定了 {{target}} 的本機登入密碼",
    "s_thing_update": "{{who}} 把 {{target}} 改名為「{{name}}」",
    "s_thing_update_plain": "{{who}} 修改了 {{target}}",
    "s_thing_assigned": "{{who}} 把 {{target}} 指派到 {{place}}",
    "s_thing_moved": "{{who}} 把 {{target}} 搬到 {{place}}",
    "s_thing_ttl_direct_token": "{{who}} 取得 {{target}} 的區網直連權杖",
    "s_thing_admin_credential_set": "{{who}} 設定了 {{target}} 的管理員密碼",
    "s_media_clip_fetch": "{{who}} 取了 {{target}} 的一段影片{{dur}}",
    "s_vms_ai_assign": "{{who}} 把 {{target}} 指派給 AI 主機 {{provider}}",
    "s_vms_ai_unassign": "{{who}} 取消了 {{target}} 的 AI 主機指派",
    "s_vms_alarm_state": "{{who}} 把 {{target}} 的警報標成「{{state}}」",
    "s_vms_device_links_put": "{{who}} 設定了 {{target}} 連動的攝影機（{{n}} 台）",
    "s_vms_floorplan_create": "{{who}} 新增了平面圖「{{name}}」",
    "s_vms_floorplan_delete": "{{who}} 刪除了平面圖「{{name}}」",
    "s_view_create": "{{who}} 新增了版面「{{name}}」",
    "s_view_delete": "{{who}} 刪除了版面「{{name}}」",
    "s_org_node_enroll_lookup": "{{who}} 查詢了一台 Kinio Node{{mac}}",
    "s_org_node_enroll_identify": "{{who}} 確認了一台 Kinio Node{{mac}}",
    "s_org_node_enroll_approve": "{{who}} 開通了一台 Kinio Node{{mac}}",
    "s_org_inventory_claim": "{{who}} 認領了庫存設備{{serial}}",
    "s_org_status": "{{who}} 把組織狀態改成「{{state}}」",
    "s_org_verification": "{{who}} 審核了組織的服務類別",
    "s_relationship_request": "{{who}} 申請了服務關係",
    "s_relationship_handover": "{{who}} 交接了服務關係",
    "s_service_client_created": "{{who}} 建立了服務帳號金鑰",
    "s_service_client_revoked": "{{who}} 撤銷了服務帳號金鑰",
    "s_service_client_secret_rotated": "{{who}} 輪替了服務帳號金鑰",
    "s_service_write": "服務帳號寫入了資料",
    "s_model_org_assign": "{{who}} 把機種 {{model}} 指派到組織",
    "s_model_org_moved": "{{who}} 把機種 {{model}} 移到另一個組織",
    "s_model_admin_create": "{{who}} 新增了機種 {{model}}",
    "s_aid_allocate": "{{who}} 配發了一批 AID",
    "s_qa_org_case": "{{who}} 改了機種的測試案例",
    "a_recording_read": "查看錄影清單",
    "a_fleet_console_ticket": "取得終端機連線",
    "a_fleet_console_open": "開終端機",
    "a_fleet_console_close": "結束終端機",
    "a_fleet_console_session_closed": "終端機已結束",
    "a_fleet_console_writer": "取得終端機輸入權",
    "a_fleet_command": "Node 指令",
    "a_fleet_local_credential": "設定本機登入密碼",
    "a_thing_update": "改設備名稱",
    "a_thing_assigned": "指派設備",
    "a_thing_moved": "搬移設備",
    "a_thing_ttl_direct_token": "區網直連權杖",
    "a_thing_admin_credential_set": "設定管理員密碼",
    "a_media_clip_fetch": "取影片片段",
    "a_vms_ai_assign": "指派 AI 主機",
    "a_vms_ai_unassign": "取消 AI 主機指派",
    "a_vms_alarm_state": "處理警報",
    "a_vms_device_links_put": "設定連動攝影機",
    "a_vms_floorplan_create": "新增平面圖",
    "a_vms_floorplan_delete": "刪除平面圖",
    "a_view_create": "新增版面",
    "a_view_delete": "刪除版面",
    "a_org_node_enroll_lookup": "查詢 Kinio Node",
    "a_org_node_enroll_identify": "確認 Kinio Node",
    "a_org_node_enroll_approve": "開通 Kinio Node",
    "a_org_inventory_claim": "認領庫存設備",
    "a_org_status": "改組織狀態",
    "a_org_verification": "審核服務類別",
    "a_relationship_request": "申請服務關係",
    "a_relationship_handover": "交接服務關係",
    "a_service_client_created": "建立服務帳號金鑰",
    "a_service_client_revoked": "撤銷服務帳號金鑰",
    "a_service_client_secret_rotated": "輪替服務帳號金鑰",
    "a_service_write": "服務帳號寫入",
    "a_model_org_assign": "指派機種到組織",
    "a_model_org_moved": "搬移機種",
    "a_model_admin_create": "新增機種",
    "s_device_read": "{{who}} 讀了 {{target}} 的{{rcmd}}",
    "rcmd_other": "資料",
    "rcmd_ch_list": "通道清單",
    "rcmd_pb_timeline": "錄影時間軸",
    "rcmd_pb_days": "有錄影的日子",
    "rcmd_pb_thumb": "錄影縮圖",
    "rcmd_sys_info": "系統資訊",
    "rcmd_hdd_info": "硬碟資訊",
    "rcmd_rec_status": "錄影狀態",
    "rcmd_wifi_state": "Wi-Fi 狀態",
    "rcmd_pb_list": "錄影清單",
    "s_recording_playback_at": "{{who}} 看了 {{target}} {{at}} 起的{{src}}",
    "s_media_watched_nodur": "{{who}} 看了 {{target}} 的即時影像",
    "s_media_replayed_nodur": "{{who}} 看了 {{target}} 的本地錄影",
    "no_end_record": "（沒有結束紀錄）",
    "s_media_replay_started": "{{who}} 開始看 {{target}} 的本地錄影",
    "s_media_replayed_at": "{{who}} 看了 {{target}} {{at}} 起的本地錄影 {{dur}}",
    "s_media_replayed_at_nodur": "{{who}} 看了 {{target}} {{at}} 起的本地錄影",
    "s_media_replay_started_at": "{{who}} 開始看 {{target}} {{at}} 起的本地錄影",
    "catalog_zh_hant": "yes",
    "quoted": "「{{v}}」",
    "s_device_command_named": "{{who}} 對 {{target}} 下了命令「{{cmdName}}」",
    "s_device_set_named": "{{who}} 改了 {{target}} 的「{{cmdName}}」",
    "rpc_pb_export": "匯出錄影",
    "rpc_cfg_set": "變更設定",
    "rpc_hdd_smartTest": "硬碟健檢",
    "rpc_kinio_pair": "配對設備",
    "rpc_kinio_pairWindow": "開放配對",
    "rpc_kinio_net": "變更網路設定",
    "rpc_sys_factoryReset": "原廠重置",
    "rpc_upgrade_check": "檢查韌體更新",
    "rpc_tool_run": "執行診斷工具",
    "rpc_tool_cancel": "停止診斷工具",
    "times_since": "× {{n}} 次（最早 {{since}}）",
    "each": "這 {{n}} 次",
    "filling": "正在往前找符合的紀錄…",
    "reason_client_stop": "看的人關掉",
    "reason_client_gone": "看的人斷線或關掉頁面",
    "reason_device_gone": "設備斷線",
    "reason_viewer_limit": "同時觀看人數已滿，被擠掉",
    "reason_token_expired": "登入逾時",
    "reason_access_revoked": "觀看權限被收回",
    "reason_authorization_unavailable": "暫時無法確認權限",
    "reason_api_delete": "經 API 結束",
    "reason_timeout": "逾時"
  },
  "sessions": {
    "title": "登入中的設備",
    "hint": "強制登出後，該設備 30 秒內會停止即時影像，也不能再換發登入。",
    "device": "設備",
    "ip": "IP",
    "signed_in": "登入 / 最後驗證",
    "last_active": "最後活動",
    "current": "目前這個",
    "mfa": "兩步驟驗證",
    "revoke": "登出",
    "sign_out": "登出這裡",
    "revoke_others": "登出其他所有設備",
    "revoke_others_confirm": "確定登出其他所有設備？",
    "revoke_current_confirm": "這會登出目前這個瀏覽器，確定？",
    "client_c_livingstyle_vms": "ls-vms",
    "client_c_kinio_vms_work": "VMS",
    "client_c_kinio_emu": "Kinio 模擬器"
  },
  "transfer": {
    "button": "交接 / 接管",
    "title_handover": "交接「{{name}}」",
    "title_takeover": "接管「{{name}}」",
    "current": "目前管理人",
    "unassigned": "無人管理",
    "target": "新管理人",
    "me": "我",
    "warn_new": "新管理人會取得這個$t(leaf.cur)的即時影像、錄影與管理權。",
    "warn_old": "原管理人會失去管理人身分，以及他在這個$t(leaf.cur)的場域授權（不會自動降為管理員）。",
    "warn_takeover": "這是組織管理員的受控接管，會完整記錄在稽核並通知相關的人。",
    "reason": "理由（必填，會寫進稽核）",
    "submit_handover": "交接",
    "submit_takeover": "接管",
    "done": "完成。原管理人在這個$t(leaf.cur)的 {{n}} 筆授權已撤銷，30 秒內生效。",
    "unchanged": "對象本來就是管理人，沒有變動。",
    "not_allowed": "只有現任管理人能交接；組織管理員可以接管。"
  },
  "policy": {
    "title": "安全政策",
    "hint": "只在使用這個組織的設備與管理功能時套用；成員自己的家與其他組織不受影響。政策變更後下一次請求就生效。",
    "idle": "閒置逾時",
    "idle_hint": "使用者沒操作（滑鼠、鍵盤、觸控）超過這段時間，要重新驗證才能繼續用這個組織的設備；監控大螢幕請用值班模式。",
    "max_sessions": "同時登入上限",
    "max_hint": "只計使用這個組織的登入；超過時那個登入要重新驗證，不會登出整個帳號。",
    "unlimited": "不限",
    "sessions": "{{n}} 個",
    "minutes": "{{n}} 分鐘",
    "hours": "{{n}} 小時",
    "days_one": "{{count}} 天",
    "days_other": "{{count}} 天",
    "saved": "已儲存",
    "ip_allowlist": "IP 允許清單",
    "ip_hint": "每行一個 IP 或 CIDR（例 203.0.113.0/24）；空白 = 不限。清單外連線存取這個組織的設備與管理功能一律拒絕。儲存時你目前的 IP 必須在清單內。",
    "require_mfa": "要求兩步驟驗證",
    "require_mfa_hint": "沒開兩步驟驗證的成員看不到這個組織的設備，會提示他開啟；帳號本身不強制。",
    "login_max_age": "登入時效",
    "login_max_age_hint": "登入超過這段時間，要重新登入才能繼續用這個組織的設備（不會登出整個帳號）。",
    "api_keys": "成員可用 API 金鑰存取本組織",
    "api_keys_hint": "打開後，成員可以用自己的 API 金鑰讓 Claude 查本組織的設備、事件與警報（權限照各人此刻的授權；寫入與影像每次記稽核，讀取不記）。",
    "snapshot_upload": "事件快照存到雲端",
    "snapshot_upload_hint": "每個事件存一張小圖到雲端，推播與事件列表會帶縮圖、雲端 AI 才能分析。關掉立即生效；打開要重新驗證。",
    "snapshot_upload_off_hint": "已關閉：事件照常記錄，但推播沒有縮圖、事件列表與預覽格顯示類別圖示、雲端 AI 不能用（本地 AI 整合中心不受影響）。已上雲的快照照保存期到期。App 截圖不受影響。"
  },
  "passkey": {
    "title": "Passkey（通行金鑰）",
    "hint": "用指紋、臉部辨識或設備 PIN 登入，不用輸入密碼，本身就算兩步驟驗證。存在 iCloud 鑰匙圈或 Google 密碼管理工具的 passkey 會同步到你的其他設備。",
    "add": "新增 passkey",
    "none": "還沒有 passkey。",
    "unsupported": "這個瀏覽器不支援 passkey。",
    "synced": "已同步",
    "created": "{{date}} 新增",
    "last_used": "上次使用 {{date}}",
    "delete": "刪除",
    "delete_confirm": "刪除「{{name}}」？刪除後就不能用它登入。",
    "sign_in": "用 passkey 登入",
    "or": "或",
    "verify": "用 passkey 驗證",
    "or_password": "或輸入密碼",
    "err_PASSKEY_CANCELED": "已取消或逾時",
    "err_PASSKEY_EXISTS": "這個設備已經有這個帳號的 passkey",
    "err_PASSKEY_INVALID": "passkey 驗證失敗",
    "err_PASSKEY_STATE_INVALID": "逾時，請重試",
    "err_NO_PASSKEY": "這個帳號還沒在這個網站設定 passkey，請改用下面的密碼驗證（passkey 可以到〔設定 › 安全性〕新增）。",
    "err_LAST_FACTOR": "你參加的組織要求兩步驟驗證：至少要保留一種（TOTP 或 passkey）",
    "err_PASSKEY_DISABLED": "這個環境沒有開 passkey",
    "err_BAD_RP": "這個網址不能使用 passkey",
    "err_REAUTH_REQUIRED": "需要重新驗證身分",
    "err_default": "passkey 失敗（{{code}}）"
  },
  "ext": {
    "verified": "Kinio 已審核：{{kind}}",
    "until": "到 {{date}}",
    "shrink": "刪減範圍",
    "revoke": "撤銷",
    "auto_include_new_on": "新設備自動加入（只限狀態 / 事件 / 警報）",
    "cond_always": "影像隨時可看",
    "cond_alarm_window": "只在警報後 {{n}} 分鐘內可看影像",
    "cond_armed": "只在布防時可看影像",
    "code": "邀請碼",
    "code_hint": "輸入服務商給你的邀請碼（或打開他們給的連結）。你在自己的帳號內核准，服務商看不到你的帳號資料。",
    "preview": "查看內容",
    "duration_one": "期限 {{count}} 天",
    "duration_other": "期限 {{count}} 天",
    "scopes": "允許的操作",
    "devices": "設備",
    "devices_all": "$t(leaf.cur)目前全部設備",
    "devices_list": "只限勾選的設備",
    "auto_include_new": "之後新增的設備自動加入（只限看狀態、事件與收警報；影像與控制永遠要另外同意）",
    "media_condition": "影像條件",
    "history": "開始前的歷史資料",
    "history_none": "不提供（預設）",
    "history_days_one": "往前 {{count}} 天",
    "history_days_other": "往前 {{count}} 天",
    "install_lan": "允許施工模式（安裝人員在現場用區網連線，最長 8 小時，交屋即作廢）",
    "consent_note": "含影像、布撤防或施工模式時會要求重新驗證身分。",
    "accept": "核准",
    "shrink_of": "刪減「{{name}}」的範圍",
    "shrink_hint": "只能縮小；要擴大請服務商重新發請求。",
    "access_log_empty": "還沒有服務存取紀錄。",
    "when": "時間",
    "who": "人員",
    "what": "操作",
    "device": "設備",
    "purpose_install": "安裝",
    "purpose_maintenance": "維護",
    "purpose_monitoring": "監控",
    "purpose_security_service": "保全服務",
    "purpose_care": "照護",
    "purpose_property": "物業",
    "kind_installer": "安裝商",
    "kind_security_provider": "保全業",
    "kind_monitoring_center": "監控中心",
    "kind_property_manager": "物業管理",
    "kind_care_provider": "照護機構",
    "kind_dealer": "經銷",
    "kind_enterprise": "企業",
    "device_unknown": "已移除的設備"
  },
  "svc": {
    "title": "分享請求",
    "note": "給屋主的說明（選填）",
    "issue": "產生邀請碼",
    "issued": "邀請碼 7 天內有效、只能用一次。把碼或連結交給屋主：",
    "status_active": "服務中",
    "status_suspended": "暫停",
    "status_ended": "已結束",
    "complete_install": "完成安裝（交屋）",
    "end": "終止",
    "end_confirm": "確定終止這筆分享？",
    "service_roles": "服務角色",
    "service_roles_hint": "服務角色決定這個人在客戶$t(leaf.cur)能做什麼，最多到客戶核准的範圍。",
    "role_operator": "操作員",
    "role_operator_desc": "看狀態、事件、影像、回放、收警報",
    "role_supervisor": "主管",
    "role_supervisor_desc": "布撤防、匯出錄影",
    "role_technician": "技師",
    "role_technician_desc": "安裝、設定、遠端偵測",
    "tab": "分享給本組織",
    "hint_kinds": "這個組織的服務類別：{{kinds}}。產生一次性代碼給$t(leaf.cur)，$t(leaf.cur)在自己的 App 或 VMS 同意後才能存取（還沒通過平台審核的用途，$t(leaf.cur)會看到提示、伺服器也會擋）。",
    "no_kinds": "這個組織沒有服務類別（例如安裝、保全、監控中心），不能發分享請求；$t(leaf.cur)仍然可以把設備分享給你們。",
    "purpose": "用途",
    "pending_requests": "等待$t(leaf.cur)同意",
    "renewal": "續約",
    "cancel_request": "撤回",
    "received": "收到的分享",
    "received_hint": "成員能做什麼在成員的「組織權限…」裡設服務角色，最多到$t(leaf.cur)分享的範圍；組織不能管理、也不能再分享這些設備。",
    "none_received": "還沒有收到分享。",
    "a_home": "一個$t(leaf.cur)",
    "unverified": "這個組織的服務類別還沒通過平台審核（或已過期），審核通過後才能發分享請求。",
    "verified_until": "審核到 {{date}}"
  },
  "sensor": {
    "popups": "感測器彈窗",
    "contact_title": "{{name}} 門開了",
    "motion_title": "{{name}} 偵測到有人",
    "playback": "回放 {{cam}}",
    "no_link": "沒有關聯攝影機；到「設備」設定關聯後，觸發時會帶即時畫面。",
    "contact_on": "開啟",
    "contact_off": "關閉",
    "motion_on": "有人",
    "motion_off": "無人",
    "alarm_title2": "警報 · {{what}} · {{name}}",
    "detection_title2": "偵測 · {{what}} · {{name}}",
    "more_n_one": "還有 {{count}} 則",
    "more_n_other": "還有 {{count}} 則",
    "expand": "展開",
    "collapse": "收成細條",
    "watch_live": "看即時",
    "no_snapshot": "還沒有快照；按〔看即時〕看現場",
    "switch_scope": "切到該範圍",
    "alarm_kind": "警報 · {{what}}",
    "detection_kind": "偵測 · {{what}}",
    "out_of_scope_path": "不在目前範圍：{{path}}",
    "switch_scope_to": "切到 {{path}}"
  },
  "link": {
    "button": "關聯",
    "title": "{{name}} 的關聯攝影機",
    "help": "觸發時（門開 / 有人）要帶哪幾台攝影機的畫面。",
    "cameras": "攝影機",
    "no_cameras": "這個$t(leaf.cur)沒有攝影機",
    "purposes": "用在",
    "purpose_popup": "即時彈窗",
    "purpose_clip": "事件卡片帶回放",
    "readonly": "只有$t(leaf.cur)擁有者 / 管理員 或組織管理員可以修改"
  },
  "onvif": {
    "open": "新增 ONVIF 攝影機",
    "title": "新增 ONVIF 攝影機（經 Kinio 閘道）",
    "help": "經現場的 NVR、Kinio Station 或 AI box（閘道）接第三方 ONVIF 攝影機；帳密只送到閘道。Kinio 自家設備會改用 Kinio 配對。",
    "no_gateway": "這個範圍裡沒有你能管理、可以當閘道的 Kinio NVR 或 Kinio Station（需要擁有者或管理員）。沒有閘道的場域請加一台 NVR 或 AI box。",
    "gateway": "閘道",
    "discover": "探索",
    "discovering": "探索中…",
    "group_managed": "已納管",
    "group_own": "Kinio 自家設備",
    "group_suspect": "疑似 Kinio 設備",
    "group_third_party": "第三方 ONVIF",
    "none": "沒有",
    "on_channel": "已是 CH{{ch}}",
    "pair_kinio": "用 Kinio 方式配對（不經 ONVIF）",
    "suspect_help": "預設用 Kinio 方式配對；舊機種要以 ONVIF 加入需要擁有者填理由。",
    "suspect_help_owner": "預設用 Kinio 方式配對；確定要以 ONVIF 加入可以勾選並填理由（會寫稽核）。",
    "duplicates": "{{n}} 筆重複回應已合併（同一台從不同網路介面回應）",
    "creds_help": "攝影機帳密（只送到閘道，平台不保存；會用在勾選的每一台）",
    "user": "帳號",
    "password": "密碼",
    "add": "加入 {{n}} 台",
    "reason": "為什麼不用 Kinio 配對？（例：舊 Swann 機種不支援私有協議）",
    "force_add": "仍以 ONVIF 加入 {{n}} 台",
    "result_ok": "已加入",
    "result_auth_failed": "帳密錯誤",
    "result_timeout": "逾時",
    "result_unreachable": "連不上",
    "result_unsupported": "不支援",
    "h265_only": "只有 H.265"
  },
  "ptz": {
    "title": "雲台控制",
    "home": "回原點",
    "speed": "速度",
    "zoom_in": "放大",
    "zoom_out": "縮小",
    "presets": "預置點",
    "pick_preset": "選擇預置點",
    "no_presets": "沒有預置點",
    "loading": "讀取中…",
    "goto": "前往",
    "save_preset": "存目前位置",
    "preset_name": "預置點名稱",
    "held": "{{role}}正在控制（{{n}} 秒後釋出）",
    "preempted": "控制權已被{{role}}取走",
    "take_over": "搶控",
    "role_owner": "擁有者",
    "role_admin": "管理員",
    "role_member": "成員",
    "role_operator": "操作員",
    "role_partner": "服務夥伴",
    "dir_up": "上",
    "dir_down": "下",
    "dir_left": "左",
    "dir_right": "右",
    "dir_upleft": "左上",
    "dir_upright": "右上",
    "dir_downleft": "左下",
    "dir_downright": "右下",
    "err_GATEWAY_OFFLINE": "閘道不在線",
    "err_GATEWAY_TIMEOUT": "閘道沒有回應",
    "err_FORBIDDEN": "沒有控制這台設備的權限",
    "cruise_start": "開始巡航",
    "cruise_stop": "停止巡航",
    "cruise_dwell": "每點停留（秒）",
    "cruise_at": "巡航中：{{name}}",
    "presets_count": "預置點　{{n}} / {{max}}",
    "presets_count_a11y": "預置點，已存 {{n}} 個，最多 {{max}} 個",
    "preset_n": "位置 {{n}}",
    "preset_add": "＋ 新增",
    "preset_full": "已滿",
    "preset_manage": "管理",
    "preset_manage_a11y": "管理預置點",
    "preset_done": "完成",
    "preset_done_a11y": "完成管理",
    "preset_rename": "改名",
    "preset_name_it": "命名",
    "preset_update": "用目前位置更新",
    "preset_delete": "刪除",
    "preset_delete_confirm": "刪除「{{name}}」？",
    "preset_here": "目前所在",
    "preset_going": "正在轉到{{name}}",
    "preset_arrived": "已轉到{{name}}",
    "preset_card_a11y": "{{name}}，預置點",
    "preset_card_unnamed_a11y": "{{name}}，預置點，未命名",
    "preset_menu": "預置點選項",
    "preset_name_label": "名稱",
    "preset_name_hint": "最多 12 個字，看得到這台的人都看得到",
    "preset_save": "存",
    "preset_unreachable": "攝影機離線，顯示最後一次的預置點",
    "preset_conflict": "別人剛改過預置點，已更新",
    "preset_err_BUSY": "雲台正在忙，請稍後再試",
    "preset_err_NOT_FOUND": "位置已失效",
    "preset_err_NOT_CALIBRATED": "雲台還在校正",
    "preset_err_TIMEOUT": "沒有轉到{{name}}",
    "preset_err_OFFLINE": "攝影機離線，沒有更新 / 刪除",
    "preset_err_ASLEEP": "攝影機在休眠，請稍後再試",
    "preset_err_LIMIT": "預置點已滿",
    "preset_err_INVALID_NAME": "請輸入 1–12 個字的名稱",
    "preset_err_OTHER": "沒有完成，請再試一次",
    "lens_note": "左右：兩顆一起轉，上下：只有{{name}}",
    "lens_none": "方向盤，這顆鏡頭不會轉"
  },
  "ai": {
    "title": "AI 運算",
    "help": "AI box、有 AI 晶片的 NVR 與 Kinio Station 在現場替同一個$t(leaf.cur)的攝影機跑 AI 分析；偵測事件記在來源攝影機上。現場 AI 隨硬體，不需要訂閱。",
    "no_provider": "這個範圍裡還沒有能跑 AI 的設備（AI box、有 AI 晶片的 NVR 或 Kinio Station）。",
    "assign": "指派攝影機",
    "assign_title": "指派攝影機給 {{name}}",
    "assign_submit": "確認指派",
    "probing": "正在請提供者測試串流…",
    "capacity": "已用 {{used}} / {{total}} 路",
    "capacity_title": "已用 {{used}} 路，共 {{total}} 路",
    "load": "負載 {{n}}%",
    "fps": "{{n}} fps",
    "none": "還沒有指派",
    "move": "改派到…",
    "unassign": "解除",
    "drag_help": "把攝影機拖到上面的提供者，或按「指派攝影機」",
    "camera": "攝影機",
    "models": "模型",
    "sensitivity": "靈敏度 {{n}}",
    "st_pending": "套用中",
    "st_running": "執行中",
    "st_degraded": "降載",
    "detail_viewer_limit": "這台設備的觀看名額被即時觀看佔滿，AI 分析先讓位，名額空出來會自動恢復",
    "detail_lan_unreachable": "區網連不到來源設備，事件分析暫停",
    "st_unreachable": "不可達",
    "st_rejected": "被拒絕",
    "err_AI_SOURCE_UNREACHABLE": "提供者連不到這台攝影機：{{message}}",
    "err_AI_SOURCE_UNSUPPORTED": "這台攝影機（或它的 NVR / Station / 基地台）的韌體還不能把影像代理給 AI 運算提供者",
    "err_AI_CAPACITY_FULL": "容量已滿（{{used}} / {{channels}} 路）",
    "err_AI_ALREADY_ASSIGNED": "這台攝影機已經指派給某個提供者",
    "err_AI_MODEL_UNSUPPORTED": "提供者不支援模型 {{model}}",
    "err_PROVIDER_OFFLINE": "提供者不在線",
    "err_NOT_AI_PROVIDER": "這台設備不是 AI 運算提供者",
    "err_FORBIDDEN": "需要$t(leaf.cur)擁有者或管理員",
    "err_VERSION_CONFLICT": "資料已被別人改過，請重新整理",
    "err_GATEWAY_OFFLINE": "閘道不在線",
    "err_GATEWAY_TIMEOUT": "閘道沒有回應",
    "model": {
      "kinio": {
        "person_vehicle@2": "人車偵測",
        "line_cross@1": "越線偵測",
        "intrusion@1": "區域入侵"
      }
    },
    "delivery": "取流方式",
    "delivery_auto": "自動（能持續就持續）",
    "delivery_continuous": "持續串流",
    "delivery_event": "事件快照",
    "delivery_help": "影像由攝影機或它的 NVR / Station / 基地台代理給提供者，提供者不需要攝影機帳密。持續串流佔那台設備一個觀看名額；電池型攝影機只能事件快照。",
    "err_AI_DELIVERY_UNSUPPORTED": "這台攝影機不支援這種取流方式（電池型只能事件快照）",
    "err_AI_VIEWER_LIMIT": "設備的觀看名額已滿（上限 {{limit}}：觀看中 {{viewers}}、AI 持續串流 {{ai}}），請改用事件快照或稍後再試",
    "err_BAD_DELIVERY": "取流方式不對",
    "tab_local": "本地 AI",
    "tab_cloud": "雲端 AI",
    "stations_without_one": "{{count}} 台 Kinio Station 沒有 AI 運算能力，所以不在上面的清單。",
    "stations_without_other": "{{count}} 台 Kinio Station 沒有 AI 運算能力，所以不在上面的清單。",
    "move_confirm": "把 {{cam}} 改派到 {{to}}？",
    "move_body": "原本的分析會停止，改由新的提供者分析；幾秒內生效。",
    "move_action": "改派",
    "moved": "已把 {{cam}} 改派到 {{to}}。",
    "move_undo": "復原",
    "subject": {
      "person": "人",
      "vehicle": "車",
      "animal": "動物",
      "face": "人臉",
      "plate": "車牌",
      "package": "包裹",
      "fire": "火焰",
      "smoke": "煙"
    },
    "subject_sep": "／",
    "model_detect": "{{what}}偵測",
    "model_detect_light": "{{what}}偵測（輕量）",
    "model_generic": "AI 偵測模型 v{{v}}",
    "stations_without_named": "{{names}} 沒有 AI 運算能力（這版 Kinio Station 沒有推論後端），所以不在上面的清單。",
    "unassign_confirm": "解除 {{cam}} 的 AI 分析？",
    "unassign_body": "這台的 AI 偵測會停止，之後不會再有 AI 事件；解除後可以按〔復原〕用同樣的設定重新指派。",
    "unassign_action": "解除指派",
    "unassigned": "已解除 {{cam}} 的 AI 分析。",
    "tab_byo": "自帶 AI"
  },
  "search": {
    "placeholder": "搜尋事件：紅色 機車 device:大門 class:person tag:helmet after:2026-09-01",
    "sort": "排序",
    "sort_time": "依時間",
    "sort_relevance": "依相關度",
    "suggest": "提示",
    "syntax": "語法：自由文字（中英混合）、\"片語\"、-排除、class: level: device:（設備名稱，例 device:\"NVR631 / CH5\"）site:（場域，含子場域）node: view: group:（組織樹的節點 / 版面 / 群組，輸入名稱挑選）tag: after: before: on: has:clip；逗號 = 或",
    "warnings": "看不懂的條件已忽略：{{list}}",
    "histogram": "每小時事件數",
    "more": "載入更多",
    "producer": "由 {{id}} 偵測",
    "bm_add": "加書籤",
    "bm_title": "書籤標題",
    "bm_note": "註記（選填）",
    "bm_private": "只有我看得到",
    "bm_saved": "已加書籤",
    "bm_delete": "刪除書籤",
    "bookmarks": "書籤",
    "site_unknown": "找不到場域：{{list}}（這些條件不會有結果）",
    "saved": "已存搜尋",
    "saved_none": "還沒有已存搜尋",
    "saved_shared": "共用",
    "saved_name": "名稱",
    "saved_scope": "存在哪裡",
    "saved_personal": "只有我",
    "saved_org": "{{name}} 共用",
    "saved_save": "儲存目前的搜尋",
    "saved_delete": "刪除「{{name}}」",
    "saved_help": "只存查詢條件；套用時照你現在的權限重新搜尋。",
    "saved_err_SAVED_SEARCH_LIMIT": "已存搜尋最多 100 筆，請先刪掉不用的",
    "saved_err_BAD_NAME": "名稱要 1–80 字",
    "saved_err_FORBIDDEN": "共用的已存搜尋要組織管理員",
    "to_map": "在地圖上看這些結果",
    "src_edge_box": "AI box",
    "src_device": "設備端 AI",
    "node_none": "找不到符合「{{q}}」的節點",
    "tree_filters": "篩選中：{{list}}",
    "tree_field_node": "節點「{{name}}」",
    "tree_field_view": "版面「{{name}}」",
    "tree_field_group": "群組「{{name}}」",
    "node_error": "節點搜尋失敗，請稍後再試（不是找不到）",
    "node_partial": "有一個區域的節點搜尋失敗，下面只列查得到的",
    "tree_name_unknown": "{{id}}（名稱未知）",
    "range": "時間範圍",
    "range_any": "全部時間",
    "range_today": "今天",
    "range_yesterday": "昨天",
    "range_24h": "過去 24 小時",
    "range_custom": "自訂…",
    "range_from": "從",
    "range_to": "到",
    "syntax_btn": "ⓘ 語法",
    "syntax_dates": "日期（YYYY-MM-DD，照你的時區）：after:D 從 D 當天起（含當天）、before:D 到 D 當天 00:00 為止（不含當天）、on:D 只有 D 那一天。",
    "range_7d": "過去 7 天",
    "hist_tip": "{{at}} · {{n}} 筆",
    "hist_hint": "在長條圖上拖選可以設時間範圍；點一格 = 只看那一個小時。",
    "term_as_class": "{{terms}} 照事件種類找：「{{cls}}」類（含影像訊號中斷、設備被拆除或遮擋）"
  },
  "exports": {
    "title": "匯出與證據",
    "help": "匯出錄影成 MP4 證據包（含每個檔案的 SHA-256 與平台簽章）；來源可選雲端、NVR / Station 硬碟或異地備份。下載每次都重新驗權限；完成的免費保存 30 天，要更久可改成長期保管。",
    "new": "新增匯出",
    "none": "還沒有匯出",
    "st_queued": "排隊中",
    "st_running": "處理中",
    "st_done": "完成",
    "st_failed": "失敗",
    "st_expired": "已過期",
    "signed": "已簽章",
    "unsigned": "未簽章",
    "reason": "原因",
    "download": "下載證據包",
    "share": "分享",
    "home": "$t(leaf.cur) / 場域",
    "cameras": "攝影機（最多 {{max}} 路）",
    "from": "開始時間",
    "minutes": "長度",
    "n_min": "{{n}} 分鐘",
    "reason_ph": "例如：警方調閱、案號…（必填，會寫進稽核與證據包）",
    "create": "建立匯出",
    "export_this": "匯出這段",
    "share_title": "分享連結",
    "ttl": "有效期限",
    "ttl_3600": "1 小時",
    "ttl_86400": "1 天",
    "ttl_604800": "7 天",
    "ttl_2592000": "30 天",
    "max_views": "觀看次數上限",
    "unlimited": "不限",
    "share_password": "密碼",
    "share_password2": "確認密碼",
    "optional": "選填",
    "share_create": "建立連結",
    "share_once": "這個連結只會顯示這一次，請現在複製。",
    "expires": "{{at}} 到期",
    "views": "已看 {{n}} / {{max}}",
    "has_password": "有密碼",
    "revoked": "已撤銷",
    "expired": "已到期",
    "revoke": "撤銷",
    "err_REASON_REQUIRED": "匯出原因必填（4 字以上）",
    "err_BAD_RANGE": "時段不對：每路一段、結束晚於開始、最長 1 小時、不能是未來",
    "err_BAD_SOURCES": "選 1–4 路攝影機",
    "err_FORBIDDEN": "沒有匯出這台攝影機的權限",
    "err_EXPORT_NOT_READY": "匯出還沒完成",
    "err_BAD_TTL": "期限要在 1 小時到 30 天之間",
    "source": "來源",
    "src_cloud": "雲端錄影",
    "src_local": "NVR / Station 硬碟",
    "src_backup": "異地備份",
    "src_cloud_help": "從雲端錄影的片段匯出。",
    "src_local_help": "請 NVR / Kinio Station 把這段本地錄影上傳後匯出（只給這次匯出，不算雲端錄影、不佔席次）；設備要在線，攝影機的 SD 卡還不支援。",
    "src_backup_help": "從異地備份的已驗證副本匯出（讀取時再驗一次完整性）。",
    "local_waiting": "等設備上傳本地錄影（最多 30 分鐘）…",
    "fail_local_export_unsupported": "這台設備的韌體還不支援本地錄影匯出",
    "fail_local_upload_timeout": "設備沒有在時限內送完本地錄影（可能離線或上傳太慢）",
    "fail_local_export_failed": "設備沒有收下匯出請求（可能離線）",
    "fail_no_recording": "這個時段沒有本地錄影",
    "fail_codec_not_supported": "這個時段的影像編碼不支援匯出（只支援 H.264 / H.265）",
    "tab_jobs": "匯出工作",
    "no_rec_in_source": "這段時間沒有{{src}}",
    "recipient": "收件人",
    "recipient_ph": "例：田中專員 / tanaka@example.jp",
    "recipient_help": "一個收件人一條連結；會以遮罩後的形式出現在對方畫面的浮水印上。",
    "ttl_until_export": "到匯出包到期（{{at}}）",
    "share_export_expiry": "匯出包保存到 {{at}}，分享連結最晚也到那時。",
    "share_clamped": "期限已截到匯出包到期（{{at}}）。",
    "no_recipient": "（沒有填收件人）",
    "err_EXPORT_EXPIRES_SOON": "匯出包保存剩不到 1 小時，請重新匯出再分享。",
    "err_RECIPIENT_REQUIRED": "要填收件人（名字或 email，最多 100 字）",
    "fail_signing_failed": "證據包簽章失敗，沒有產生未簽章的包；請稍後重新匯出或聯絡平台",
    "block_not_enabled": "這個組織還沒開通證據匯出，請聯絡服務商開通。",
    "block_worker_disabled": "這個環境目前不能建立匯出。",
    "block_tmp_space_low": "匯出服務忙碌中，請稍後再試。",
    "block_gateway_unreachable": "暫時無法建立匯出，請稍後再試。",
    "max_views_help": "預設 {{n}} 次；對方每開一次分享頁算一次。",
    "fail_queue_timeout": "排隊太久沒有開始（當時匯出服務沒開或忙碌），請重新建立匯出。",
    "st_deleted": "已刪除",
    "archived": "長期保管",
    "kept_free": "免費保存到 {{at}}",
    "kept_archive": "長期保管到 {{at}}",
    "quota_line": "免費保存空間（組織共用）：已用 {{used}} / {{limit}}",
    "block_quota_exceeded": "這個組織的免費匯出空間已用完：刪掉不需要的匯出包，或把要留的改成長期保管。",
    "delete": "刪除…",
    "delete_title": "刪除匯出包",
    "delete_help": "刪除後證據包與它的分享連結立即失效，檔案會從雲端刪除，不能復原。",
    "delete_no_refund": "這個匯出包在長期保管中：提前刪除，已付的保管費用不退。",
    "delete_reason": "刪除原因（必填，會寫進稽核）",
    "delete_confirm": "刪除",
    "deleted_reason": "刪除原因",
    "err_EXPORT_BUSY": "匯出還在進行中，完成後才能刪。",
    "err_EXPORT_GONE": "匯出包已到期或已刪除。",
    "archive": "長期保管…",
    "archive_extend": "延長保管…",
    "archive_title": "改成長期保管",
    "archive_extend_title": "延長長期保管",
    "archive_help": "這個匯出包 {{size}}（{{cls}}）。長期保管期間照常可下載、驗證、建分享連結（每條仍最長 30 天）；到期後刪除。延長會接在目前到期日後面。",
    "archive_size_5gb": "≤ 5 GB",
    "archive_size_20gb": "≤ 20 GB",
    "archive_size_50gb": "≤ 50 GB",
    "archive_period": "保管期間",
    "archive_p_90d": "90 天",
    "archive_p_1y": "1 年",
    "archive_p_3y": "3 年",
    "archive_after": "付款後保存到 {{at}}",
    "archive_reason": "原因（必填，會寫進稽核）",
    "archive_no_refund": "一次性付款、價格未稅；提前刪除或刪除$t(leaf.cur)時，已付的費用不退。",
    "archive_pay": "前往付款",
    "archive_processing": "付款處理中，完成後這裡會更新…",
    "archive_done": "長期保管已生效。",
    "archive_failed": "付款沒有完成，匯出包維持原本的保存期限。",
    "archive_canceled": "已取消付款，匯出包維持原本的保存期限。",
    "archive_slow": "付款結果還沒回來，請稍後重新整理。",
    "err_ARCHIVE_TOO_LONG": "延長後的到期日不能晚於今天起 3 年。",
    "err_ARCHIVE_TOO_LARGE": "超過 50 GB 的匯出包不提供長期保管。",
    "err_ARCHIVE_PENDING": "這個匯出包已有結帳中的長期保管，請先完成或等它過期（23 小時）。",
    "err_EXPORT_NOT_DONE": "匯出完成後才能改成長期保管。",
    "err_STORE_NOT_CONFIGURED": "這個品牌目前不能線上付款，請聯絡服務商。",
    "err_BAD_PERIOD": "保管期間只能是 90 天、1 年或 3 年。"
  },
  "shares": {
    "tab": "分享連結",
    "help": "所有對外的分享連結：給了誰、誰建的、什麼時候到期、看了幾次。識別碼就是對方畫面浮水印上的 6 碼。",
    "filter": "顯示範圍",
    "f_active": "有效的",
    "f_all": "全部",
    "revoke_picked": "撤銷選取的 {{n}} 條",
    "none_active": "目前沒有對外開著的分享連結",
    "none_all": "還沒有建過分享連結",
    "pick_all": "選取全部有效的",
    "pick": "選取 {{code}}",
    "col_video": "影片",
    "col_recipient": "收件人",
    "col_code": "識別碼",
    "col_by": "建立者",
    "col_created": "建立時間",
    "col_expires": "到期",
    "col_views": "觀看",
    "col_password": "密碼",
    "col_status": "狀態",
    "col_actions": "動作",
    "by_me": "我",
    "by_other": "其他成員",
    "st_active": "有效",
    "st_expired": "已到期",
    "st_revoked": "已撤銷",
    "st_used_up": "次數用完",
    "revoke_one_title": "撤銷後對方就打不開這條連結",
    "revoke_body": "收件人：{{who}}（識別碼 {{code}}）。30 秒內生效，不能復原；要再給就重新建一條。",
    "revoke_many_title": "撤銷 {{n}} 條分享連結",
    "revoke_many_body": "這些收件人 30 秒內就打不開，不能復原。撤銷失敗的會留在表上並寫原因。"
  },
  "share": {
    "title": "分享的影片",
    "need_password": "這段影片有密碼保護",
    "password": "密碼",
    "wrong_password": "密碼錯誤",
    "open": "開啟",
    "gone": "這個分享連結已失效（到期、被撤銷或觀看次數用完）。",
    "not_found": "找不到這個分享連結。",
    "error": "暫時無法載入，請稍後再試。",
    "expires": "連結於 {{at}} 到期",
    "clip_n": "片段 {{n}}"
  },
  "verify": {
    "title": "證據包驗證",
    "help": "在瀏覽器裡檢查證據包：每個檔案的 SHA-256 是否跟 manifest 一致、manifest 的平台簽章是否有效。檔案不會上傳。",
    "drop": "把證據包 ZIP 拖到這裡，或點一下選檔",
    "checking": "檢查中…",
    "v_pass": "驗證通過：檔案完整、簽章有效",
    "v_fail": "驗證失敗：內容被改過或簽章無效",
    "v_unsigned": "檔案完整，但這份證據包沒有簽章",
    "job": "匯出工作",
    "exported_by": "匯出者",
    "reason": "原因",
    "generated": "產生時間",
    "signature": "簽章",
    "sig_valid": "有效",
    "sig_invalid": "無效（manifest 被改過或不是平台簽的）",
    "sig_unsigned": "沒有簽章",
    "sig_no_key": "找不到對應的平台金鑰",
    "missing": "缺少這個檔案",
    "mismatch": "SHA-256 不一致（被改過）",
    "extra": "manifest 沒列的多餘檔案",
    "err_bad_zip": "不是有效的 ZIP",
    "err_no_manifest": "ZIP 裡沒有 manifest.json",
    "err_bad_manifest": "manifest.json 格式錯誤",
    "tab": "驗證證據包",
    "key": "簽章金鑰",
    "fp_short": "指紋 {{fp}}",
    "key_current": "使用中",
    "key_retired": "已停用",
    "keys_title": "平台的驗章金鑰（{{n}} 把）",
    "keys_help": "換過金鑰後，舊的證據包仍用當時那把驗。可以拿下面的指紋跟平台公開說明頁比對。"
  },
  "billing": {
    "subject": "付費主體",
    "subject_org": "組織：{{name}}",
    "subject_home": "$t(leaf.cur)：{{name}}",
    "no_subject": "你沒有可以管理方案的組織或$t(leaf.cur)。",
    "notice_ok": "完成",
    "notice_warn": "注意",
    "notice_err": "錯誤",
    "checkout_canceled": "已取消付款，沒有扣款。",
    "checkout_processing": "付款完成，正在確認（通常幾秒內）…",
    "checkout_done": "購買完成，席次與額度已生效。",
    "checkout_failed": "付款沒有完成或已過期。",
    "checkout_slow": "付款確認比平常久，稍後重新整理看看；如果已扣款，席次會自動出現。",
    "subscriptions": "訂閱",
    "no_subscriptions": "還沒有訂閱。",
    "items": "內容",
    "state": "狀態",
    "period_end": "下次續訂 / 到期",
    "grace_until": "寬限到 {{at}}",
    "manage": "管理付款與訂閱",
    "manage_hint": "在 Stripe 的管理頁可以改席數、換卡、取消（變更會在一分鐘內同步回來）。",
    "buy": "購買",
    "draft_prices": "價格暫定",
    "store_not_configured": "這個品牌還沒設定付款帳號，暫時不能購買。",
    "need_org_billing": "購買需要組織管理員或「帳單」權限；你可以看，但不能買。",
    "need_owner": "只有$t(leaf.cur)的擁有者可以購買。",
    "product": "商品",
    "price": "價格",
    "quantity": "數量",
    "per_month": "月",
    "per_year": "年",
    "per_seat": "每席",
    "buy_btn": "購買（{{total}}）",
    "seat_name": "雲端錄影席次：{{mode}}、保存 {{days}} 天",
    "ai_name": "雲端 AI：每月 {{n}} 次分析",
    "pack_name": "雲端 AI 加購：{{n}} 次",
    "pack_hint": "本月（UTC）有效",
    "ai_already": "已有雲端 AI 訂閱；額度不夠請加購",
    "mode_event": "事件錄影",
    "mode_continuous": "全時錄影",
    "days_one": "{{count}} 天",
    "days_other": "{{count}} 天",
    "seats": "雲端錄影席次",
    "seats_summary": "共 {{total}} 席、{{free}} 席未指派",
    "no_seats": "還沒有席次。買了之後在這裡指派到設備或通道。",
    "seat": "席次",
    "source": "來源",
    "source_subscription": "訂閱",
    "source_grant": "合約",
    "contract_until": "合約到 {{at}}",
    "assigned_to": "指派到",
    "unassigned": "未指派",
    "has_seat": "已有席次",
    "usage_month": "本月上傳",
    "usage": "{{clips}} 段 · {{mb}} MB",
    "assigned": "已指派到 {{name}}，{{within}} 秒內開始用這一席上雲。",
    "covered_by_plan": "{{name}} 原本就在$t(leaf.cur)方案內；指派後改用這一席的保存天數與模式。",
    "seats_hint": "一台設備（或 NVR 的一個通道）同時只能有一席；改派後原設備最慢 60 秒停止上雲，已存的片段照原本的保存天數保留。",
    "ai": "雲端 AI 額度",
    "ai_usage": "{{period}} 已用 {{used}} / {{limit}} 次",
    "ai_packs": "（含加購 {{n}} 次）",
    "ai_limit_reached": "本月額度已用完：分析已暫停，錄影與事件不受影響。可以加購。",
    "ai_near_limit": "本月額度已用超過 80%。",
    "ai_feature_detect": "物件偵測補位",
    "ai_feature_attributes": "屬性標籤",
    "ai_feature_caption": "場景描述",
    "ai_feature_lpr": "車牌辨識",
    "state_pending": "待付款",
    "state_active": "有效",
    "state_cancel_pending": "期末取消",
    "state_grace": "寬限中",
    "state_on_hold": "暫停（付款失敗）",
    "state_expired": "已到期",
    "state_revoked": "已撤銷",
    "state_ended": "已結束",
    "err_generic": "操作失敗（{{code}}）",
    "err_FEATURE_DISABLED": "全時錄影即將開放，目前不能購買全時席次。",
    "coming_soon": "即將開放",
    "err_STORE_NOT_CONFIGURED": "這個品牌還沒設定付款帳號。",
    "err_ALREADY_ENTITLED": "已經有雲端 AI 訂閱；額度不夠請加購。",
    "err_REF_HAS_SEAT": "這台設備已經有席次，先解除那一席。",
    "err_SEAT_ENDED": "這一席已經結束。",
    "err_PRODUCT_NOT_PURCHASABLE": "這個商品目前不能購買（可能已改版），請重新整理。",
    "err_BAD_RETURN_URL": "回傳網址不被允許。",
    "err_DEVICE_NOT_FOUND": "這台設備不在這個主體的$t(leaf.cur)裡。",
    "err_FORBIDDEN": "你沒有這個操作的權限。",
    "err_USE_ORG_BILLING": "團體組織$t(leaf.cur)的席次與 AI 由組織購買。",
    "err_NO_CUSTOMER": "還沒買過，沒有可管理的付款資料。",
    "err_STORE_ERROR": "付款服務暫時無法使用，請稍後再試。",
    "rate": "最近 1 小時 {{kbps}} kbps",
    "uplink_title": "全時錄影的實測上行（最近 1 小時，依場域）：",
    "uplink_home": "{{mbps}} Mbps；請確認場域的上行頻寬足夠",
    "pick_title": "要看哪一個的方案與帳單？",
    "capsule": "付費主體：{{name}}",
    "home_plan_item": "{{name}}（{{where}}）",
    "home_plan_cams_one": "另外由$t(leaf.cur)方案提供雲錄的攝影機：{{names}}",
    "home_plan_cams_other": "另外由$t(leaf.cur)方案提供雲錄的攝影機（{{count}} 台）：{{names}}",
    "archives": "證據包長期保管",
    "archives_help": "匯出包免費保存 30 天；要更久，在「匯出與證據」對每個包選〔長期保管…〕，一次性付款（美元、未稅）。",
    "archive_size": "匯出包大小",
    "no_archives": "目前沒有長期保管中的匯出包。",
    "archive_job": "匯出工作",
    "archive_period": "期間",
    "archive_ends": "保管到",
    "archive_days": "{{n}} 天",
    "archive_st_active": "保管中",
    "archive_st_pending": "結帳中",
    "archive_st_expired": "結帳過期",
    "archive_st_revoked": "已退款"
  },
  "backup": {
    "title": "異地備份",
    "help": "把 NVR 的錄影加密後送到 NAS 或另一台 NVR。目的地只存加密後的檔案、拿不到金鑰；覆蓋率看的是「已確認送達並驗證的最後時間點」。",
    "add_target": "新增目的地",
    "new_policy": "新增備份政策",
    "targets": "目的地",
    "no_targets": "還沒有備份目的地。",
    "policies": "備份政策",
    "no_policies": "還沒有備份政策。",
    "delete": "刪除",
    "test": "測試連線",
    "test_ok": "連線正常",
    "test_first": "先測試",
    "save_target": "登記",
    "rotate": "更換帳密",
    "rotate_title": "更換 {{name}} 的寫入帳密",
    "rotate_help": "新帳密送到平台後託管；舊的立刻退役。更換後會回到「未測試」，請再測一次。",
    "in_use": "還有政策在用，先撤銷政策",
    "confirm_delete_target": "刪除目的地「{{name}}」？帳密會一併退役。",
    "via_device": "經 Kinio 設備",
    "quota_used": "已用 {{used}} / 額度 {{quota}}",
    "cred_hint": "寫入 {{write}}、讀取 {{read}}",
    "policies_n": "{{n}} 個政策",
    "cat_ok": "正常",
    "cat_auth": "認證失敗",
    "cat_network": "網路問題",
    "cat_permission": "權限不足",
    "cat_space": "空間不足",
    "cat_config": "設定錯誤",
    "cat_integrity": "內容不一致",
    "cat_unsupported": "要設備代測",
    "cat_unknown": "無法辨識",
    "step_quota": "額度",
    "step_put": "寫入",
    "step_head": "檢查",
    "step_get": "讀回",
    "step_delete": "刪除",
    "kind_nas_s3": "NAS（S3 相容）",
    "kind_nas_smb": "NAS（SMB）",
    "kind_nas_nfs": "NAS（NFS）",
    "kind_nvr": "另一台 NVR",
    "kind_help_nas_s3": "Synology / QNAP 內建的 S3 服務或 MinIO；同站或異地都可。NVR 用 S3 API 直推密文並驗 checksum。",
    "kind_help_nas_smb": "只限與來源 NVR 同站區網，一律經同站的 Kinio 設備存取。",
    "kind_help_nas_nfs": "同 SMB：只限同站區網（Linux / macOS NAS）。",
    "kind_help_nvr": "同一個組織的另一台 Kinio NVR（團體組織的$t(leaf.cur)）；兩端擁有者都要核准，必須不同故障域。",
    "home": "$t(leaf.cur)",
    "kind": "種類",
    "name": "名稱",
    "target_nvr": "目的 NVR",
    "endpoint_s3": "S3 端點",
    "endpoint_smb": "SMB 路徑",
    "endpoint_nfs": "NFS 路徑",
    "bucket": "Bucket",
    "prefix": "前綴",
    "region": "Region",
    "path_style": "Path-style（多數 NAS 要勾）",
    "access_path": "回放時怎麼讀",
    "ap_public": "NAS 有公網 HTTPS 端點（VMS 直接讀）",
    "ap_via_device": "經同站另一台 Kinio 設備代理",
    "proxy_device": "代理設備",
    "quota_gb": "額度（GB）",
    "quota_help": "NAS 回報不了剩餘空間，平台照這個額度擋；超過就停止新備份，不刪未到期的副本。",
    "credentials": "帳密",
    "cred_help": "帳密只送這一次，由平台託管（加密）；寫入的只發給來源 NVR，讀取的只給回放。建議寫入 / 讀取用兩組、權限只到這個 bucket / prefix。",
    "separate_read": "讀取用另一組",
    "read_prefix": "讀取",
    "username": "帳號",
    "password": "密碼",
    "access_key": "Access key",
    "secret_key": "Secret key",
    "fault_domain": "故障域",
    "fd_site": "場域",
    "fd_facility": "機房 / 建物",
    "fd_power": "供電 / UPS",
    "fd_network": "對外網路",
    "fd_help": "共用機房或供電 = 同一個故障域（一次火災 / 停電兩邊一起沒）。IP 不同不算異地。",
    "fd_required_nvr": "NVR 互備要填兩端的場域、機房、供電、對外網路並確認現場。",
    "site_confirmed": "已到現場確認上面的故障域",
    "wz1": "來源 NVR 與通道",
    "wz2": "目的地",
    "wz3": "保留天數、速率、額度",
    "wz4": "容量試算",
    "wz5": "故障域",
    "wz6": "送出核准",
    "source_nvr": "來源 NVR",
    "no_nvr": "你擁有的$t(leaf.cur)裡沒有多通道的 NVR。",
    "channels": "通道",
    "stream_main": "主碼流",
    "stream_sub": "子碼流",
    "target": "目的地",
    "needs_target_approval": "目的地在別的$t(leaf.cur)，送出後要那個$t(leaf.cur)的擁有者核准。",
    "retention_days": "保留天數",
    "rate_limit": "速率上限（Mbps）",
    "unlimited": "不限",
    "policy_quota": "政策額度（GB）",
    "auto": "= 估算值",
    "estimate": "試算",
    "submit": "送出並核准來源方",
    "est_line": "碼率合計 {{bps}} × {{days}} 天 ≈ {{raw}}，加 {{oh}}% 開銷與 {{margin}}% 餘裕 = {{total}}",
    "est_assumed": "{{n}} 路沒有回報碼率，用假設值（主碼流 2 Mbps、子碼流 512 kbps）估。",
    "est_note": "以全時錄影的上限估算；上行與目的端寫入都要持續有這個頻寬。",
    "target_free": "目的地還可配 {{free}}",
    "not_offsite": "非異地",
    "incoming": "（別的$t(leaf.cur)送來的備份）",
    "pst_draft": "草稿",
    "pst_pending_approval": "待核准",
    "pst_validating": "檢查中",
    "pst_active": "運作中",
    "pst_degraded": "落後",
    "pst_paused": "已暫停",
    "pst_revoked": "已撤銷",
    "cov_ok": "已保護",
    "cov_degraded": "落後 > 120 秒",
    "cov_not_recording": "來源沒在錄",
    "cov_partial": "來源失聯，只到已知的位置",
    "cov_unknown": "未知",
    "tst_untested": "未測試",
    "tst_ok": "連線正常",
    "tst_failed": "測試失敗",
    "tst_disabled": "已停用",
    "policy_line": "{{ch}} 路 · 保留 {{days}} 天 · 額度 {{quota}} · 速率 {{rate}} · 版本 {{v}}",
    "target_view": "這裡只存對方的密文：{{n}} 個物件、{{bytes}}（沒有影片入口）",
    "cov_line": "最慢的通道已保護到 {{until}} · 最大落後 {{lag}} · 待傳 {{pending}} · 缺口 {{missing}} 段",
    "col_channel": "通道",
    "col_state": "狀態",
    "col_protected": "已保護到",
    "col_lag": "落後",
    "col_pending": "待傳",
    "col_missing": "缺口",
    "col_verified": "最後驗證",
    "approve_source": "核准（來源方）",
    "approve_target": "核准（目的方）",
    "pause": "暫停",
    "resume": "恢復",
    "revoke": "撤銷",
    "confirm_revoke": "撤銷這個政策？停止新備份；已存的副本依原保留期處理（不是刪除資料）。",
    "v_name": "名稱必填",
    "v_quota": "額度必填",
    "v_endpoint_s3": "端點寫成 https://主機[:埠]",
    "v_bucket": "bucket 名稱不對（小寫英數、點、減號）",
    "v_creds": "要填帳密",
    "v_proxy": "要選同站的代理設備",
    "v_endpoint_smb": "SMB 路徑寫成 //主機/分享名稱",
    "v_endpoint_nfs": "NFS 路徑寫成 主機:/export",
    "v_nvr": "要選目的 NVR",
    "v_kind": "種類不對",
    "err_ESCROW_UNAVAILABLE": "這個環境還沒設定金鑰託管，暫時不能保存 NAS 帳密。",
    "err_OWNER_REQUIRED": "只有$t(leaf.cur)擁有者能設定異地備份",
    "err_SOURCE_UNSUPPORTED": "這台 NVR 的韌體還不能做異地備份",
    "err_TARGET_UNSUPPORTED": "目的 NVR 的韌體還不能接收異地備份",
    "err_CAPACITY_INSUFFICIENT": "容量不足：{{message}}",
    "err_SAME_FAULT_DOMAIN": "同一個故障域：{{message}}",
    "err_FAULT_DOMAIN_REQUIRED": "{{message}}",
    "err_TARGET_IN_USE": "還有政策在用這個目的地",
    "err_POLICY_VERSION_MISMATCH": "政策內容已經改過，請重新整理後再核准",
    "err_VERSION_CONFLICT": "別人剛改過，請重新整理",
    "err_PERSONAL_NVR_BACKUP_UNSUPPORTED": "NVR 互備只給團體組織的$t(leaf.cur)",
    "err_SMB_LAN_ONLY": "SMB 只限同站區網",
    "err_RATE_LIMIT_TOO_LOW": "{{message}}",
    "restore": "復原",
    "restore_help": "把已驗證的備份副本寫回這個$t(leaf.cur)的一台 NVR（修好或替換的那台）。逐段驗證，可取消；寫回的片段仍屬於原本的攝影機，不會自動恢復攝影機帳密或網路設定。",
    "restore_target": "寫回哪台 NVR",
    "restore_start": "開始復原",
    "restore_line": "復原到 {{nvr}}：{{status}}（{{done}} / {{total}}，失敗 {{failed}}）",
    "rst_queued": "排隊中",
    "rst_running": "進行中",
    "rst_done": "完成",
    "rst_failed": "有失敗",
    "rst_canceled": "已取消",
    "from": "從",
    "to": "到",
    "purge": "清除備份資料",
    "confirm_purge": "清除這個政策在目的地上的所有副本？政策會一併撤銷。NVR 會逐一刪除物件，目的地離線時會顯示「等待刪除」。這個動作無法復原。",
    "rs_deleting": "刪除中 {{n}}",
    "rs_deletion_pending": "等待刪除 {{n}}（目的地未確認）",
    "rs_deleted": "已刪除 {{n}}",
    "rs_corrupt": "損壞 {{n}}",
    "rs_lost": "遺失 {{n}}",
    "err_RESTORE_UNSUPPORTED": "這台 NVR 的韌體還不能寫回備份",
    "err_NOTHING_TO_RESTORE": "這段時間沒有已驗證的副本",
    "need_target": "先新增目的地",
    "no_policies_need_target": "還沒有備份政策。先在上面新增目的地，才能建立備份政策。"
  },
  "aiCloud": {
    "title": "雲端 AI",
    "no_subscription": "還沒有雲端 AI 訂閱。",
    "go_billing": "到方案與帳單購買 →",
    "consented": "已同意",
    "consented_at": "{{at}} 同意",
    "excluded_help": "逐台排除（例如廁所附近、住戶區）：勾選的攝影機不會送雲端分析。",
    "exclude": "排除",
    "revoke": "撤回同意",
    "revoke_help": "撤回後 60 秒內停止送出；已產生的分析照事件保存期處理。",
    "outdated": "同意書已更新，請重新閱讀並同意。",
    "consent_body": "雲端 AI 會把移動事件發生時的雲端錄影片段畫面（事件當下與之後 2 秒共 3 張）送去分析：\n・用途：辨識畫面中的人、車、動物、包裹，過濾誤報；（選擇時）產生一句場景描述與衣著 / 車輛等屬性，供搜尋。\n・處理者：Kinio 自架的物件偵測模型（YOLOX）；場景描述由 Anthropic 的 Claude 產生。\n・保存：分析結果跟事件一起保存（30 天，有片段的照片段保存天數）；送出的畫面不另外保存。\n・不做：人臉辨識、身分推測；分析結果只是建議，不會控制任何設備。\n・只有已有雲端錄影的設備能分析；可以逐台排除，也可以隨時撤回。",
    "agree": "我已閱讀並同意以上內容",
    "grant": "同意並啟用",
    "grant_help": "需要重新驗證身分。",
    "need_org_admin": "要組織管理員才能同意。",
    "need_owner": "要$t(leaf.cur)擁有者才能同意。",
    "badge_confirmed": "雲端 AI 確認：{{what}}",
    "badge_no_target": "雲端 AI 判定非人車",
    "label_person": "人",
    "label_vehicle": "車",
    "label_animal": "動物",
    "label_package": "包裹",
    "err_CONSENT_TEXT_OUTDATED": "同意書已更新，請重新整理後再同意。",
    "err_NO_CONSENT": "目前沒有同意。",
    "err_VERSION_CONFLICT": "別人剛改過，已重新載入。",
    "err_USE_ORG_CONSENT": "團體組織$t(leaf.cur)的雲端 AI 同意由組織管理員給。",
    "err_FORBIDDEN": "你沒有這個操作的權限。",
    "pick_subject": "選一個組織或$t(leaf.cur)，看它的雲端 AI 同意與用量（會切換頁首範圍）。",
    "no_subject": "目前的範圍沒有可以訂閱雲端 AI 的組織或$t(leaf.cur)。",
    "consent_summary": "雲端 AI 會把事件當下的雲端錄影畫面送去分析（辨識人、車、動物、包裹，過濾誤報）；不做人臉辨識，可以逐台排除、隨時撤回。",
    "consent_more": "看完整說明"
  },
  "dset": {
    "confirm_streams": "這項設定會影響既有錄影與觀看（碼流 / 畫質會重新協商），確定要改嗎？",
    "timeout": "設備 25 秒內沒有確認",
    "load_offline": "設備離線或暫時無法讀取設定",
    "load_error": "讀取設定失敗",
    "none": "這台設備沒有可在網頁調整的設定",
    "use_app": "請用設備 App 操作",
    "owner_only": "僅擁有者",
    "pending": "套用中",
    "applied": "已套用",
    "adjusted": "設備採用了不同的值",
    "failed": "失敗",
    "unknown": "未回報",
    "streams_title": "會影響既有錄影與觀看",
    "streams_body": "碼流 / 畫質會重新協商，正在觀看與錄影的畫面會中斷幾秒。",
    "tech_title": "技術設定改錯可能讓設備斷線或停止錄影",
    "tech_body": "這是安裝商 / 工程用的設定；改之前確認你知道這個值的影響。",
    "tech_help": "安裝商 / 工程用的設定：改錯可能斷線、停止錄影或違反法規。每次修改都會先確認。",
    "tech_none": "這台設備沒有技術設定",
    "change_body": "「{{label}}」改成 {{value}}",
    "apply_change": "修改「{{label}}」",
    "segment_switch": "切換成「{{label}}」",
    "depends_on": "先開啟「{{parent}}」才能調整",
    "depends_value": "「{{parent}}」設成 {{values}} 時才能調整",
    "advanced_n": "進階（{{n}}）",
    "sections": "設定分區",
    "val_free": "（可用 {{v}}）",
    "val_none": "沒有",
    "val_locked": "未設定",
    "val_unknown": "未知",
    "val_never": "不會過期",
    "vendor_fw": "原廠韌體版本",
    "auto_apply": "改了就會套用到設備，不用按儲存。",
    "ch_summary": "{{online}} 路在線 / 共 {{total}} 路",
    "ch_summary_label": "通道",
    "val_on": "開",
    "val_off": "關",
    "val_present": "有",
    "val_absent": "沒有",
    "read_only_section": "這些是設備回報的資訊，不能在這裡改。",
    "ttl_dut_model": "{{label}}（{{model}}）",
    "ttl_dut_aid": "AID {{aid}}",
    "ttl_token_set_label": "UART（TTL）密鑰已設定",
    "ttl_rx_at_label": "UART（TTL）最後有輸出",
    "quality_res_named": "{{name}}（{{dims}}）"
  },
  "ddev": {
    "not_found": "找不到這台設備，或你沒有權限。",
    "back": "返回設備列表",
    "tab_overview": "概覽",
    "tab_live": "即時與回放",
    "tab_channels": "通道",
    "tab_settings": "設定",
    "tab_recording": "錄影與儲存",
    "tab_events": "事件",
    "tab_health": "健康與韌體",
    "tab_links": "關聯",
    "status": "狀態",
    "media_status": "媒體狀態",
    "capabilities": "能力",
    "storage": "儲存",
    "no_events": "過去 24 小時沒有事件",
    "links_hint": "把這個感測器關聯到攝影機：事件卡片與彈窗會帶出關聯攝影機同時刻的畫面。",
    "tab_site": "現場設備",
    "tab_ai": "AI",
    "tab_firmware": "韌體",
    "tab_location": "位置",
    "tab_audit": "稽核",
    "ai_unavailable": "AI 運算資訊暫時讀不到",
    "ai_none": "這台攝影機還沒指派 AI 分析",
    "ai_open": "到 AI 分析頁",
    "fw_unavailable": "韌體狀態暫時讀不到（或這台不經平台更新）",
    "fw_available": "可用更新",
    "fw_latest": "已是最新",
    "fw_auto": "自動更新",
    "fw_update_now": "立即更新",
    "fw_confirm": "現在更新韌體 {{v}}？更新中設備會重新開機。",
    "fw_started": "已送出更新，設備會在下載完成後重新開機",
    "fw_via_app": "這台由 App 轉交更新，請用 App 完成",
    "site": "場域",
    "geo": "地圖座標",
    "floorplan": "平面圖",
    "open_map": "到地圖",
    "tab_analytics": "智慧分析",
    "tab_technical": "技術",
    "tab_nodes": "節點",
    "tab_advanced": "進階",
    "maintenance": "維護",
    "open_playback": "在回放頁開啟",
    "last_seen": "最後上線",
    "fw_short": "韌體 {{v}}",
    "fw_has_update": "（有新版）",
    "fw_is_latest": "（最新）",
    "fw_all": "看全部設備的韌體 →",
    "path": "所在位置",
    "reboot_hint": "設備會離線約 1–2 分鐘，期間不會錄影。",
    "support_title": "複製給客服",
    "support_hint": "客服需要時再複製；這些代碼不會出現在一般畫面。",
    "support_copy": "複製",
    "support_copied": "已複製",
    "ai_provider_unnamed": "未命名的 AI 運算設備",
    "maintenance_sub": "重新開機、解除綁定",
    "rec_settings": "錄影與儲存的設定",
    "ch_summary_one": "{{count}} 路",
    "ch_summary_other": "{{count}} 路",
    "ch_summary_off_one": "{{count}} 路離線",
    "ch_summary_off_other": "{{count}} 路離線",
    "ch_view": "看通道",
    "adv_diag": "診斷",
    "adv_diag_sub": "序列埠終端機，安裝與開發用",
    "adv_diag_dut": "接的是 {{name}}",
    "ev_recording": "錄影片段",
    "ev_open_in_events": "在事件頁開啟",
    "ev_only_recording": "這 24 小時只有錄影片段，沒有事件；勾「錄影片段」可以看。",
    "sd_no_capacity": "SD 卡 · 讀不到容量（設備沒有回報）",
    "sd_no_capacity_tip": "插著 SD 卡，但設備沒有回報容量；可以到「錄影與儲存」看錄影狀態。",
    "no_snapshot": "還沒有快照",
    "watch_live": "看即時",
    "rec_settings_fold_one": "錄影與儲存的設定（{{count}} 項）",
    "rec_settings_fold_other": "錄影與儲存的設定（{{count}} 項）",
    "ev_system_hint": "「系統」是設備自己的狀態變化（上線 / 離線、重新開機、串流或錄影開始 / 結束），不是偵測到的事；平常不用處理。這些狀態紀錄只在這裡列，不進事件頁的搜尋與統計（所以事件頁的「系統」可能比這裡少）。",
    "ev_system_generic": "設備狀態變化",
    "recent_events": "最近事件",
    "recent_none": "最近 7 天沒有事件。",
    "recent_all": "看這台的全部事件 ▸",
    "ev_lasted": "（持續 {{dur}}）",
    "ev_window": "過去 24 小時",
    "change_wifi": "更換 Wi-Fi",
    "change_wifi_app": "請用手機 App 更換：手機要在設備旁邊，用藍牙或設備的熱點把新的 Wi-Fi 交給它。"
  },
  "health": {
    "title": "健康",
    "level_ok": "正常",
    "level_warn": "注意",
    "level_alert": "異常",
    "level_unknown": "未回報",
    "free": "可用",
    "retention_days_one": "預估可保存 {{count}} 天",
    "retention_days_other": "預估可保存 {{count}} 天",
    "reason_smart": "SMART 異常",
    "reason_disk_error": "硬碟錯誤",
    "reason_disk_full": "硬碟已滿",
    "reason_no_disk": "沒有偵測到硬碟",
    "reason_almost_full": "空間不足 5%（未開覆寫）",
    "rate": "目前錄影位元率 {{kbps}} kbps",
    "no_rate": "設備沒有回報錄影位元率，無法估算保存天數",
    "disk_model": "型號 / 序號",
    "disk_state": "狀態",
    "capacity": "可用 / 總容量",
    "no_disks": "設備沒有回報個別硬碟資訊",
    "online_rate": "設備在線率",
    "recorders": "錄影主機",
    "recorders_bad": "異常 / 總數",
    "min_retention": "最短預估保存",
    "days_one": "{{count}} 天",
    "days_other": "{{count}} 天",
    "offline_list": "離線設備（{{n}}）",
    "smart_ok": "正常",
    "smart_warn": "注意",
    "smart_fail": "異常",
    "smart_unknown": "未知",
    "smart_temp": "{{c}} °C",
    "smart_poh": "通電 {{h}} 小時",
    "smart_sectors": "重新配置 {{realloc}}、待處理 {{pending}}、無法修正 {{uncorr}} 個扇區",
    "smart_test_run": "自我測試",
    "smart_test_sent": "已送出自我測試（約 2 分鐘）",
    "smart_test_running": "自我測試進行中",
    "smart_test_pass": "上次自我測試：通過",
    "smart_test_fail": "上次自我測試：未通過",
    "smart_test_aborted": "上次自我測試：已中止",
    "smart_test_weekly": "每週自動",
    "reason_smart_warn": "SMART 需注意",
    "overwrite": "錄影覆寫",
    "overwrite_auto": "自動覆寫",
    "overwrite_off": "不覆寫（滿了會停錄）",
    "overwrite_days_one": "保留 {{count}} 天",
    "overwrite_days_other": "保留 {{count}} 天",
    "rec_space": "錄影空間",
    "disk_space": "磁碟空間",
    "kind_hdd": "HDD",
    "kind_ssd": "SSD",
    "kind_sd": "SD 卡",
    "kind_usb": "USB",
    "kind_flash": "內建 flash",
    "kind_disk": "硬碟",
    "disks_title": "實體碟",
    "volume_title": "錄影卷",
    "legacy_note": "這台設備回報的是錄影卷（舊格式），沒有個別實體碟與儲存池資訊",
    "disk_kind": "類型",
    "disk_record": "錄影碟",
    "record_yes": "是",
    "record_no": "否",
    "physical_capacity": "實體容量",
    "pools_title": "儲存池",
    "no_pools": "設備沒有回報儲存池",
    "pool_role": "用途",
    "role_record": "錄影",
    "role_system": "系統",
    "role_index": "索引",
    "pool_disk": "所在碟",
    "pool_part": "分割",
    "pool_capacity": "容量",
    "pool_used": "用量",
    "pool_in_use": "使用中",
    "pool_idle": "尚未啟用",
    "retention_basis": "預估保存天數以錄影空間 {{total}} 計算，不是實體碟容量",
    "cert": "憑證到期",
    "cert_note_one": "已過期或 {{count}} 天內到期",
    "cert_note_other": "已過期或 {{count}} 天內到期",
    "cert_expired": "憑證已過期（{{date}}）",
    "cert_soon": "憑證 {{date}} 到期",
    "firmware": "韌體合規",
    "firmware_note": "已是可用的最新版 / 全部",
    "fw_update": "有新韌體（目前 {{v}}）",
    "seats": "雲錄席次",
    "seats_note": "已指派 / 生效中",
    "ai": "AI 額度（本月）",
    "backup": "備份覆蓋",
    "backup_note": "正常 / 啟用中的政策",
    "backup_degraded": "{{n}} 個政策落後或中斷",
    "rec_gaps": "24 小時錄影缺口",
    "rec_gaps_note": "有缺口 / 全時錄影的攝影機",
    "rec_gap_item": "過去 24 小時有錄影缺口",
    "attention": "需要注意",
    "not_enabled": "未啟用",
    "setup": "設定",
    "unknown": "讀不到",
    "unknown_n_one": "讀不到（{{count}} 台沒回報）",
    "unknown_n_other": "讀不到（{{count}} 台沒回報）",
    "dstate_normal": "正常",
    "dstate_ok": "正常",
    "dstate_degraded": "降級",
    "dstate_error": "錯誤",
    "dstate_failed": "故障",
    "dstate_missing": "找不到",
    "dstate_readonly": "唯讀",
    "dstate_full": "已滿",
    "dstate_unformatted": "未格式化",
    "seats_home_plan_one": "另有 {{count}} 台由$t(leaf.cur)方案提供雲錄",
    "seats_home_plan_other": "另有 {{count}} 台由$t(leaf.cur)方案提供雲錄",
    "watch_playback": "看回放",
    "rec_gaps_off": "只檢查全時雲錄的攝影機；目前沒有",
    "space_unknown": "讀不到容量",
    "usb_stick": "USB 隨身碟",
    "cap_used_total_free": "已用 {{used}} / 共 {{total}}（可用 {{free}}）",
    "cap_total": "共 {{total}}",
    "reason_other": "儲存狀態異常",
    "reason_sd_abnormal": "記憶卡異常",
    "reason_sd_no_space": "記憶卡已滿，已停止錄影",
    "reason_sd_needs_format": "記憶卡需要格式化",
    "days_lt1": "不到 1 天（約 {{h}} 小時）",
    "retention_lt1": "預估可保存不到 1 天（約 {{h}} 小時）",
    "sd_looping": "共 {{total}} · 循環錄影中",
    "sd_looping_note": "卡滿後會自動蓋掉最舊的錄影，不會停止錄影",
    "rec_gaps_off2": "目前沒有全時雲錄或本地錄影的攝影機",
    "rec_gaps_note2": "過去 24 小時 · 雲端 {{cloud}} 台、本地 {{local}} 路",
    "gap_reason_source_unreachable": "收不到影像",
    "gap_reason_storage_full": "硬碟滿了",
    "gap_reason_storage_error": "錄影硬碟異常",
    "gap_reason_recorder_restart": "錄影主機重開機",
    "gap_reason_unknown": "原因不明",
    "rec_gaps_unreported_one": "另有 {{count}} 路本地錄影沒回報",
    "rec_gaps_unreported_other": "另有 {{count}} 路本地錄影沒回報"
  },
  "rpol": {
    "enable_cloud": "開啟雲端錄影",
    "enable_sd": "開啟記憶卡錄影",
    "confirm_cloud": "開啟雲端錄影會關閉記憶卡錄影，之後的錄影只上傳雲端（有記憶卡時仍做斷網暫存）。",
    "confirm_sd": "開啟記憶卡錄影會關閉雲端錄影，之後的錄影只存在記憶卡。",
    "confirm_sd_seat": "這台已指派雲端席次，關閉後席次閒置但仍計費，可到方案頁改派。",
    "no_recording": "目前沒有錄影",
    "device_mode": "設備",
    "mode_continuous": "全時錄影",
    "mode_event": "有動靜才錄",
    "mode_unknown": "未回報",
    "cloud": "雲端錄影",
    "cloud_on": "生效中（{{mode}}）",
    "cloud_off": "未生效",
    "retention": "雲端保存",
    "days_one": "{{count}} 天",
    "days_other": "{{count}} 天",
    "follows_plan": "依方案 / 席次",
    "owner_only": "錄影政策只有$t(leaf.cur)擁有者能改。",
    "mode_scheduled": "依排程",
    "mode_off": "不錄影",
    "cloud_policy_note": "雲端全時錄影中，本機也全天錄；關掉雲錄後回到此排程。",
    "cloud_mode": "雲端什麼時候錄",
    "continuous_coming_soon": "全時錄影即將開放",
    "err_FEATURE_DISABLED": "全時錄影即將開放，目前只提供事件錄影。",
    "capplied_applied": "設備已套用",
    "capplied_not_applied": "設備尚未套用",
    "capplied_unknown": "等待設備回報",
    "capplied_days_one": "（設備端保存 {{count}} 天）",
    "capplied_days_other": "（設備端保存 {{count}} 天）",
    "src_seat": "由「{{name}}」的雲錄席次提供",
    "src_seat_plain": "由雲錄席次提供",
    "src_home_plan": "由$t(leaf.cur)方案「{{plan}}」提供",
    "src_home_plan_plain": "由$t(leaf.cur)方案提供",
    "src_grant": "由合約「{{plan}}」提供",
    "src_grant_plain": "由合約提供",
    "src_until": "，到 {{date}}",
    "src_exempt": "未套用方案（開發環境豁免）",
    "src_none": "沒有指派雲錄席次",
    "assign_seat": "指派席次",
    "cloud_on_exempt": "錄影中（{{mode}}）· 未套用方案（開發環境豁免）",
    "cloud_on_plain": "生效中",
    "cloud_unsupported": "這台攝影機不支援雲端錄影（機種限制）",
    "reason_not_supported": "這台攝影機不支援雲端錄影（機種限制）",
    "reason_plan_no_cloud": "$t(leaf.cur)的方案不含雲端錄影",
    "reason_home_disabled": "這個$t(leaf.cur)的雲端錄影已暫停（請聯絡服務商）",
    "reason_disabled": "這台的雲端錄影已關閉",
    "reason_mode_not_in_plan": "選的錄影方式不在方案內，改用事件錄影",
    "reason_camera_limit": "方案的攝影機台數已滿",
    "reason_continuous_paused": "全時錄影即將開放，目前用事件錄影",
    "reason_other": "雲端錄影目前沒有生效",
    "col_where": "錄到哪裡",
    "col_when": "什麼時候錄",
    "where_sd": "記憶卡",
    "where_recorder": "錄影主機",
    "cloud_switch": "開啟",
    "status_label": "狀態：",
    "platform_state": "平台{{state}}"
  },
  "evd": {
    "watch_recording": "看錄影",
    "sd_offline": "這段錄在攝影機的記憶卡上，攝影機連線後才能看",
    "no_recording": "事件發生時沒有錄影",
    "open": "詳細",
    "back": "返回事件",
    "time": "時間",
    "class": "分類",
    "device": "設備",
    "ai": "AI 分析",
    "phase_started": "開始",
    "phase_ended": "結束",
    "phase_instant": "單次",
    "fields": "原始欄位",
    "clip": "前後片段",
    "no_cloud_clip": "這段時間沒有雲端片段；可到回放頁看設備本地錄影。",
    "open_playback": "在回放頁開啟",
    "related": "關聯攝影機（同時刻）",
    "cycle": "這次事件的開始與結束",
    "not_found": "這則事件找不到了：可能超過保存期限或已刪除。",
    "back_list": "回事件列表",
    "looking": "正在讀取這則事件…",
    "cycle_dur": "這次{{name}}持續 {{dur}}",
    "cycle_open": "這次{{name}}還沒有結束（或結束的紀錄還沒進來）",
    "cycle_no_end": "還沒結束",
    "cycle_this": "這一筆",
    "dur_s": "{{s}} 秒",
    "dur_ms": "{{m}} 分 {{s}} 秒",
    "dur_hm": "{{h}} 小時 {{m}} 分",
    "clip_suspect": "這段雲端片段可能不完整（片段長度跟事件對不上），畫面可能是綠色或停住；只播事件前後 30 秒。可以在回放頁改看其他來源。",
    "clip_suspect_local": "改看{{src}}",
    "cycle_no_end_record": "沒有收到這次{{name}}的結束紀錄（開始後超過 10 分鐘），持續多久不知道",
    "cycle_end_only": "這是{{name}}的結束紀錄；開始的紀錄不在前後 15 分鐘內",
    "cycle_open_start": "看開始那筆 ▸",
    "clip_checking": "正在查這段時間有沒有雲端片段…",
    "clip_unreadable": "讀不到這段片段。",
    "dur_lt1": "不到 1 秒"
  },
  "unbind": {
    "title": "解除綁定",
    "explain": "把這台設備從$t(leaf.cur)移除。",
    "reset": "設備會收到重置指令，回到可重新配對的狀態（離線時下次連線才會重置）。",
    "history": "歷史錄影與事件留在原$t(leaf.cur)，不會跟著設備走。",
    "children_one": "底下 {{count}} 個通道 / 子設備一起移除。",
    "children_other": "底下 {{count}} 個通道 / 子設備一起移除。",
    "button": "解除綁定",
    "confirm": "確定要解除綁定「{{name}}」？請輸入設備 ID 最後 4 碼「{{code}}」確認。",
    "type_code": "設備 ID 最後 4 碼"
  },
  "pair": {
    "open": "新增設備",
    "title": "新增 Kinio 設備",
    "no_home": "你沒有可以新增設備的$t(leaf.cur)（需要擁有者或管理員）。",
    "method": "配對方式",
    "method_lan": "有線（輸入配對碼）：NVR、Kinio Station、AI box 在本機畫面輸入配對碼",
    "method_qr": "掃 QR：讓攝影機鏡頭掃這個頁面上的 Wi-Fi 與配對碼",
    "method_app": "藍牙或設備熱點（用手機 App）：App 掃這個 QR 後再掃設備標籤",
    "aid_hint": "在設備底部標籤或 NVR 本機畫面的「設備資訊」，格式 CNV-XXXXXXXXXXXXXXXX-X",
    "err_BAD_DEVICE_REF": "設備 ID 格式不對",
    "err_MODEL_NOT_AVAILABLE_FOR_BRAND": "這個品牌目前不提供 Kinio Station / Kinio Node",
    "start": "產生配對碼",
    "bound": "{{aid}} 已加入$t(leaf.cur)。",
    "open_device": "開啟設備",
    "status_failed": "配對失敗",
    "status_canceled": "已取消",
    "status_expired": "配對碼已過期",
    "status_pending": "等待設備兌換",
    "status_connected": "設備已連上，完成綁定中",
    "again": "重新配對",
    "enter_on_device": "在設備本機的「雲端配對」畫面輸入以下配對碼：",
    "code": "配對碼",
    "url": "兌換位址",
    "expires_in": "{{m}}:{{s}} 後過期",
    "cancel": "取消配對",
    "method_app_unavailable": "（這個品牌沒有 App 入口網站，無法產生 App 連結）",
    "wifi_ssid": "Wi-Fi 名稱",
    "wifi_psk": "Wi-Fi 密碼（開放網路留空）",
    "wifi_note": "Wi-Fi 密碼只放進這個頁面上的 QR，不會送到雲端或被儲存。",
    "err_SSID_REQUIRED": "請輸入 Wi-Fi 名稱",
    "err_SSID_TOO_LONG": "Wi-Fi 名稱超過 32 位元組",
    "err_PSK_LENGTH": "Wi-Fi 密碼要 8–63 個字元（或 64 位十六進位）",
    "err_BAD_SESSION": "配對資料不完整，請重新配對",
    "show_qr": "顯示 QR",
    "show_qr_again": "再顯示 QR",
    "hide_qr": "隱藏 QR",
    "qr_hidden": "QR 已隱藏（顯示 5 分鐘後自動隱藏）。",
    "qr_auto_hide": "{{m}}:{{s}} 後自動隱藏",
    "scan_with_camera": "讓攝影機處於配對狀態，把 QR 對著鏡頭（約 20–40 公分），聽到提示音後等它連線。",
    "scan_with_app": "用手機 App 的「新增設備」掃這個 QR，再依指示掃設備標籤。App 不必是這個$t(leaf.cur)的成員。",
    "qr_alt_kwf": "給攝影機掃的 Wi-Fi 與配對碼 QR",
    "qr_alt_app": "交給 App 的配對連結 QR",
    "kind_camera": "攝影機",
    "kind_doorbell": "門鈴",
    "kind_nvr": "NVR",
    "kind_station": "Station",
    "kind_sensor": "感測器",
    "kind_light": "燈",
    "kind_lock": "門鎖",
    "kind_plug": "插座",
    "kind_frame": "相框",
    "kind_other": "設備",
    "bound_name_title": "已加入$t(leaf.cur)。幫這台設備取個名字",
    "name_label": "設備名稱",
    "name_hint": "推播、App 與 VMS 都會顯示這個名字（1–32 字）。略過就用預填的名字。",
    "err_INVALID_NAME": "名稱要 1–32 字、不能有控制字元",
    "name_failed": "名稱沒存成功，請再試一次",
    "name_forbidden": "你不能改這台設備的名字（需要$t(leaf.cur)擁有者或管理員），之後可以請他們改。",
    "name_skip": "略過",
    "name_save": "儲存名稱",
    "aid_label": "設備編號",
    "aid_demo_title": "標籤上的「設備編號」"
  },
  "layouts": {
    "pick": "版面…",
    "save": "儲存版面",
    "save_as": "另存版面",
    "delete": "刪除版面",
    "delete_confirm": "刪除版面「{{name}}」？",
    "name": "名稱",
    "scope": "誰看得到",
    "scope_user": "只有我",
    "scope_org": "組織共用：{{org}}",
    "denied_dropped": "沒有權限的格子不會存進新版面。",
    "no_permission": "無權限",
    "err_CELL_FORBIDDEN": "有格子是你沒有觀看權限的攝影機",
    "err_VERSION_CONFLICT": "版面已被別人改過，請重新載入",
    "none": "還沒有存過版面",
    "manage": "管理版面…"
  },
  "bm": {
    "add": "書籤",
    "need_time": "先播放或選一個時間點",
    "title": "標題",
    "note": "註記",
    "length": "長度",
    "len_s": "{{n}} 秒",
    "len_point": "時間點",
    "visibility": "誰看得到",
    "vis_private": "只有我",
    "vis_home": "$t(leaf.cur)成員",
    "list": "書籤"
  },
  "subg": {
    "panel_hint": "已加入 {{n}} 台（上限 {{max}}）。貼 QR 的子設備要掃 QR 才加得進來。",
    "region": "地區 {{r}}",
    "add": "加入子設備",
    "need_admin": "加入子設備需要$t(leaf.cur)擁有者或管理員。",
    "none": "還沒有子設備。",
    "col_slot": "槽位",
    "col_mode": "加入方式",
    "mode_qr": "QR 白名單",
    "mode_permit": "限時開放（未認證）",
    "title": "加入子設備",
    "method": "加入方式",
    "method_scan": "用攝影機掃子設備上的 QR",
    "method_manual": "手動輸入（QR 內容或 EUI + 安裝碼）",
    "method_permit": "不需 QR 的子設備：限時開放加入",
    "qr_text": "QR 內容",
    "or_fields": "或輸入標籤上的 EUI 與安裝碼：",
    "is_code": "安裝碼（IS）",
    "is_hint": "26 碼英數字（A–Z、2–7），標籤上 QR 旁邊印的那一串。",
    "smartstart": "SmartStart：子設備上電就自動加入（窗口 24 小時）",
    "permit_explain": "閘道會開放 120 秒，期間按下子設備的配對鍵。只給不需要 QR 的子設備；貼 QR 的子設備請掃 QR。",
    "permit_warn": "這條路沒有安裝碼認證，只擋被動竊聽、擋不了主動冒充。",
    "start": "開始加入",
    "permit_start": "開放 120 秒",
    "wait_qr": "閘道已把 {{eui}} 加入白名單。請長按子設備的按鍵 5 秒（或裝上電池）。",
    "wait_qr_smart": "閘道已把 {{eui}} 加入白名單（SmartStart）。子設備上電就會自動加入。",
    "wait_permit": "閘道正在開放加入。請按下不需 QR 的子設備的配對鍵。",
    "left": "剩 {{m}}:{{s}}",
    "closed_found": "加入窗口已關閉，這次加入了 {{n}} 台。",
    "closed_none": "加入窗口已關閉，沒有子設備加入。確認子設備在閘道附近、已長按 5 秒，再試一次。",
    "stop": "停止加入",
    "again": "再加一台",
    "joined": "新子設備：CH{{slot}}",
    "name_for": "CH{{slot}} 的名稱",
    "location": "位置（場域）",
    "location_keep": "（不指定）",
    "location_personal": "這個$t(leaf.cur)的組織只有一個場域，不用指定位置；可以在地圖頁擺放。",
    "to_map": "前往地圖",
    "saved": "已儲存「{{name}}」",
    "scan_unsupported": "這個瀏覽器不支援攝影機掃描（需要 Chrome / Edge），請改用手動輸入。",
    "scan_denied": "無法使用攝影機（沒有權限或沒有攝影機），請改用手動輸入。",
    "scan_hint": "把子設備上的 QR 對準鏡頭。",
    "scan_start": "開啟攝影機",
    "err_other": "加入失敗（{{code}}）",
    "err_qr_not_subg": "這不是 Kinio 子設備的 QR（要 KSG:1 開頭）。",
    "err_qr_version": "不支援這個版本的 QR。",
    "err_qr_format": "QR 內容格式不對。",
    "err_qr_eui": "EUI 要 16 個十六進位字元。",
    "err_qr_is": "安裝碼不對（26 碼，A–Z 與 2–7）。",
    "err_INVALID_QR": "QR 內容或安裝碼不對。",
    "err_QR_DEVICE_NOT_ALLOWED": "貼 QR 的子設備不能用限時開放加入，請掃 QR。",
    "err_CAPABILITY_NOT_SUPPORTED": "這台設備不能加入子設備。",
    "err_GATEWAY_OFFLINE": "閘道不在線。",
    "err_GATEWAY_TIMEOUT": "閘道沒有回應。",
    "err_GATEWAY_ERROR": "閘道拒絕了（允許清單滿了或正在忙），稍後再試。",
    "err_FORBIDDEN": "沒有權限。",
    "err_INVALID_NAME": "名稱要 1–64 字。",
    "remove": "移除",
    "removing": "移除中（等閘道確認）",
    "remove_confirm": "要移除「{{name}}」嗎？子設備下次回報時會解除配對，之後要重新掃 QR 才能再加入。"
  },
  "inbox": {
    "title": "通知",
    "title_n": "通知（未讀 {{n}}）",
    "mark_all": "全部標為已讀",
    "mark_read": "標為已讀",
    "empty": "沒有通知",
    "failed": "通知收件匣暫時讀不到",
    "mfa_alarm_title": "{{from}}有一則警報",
    "mfa_alarm_body": "開啟兩步驟驗證並重新登入後才看得到內容。",
    "mfa_alarm_back": "我已設定，回到這則警報",
    "mfa_alarm_someone": "委派方",
    "alarm_title": "警報 · {{name}}",
    "untitled": "通知",
    "view": "查看",
    "open": "開啟",
    "dismiss_tip": "關掉（不標為已讀）",
    "more_n_one": "還有 {{count}} 則通知",
    "more_n_other": "還有 {{count}} 則通知",
    "bell_tip": "未讀通知 {{n}} 則（跟選單「事件與警報」旁的未處理警報數不同）",
    "times_n": "× {{n}} 次（最早 {{since}}）",
    "times_only": "× {{n}} 次",
    "empty_alarms": "沒有新通知；還有 {{count}} 則警報沒處理。",
    "go_alarms": "去處理"
  },
  "devpolicy": {
    "title": "MyCam 設備與 AI 政策",
    "hint": "套用到這個組織所有場域的手機攝影機與電腦端。每一項改了就儲存（需要重新驗證）。",
    "k_soft_device_require_attestation": "只收通過完整性檢查（verified）的設備",
    "k_soft_device_lock_settings": "鎖定設定（手機使用者不能改被鎖定的設定）",
    "k_soft_device_allow_audio_record": "允許錄音",
    "k_ai_byo_cloud_allowed": "允許自帶雲端 AI",
    "k_soft_device_allow_personal_account": "允許個人帳號加入設備",
    "by_platform": "平台在啟用時檢查",
    "by_app": "由 MyCam App 照做",
    "by_pending": "成員能不能把個人手機當這個組織的 MyCam 設備，怎麼判斷尚未決定，暫不能改"
  },
  "dhealth": {
    "cert": "憑證到期",
    "cert_expired": "已過期",
    "cert_soon": "30 天內到期",
    "wifi": "Wi-Fi 訊號",
    "temperature": "機體溫度",
    "mac": "MAC 位址",
    "netifs": "網路介面",
    "if_name": "介面",
    "if_kind": "種類",
    "if_kind_wifi": "Wi-Fi",
    "if_kind_wired": "有線",
    "if_kind_cellular": "行動網路",
    "if_up": "連線",
    "if_up_yes": "已連線",
    "if_up_no": "未連線"
  },
  "tour": {
    "open": "輪巡",
    "title": "輪巡設定",
    "interval": "每頁停留",
    "seconds": "{{n}} 秒",
    "mode": "輪巡內容",
    "mode_cameras": "攝影機清單",
    "mode_layouts": "版面",
    "cameras_hint": "依目前 {{size}} 格分頁，共 {{pages}} 頁",
    "no_layouts": "還沒有存過版面",
    "start": "開始輪巡",
    "running": "輪巡中：第 {{i}} / {{n}} 頁",
    "next_in": "{{s}} 秒後換頁",
    "pause": "暫停",
    "resume": "繼續",
    "stop": "停止"
  },
  "nset": {
    "global_title": "通知（我的）",
    "home_title": "$t(leaf.cur)的通知",
    "home": "$t(leaf.cur)",
    "no_home": "沒有可以設定通知的$t(leaf.cur)",
    "unavailable": "通知設定暫時讀不到",
    "quiet": "勿擾時段",
    "quiet_start": "開始",
    "quiet_end": "結束",
    "quiet_clear": "取消勿擾",
    "quiet_hint": "時區 {{tz}}；勿擾時只進收件匣，警報照送",
    "email_alerts": "事件通知也寄 email",
    "hide_details": "鎖定畫面隱藏細節",
    "thumbnails": "通知附縮圖",
    "category": "類別",
    "ch_inbox": "收件匣",
    "ch_push": "App 推播",
    "ch_email": "Email",
    "forced": "不可關閉",
    "per_device": "個別攝影機的偵測通知",
    "follow_home": "跟$t(leaf.cur)設定",
    "cat": {
      "security_alarm": "警報（布防中）",
      "device_detection": "偵測（人、車、動作…）",
      "device_doorbell": "門鈴",
      "device_call": "設備呼叫",
      "device_status": "設備狀態（離線、儲存、錄影中斷、備份）",
      "device_ota": "韌體更新",
      "security_mode": "布撤防變更",
      "home_access": "$t(leaf.cur)成員與綁定",
      "account_security": "帳號安全",
      "billing_subscription": "訂閱與付款",
      "support_reply": "客服回覆",
      "care_service": "關懷提醒",
      "andrew_insight": "AI 管家的提醒與建議",
      "automation_notify": "自動化規則",
      "hw_review": "硬體審核",
      "org_notice": "組織公告",
      "account_privacy": "隱私與資料請求",
      "sleep_report_ready": "睡眠報告"
    },
    "ai_confirmed_only": "只通知雲端 AI 確認的偵測（該攝影機有開雲端 AI 時；60 秒沒結果照常送）",
    "cat_other": "其他通知",
    "part_local": "浮動通知與彈窗（這台電腦）",
    "part_receive": "我要收哪些通知",
    "part_subs": "訂閱的場域與群組",
    "float_intro": "右下角的浮動通知：警報一律用警報卡（先顯示快照、可直接處理，按〔看即時〕才開影像）；其他通知照下面的檔位跳。同一則只跳一次，20 秒沒動就收成一條細條。"
  },
  "rules": {
    "no_home": "沒有可以設定規則的$t(leaf.cur)",
    "home": "$t(leaf.cur)",
    "unavailable": "規則暫時讀不到",
    "from_template": "從範本建立",
    "new_json": "進階：用 JSON 編輯",
    "enabled": "啟用",
    "kind_automation": "自動化",
    "kind_scene": "場景",
    "placement_cloud": "雲端執行",
    "placement_local": "本地執行",
    "pending_sync": "設備還沒同步",
    "never": "還沒執行過",
    "result_ok": "上次成功",
    "result_failed": "上次失敗",
    "result_skipped": "上次跳過",
    "fires": "共 {{n}} 次",
    "run": "執行",
    "runs": "執行紀錄",
    "edit": "編輯",
    "delete": "刪除",
    "delete_confirm": "刪除規則「{{name}}」？",
    "last_error": "第 {{n}} 個動作失敗：{{reason}}",
    "runs_local": "本地執行的規則紀錄在設備上，這裡只顯示上次結果",
    "run_time": "時間",
    "run_trigger": "觸發",
    "run_status": "結果",
    "run_error": "失敗原因",
    "trigger_manual": "手動",
    "run_error_at": "第 {{n}} 個動作：{{reason}}",
    "runs_empty": "7 天內沒有執行",
    "status_pending": "等待中",
    "status_running": "執行中",
    "status_done": "完成",
    "status_failed": "失敗",
    "status_canceled": "取消",
    "reason_device_offline": "設備離線",
    "reason_running": "前一次還在跑",
    "reason_forbidden": "權限不足",
    "template": "範本",
    "tpl_door_record_notify": "門磁開 → 錄影 + 通知",
    "tpl_door_record_notify_text": "門被打開了",
    "tpl_door_record_notify_hint": "門窗感測器打開時，關聯攝影機開始錄影並發通知（彈窗在設備「關聯」設定）",
    "tpl_armed_pir_siren": "布防中 PIR → 警報器 + 通知",
    "tpl_armed_pir_siren_text": "布防中偵測到有人",
    "tpl_armed_pir_siren_hint": "外出 / 夜間布防時 PIR 觸發：警報器響並發通知",
    "tpl_ai_person_notify": "AI 偵測到人 → 通知",
    "tpl_ai_person_notify_text": "偵測到人",
    "tpl_ai_person_notify_hint": "攝影機的 AI 偵測到人時發通知",
    "role_sensor": "感測器",
    "role_camera": "攝影機",
    "role_siren": "警報器",
    "optional": "（可不選）",
    "pick": "請選擇",
    "none_capable": "這個$t(leaf.cur)沒有符合的設備",
    "name": "名稱",
    "notify_text": "通知內容",
    "notify_off": "這個環境不提供規則通知，範本只會建立設備動作",
    "create": "建立",
    "edit_title": "編輯「{{name}}」",
    "json_hint": "規則分三段：觸發（triggers）、條件（conditions）、動作（actions）。存檔前會先檢查格式；規則在設備上還是雲端執行由系統決定。",
    "json": "規則 JSON",
    "bad_json": "JSON 格式不對",
    "valid": "驗證通過：{{placement}}",
    "validate": "驗證",
    "err_RULE_INVALID": "規則不合法，請看問題清單",
    "err_RULE_RUNNING": "前一次還在跑",
    "err_RULE_DISABLED": "規則已停用",
    "err_VERSION_CONFLICT": "別人剛改過，請重新開啟",
    "handoff_old_device": "原執行設備",
    "handoff_pending": "交接中：{{from}} 上線後停用舊設定，之後才由 {{to}} 執行",
    "handoff_disabled": "已停用（{{from}} 離線，上線後生效）",
    "handoff_deleting": "刪除中（{{from}} 上線後停止）",
    "shared_devices_note": "分享給你的設備不能用在自動化",
    "err_RULE_HANDOFF_PENDING": "規則交接中，舊的執行設備上線停用舊設定後才能執行",
    "handoff_cloud": "雲端",
    "more": "更多規則動作",
    "empty_intro": "還沒有規則。規則讓設備自己反應：門被打開就錄影並通知你、布防時有人就響警報器。從下面的範本開始：",
    "use_template": "用這個範本",
    "tpl_door_record_notify_needs": "這個範本需要門磁感測器，這個$t(leaf.cur)還沒有",
    "tpl_armed_pir_siren_needs": "這個範本需要人體感測器（PIR），這個$t(leaf.cur)還沒有",
    "tpl_ai_person_notify_needs": "這個範本需要有人形偵測的攝影機，這個$t(leaf.cur)還沒有",
    "reason_other": "系統沒有說明原因",
    "tpl_cannot_create": "{{what}}，所以還不能建立。先在「設備」加入需要的設備，或換一個範本。",
    "tpl_pick_first": "先選{{what}}"
  },
  "armed": {
    "label": "布防模式",
    "home": "在家",
    "night": "夜間",
    "away": "外出",
    "unsynced_one": "{{count}} 台設備還沒同步（上線後補推）",
    "unsynced_other": "{{count}} 台設備還沒同步（上線後補推）"
  },
  "dctl": {
    "siren_on": "🔔 響警報器",
    "siren_off": "停止警報",
    "light_on": "💡 開補光燈",
    "light_off": "關補光燈",
    "reboot": "重新開機",
    "reboot_confirm": "重新開機「{{name}}」？期間會斷線一兩分鐘。",
    "sent": "已送出",
    "err_FORBIDDEN": "沒有權限",
    "err_DEVICE_OFFLINE": "設備離線",
    "err_DEVICE_WAKING": "設備正在喚醒，請稍後再試",
    "err_DEVICE_ASLEEP": "設備正在休眠",
    "err_COMMAND_TIMEOUT": "設備沒有在時間內回應",
    "err_RENEW_ONLY": "設備憑證已過期，只能換證",
    "siren_confirm": "讓 {{name}} 的警報器響 30 秒？",
    "siren_confirm_body": "現場會發出警報聲；要提早停可以按〔停止警報〕。",
    "siren_action": "響警報器",
    "more": "更多"
  },
  "alarm": {
    "section": "警報處理",
    "state_open": "未處理",
    "state_acknowledged": "已看到",
    "state_claimed": "處理中",
    "state_resolved": "已處理",
    "state_false_alarm": "誤報",
    "act_acknowledged": "已看到",
    "act_claimed": "我來處理",
    "act_take_over": "我來接手",
    "act_resolved": "已處理",
    "act_false_alarm": "誤報",
    "act_open": "重開",
    "claimed_by": "{{name}} 處理中",
    "claimed_by_me": "你處理中",
    "someone": "有人",
    "note_btn": "備註",
    "note_label": "備註",
    "note_placeholder": "備註（一行，最多 {{max}} 字）",
    "note_invalid": "備註只能一行、最多 {{max}} 字",
    "last_note": "備註：{{note}}",
    "conflict": "已被 {{name}} 處理，畫面已更新",
    "conflict_anon": "已被別人處理，畫面已更新",
    "failed": "更新失敗：{{msg}}",
    "history": "處理歷程",
    "history_empty": "還沒有人處理",
    "read_only": "你只能看，不能改處理狀態",
    "unhandled_n": "{{n}} 則未處理的警報",
    "handle_menu": "處理",
    "note_add": "加備註",
    "also_done": "這一波 {{n}} 則一起處理了",
    "more_actions": "其他處理（誤報、備註）",
    "unhandled_counting": "正在算還沒處理的警報",
    "age_just_now": "剛發生",
    "age_min_one": "已開 {{count}} 分鐘",
    "age_min_other": "已開 {{count}} 分鐘",
    "age_hour_one": "已開 {{count}} 小時",
    "age_hour_other": "已開 {{count}} 小時",
    "age_day_one": "已開 {{count}} 天",
    "age_day_other": "已開 {{count}} 天",
    "recovered_dur": "↺ 已恢復 {{at}}（中斷了 {{dur}}）",
    "act_resolve_recovered": "已恢復，結案",
    "resolve_recovered_tip": "狀況已經解除，標成「已處理」",
    "recovered_lt1": "↺ 已恢復 {{at}}（中斷不到 1 秒）"
  },
  "popup": {
    "title": "警報彈窗",
    "help": "事件發生時自動把畫面帶出來。這是這台電腦（瀏覽器）的設定，不跟帳號走。",
    "sensor": "感測器觸發",
    "sensor_help": "門磁 / PIR 觸發時帶出關聯的攝影機（在設備頁設定關聯）",
    "alarm": "警報",
    "alarm_help": "煙霧、拆除，或布防中設了警報的偵測 → 帶出來源攝影機",
    "detection": "AI 偵測",
    "detection_help": "人、車等一般偵測也帶出來源攝影機（事件多的場域會很頻繁）",
    "target": "帶到哪裡",
    "target_float": "右下角浮窗",
    "target_cell": "影像牆的指定格位",
    "cell": "第幾格",
    "cell_help": "人在影像牆時，來源攝影機會換到這一格（已經在牆上就跟那一格交換）；不在影像牆時用浮窗。"
  },
  "sync": {
    "title": "多路同步回放",
    "open": "多路同步",
    "help": "最多 {{max}} 路，用同一個時間對齊播放：有雲端錄影的播雲端，沒有的播本地錄影（NVR / Station 硬碟、SD 卡）；某一路那個時間沒有錄影會顯示空檔。",
    "cameras": "攝影機（{{n}} / {{max}}）",
    "load": "載入",
    "play": "播放",
    "pause": "暫停",
    "speed": "速度",
    "position": "時間位置",
    "gap": "這個時間沒有雲端錄影",
    "end": "這個時間之後沒有雲端片段（雲端只存事件片段）",
    "no_cloud_scope": "這個範圍的攝影機最近兩個月都沒有雲端錄影，也沒有本地錄影（NVR / Station 硬碟、SD 卡），多路同步沒有可播的錄影。",
    "no_cloud_cam": "這台沒有雲端錄影，也沒有本地錄影（硬碟 / SD 卡）",
    "aligned": "{{at}} 這幾路都還沒有錄影，從最早有錄影的 {{from}} 開始。",
    "no_cloud_legend": "有鎖頭的攝影機最近兩個月沒有雲端錄影（不支援雲端錄影，或沒有雲錄席次 / 方案），也沒有本地錄影（NVR / Station 硬碟、SD 卡）。",
    "skip_to": "跳到 {{time}}",
    "jump_all": "同步回放用同一個時間：全部畫面一起移到那個時間",
    "jumped": "已把全部畫面移到 {{name}} 的下一段（{{at}}）。",
    "none_later": "之後 {{h}} 小時內都沒有雲端片段",
    "event_only": "只存事件片段",
    "event_only_hint": "這台的雲端只存事件片段，多路同步裡大部分時間會是空格（可以用〔跳過去〕到下一段）",
    "clip_suspect": "⚠ 這段雲端片段可能不完整，畫面可能是綠色或停住",
    "open_single": "用單路看其他來源",
    "gap_next": "這個時間沒有雲端錄影（下一段 {{time}}）",
    "src_cloud": "雲端",
    "src_nvr": "硬碟",
    "src_sd": "SD 卡",
    "gap_local": "這個時間沒有本地錄影",
    "gap_next_local": "這個時間沒有本地錄影（下一段 {{time}}）",
    "end_local": "這個時間之後沒有本地錄影"
  },
  "chcopy": {
    "title": "複製設定到其他通道",
    "help": "把一路的設定寫到其他通道，再逐路回讀確認。只複製兩邊都有、而且你有權限改的項目；排程、偵測區這類自訂編輯器與指令不在內。",
    "source": "來源通道",
    "targets": "目標通道",
    "all": "全選其他通道",
    "compare": "比對",
    "items": "要複製的項目",
    "nothing": "來源通道沒有可以複製的設定",
    "col_channel": "通道",
    "col_diff": "不同的項目",
    "col_result": "結果",
    "diff_n": "{{n}} 項",
    "copy": "複製",
    "retry": "重試失敗的（{{n}}）",
    "same": "已經一樣",
    "applied_n": "已套用 {{n}} 項",
    "not_applied": "沒有套用：{{list}}"
  },
  "aiset": {
    "open": "設定",
    "title": "AI 設定：{{name}}",
    "zone_help": "在畫面上點出偵測區域（最多 {{max}} 點，拖曳頂點可調整）；不畫 = 整個畫面。",
    "line_help": "在畫面上點兩下拉出越線（A → B）。",
    "zone_points": "區域 {{n}} 點",
    "zone_full": "整個畫面",
    "undo": "退回一點",
    "clear": "清除",
    "line_first": "點畫面設定起點 A",
    "line_second": "再點一下設定終點 B",
    "line_set": "越線已設定（再點畫面可重畫）",
    "direction": "方向",
    "dir_both": "雙向",
    "dir_a_to_b": "A 的左側 → 右側",
    "dir_b_to_a": "A 的右側 → 左側",
    "schedule": "排程",
    "always": "全天",
    "start": "開始",
    "end": "結束",
    "schedule_help": "設備當地時間；結束早於開始 = 跨午夜",
    "day_0": "日",
    "day_1": "一",
    "day_2": "二",
    "day_3": "三",
    "day_4": "四",
    "day_5": "五",
    "day_6": "六",
    "err_sensitivity": "靈敏度要在 10–100",
    "err_zone_points": "區域要 3–16 個點",
    "err_line_required": "這個模型要先畫越線",
    "err_line_short": "越線太短",
    "err_schedule_days": "排程至少選一天",
    "err_schedule_time": "排程時間不對（開始與結束不能一樣）"
  },
  "diag": {
    "title": "遠端診斷授權",
    "help": "客服要對這台設備做唯讀遠端偵測（狀態、設定摘要、最近的設備紀錄）時，要擁有者或管理員同意；同意有時限，可隨時撤回。原始日誌不提供下載。",
    "none": "目前沒有診斷請求",
    "st_requested": "等待同意",
    "st_granted": "已同意",
    "st_denied": "已拒絕",
    "st_revoked": "已撤回",
    "st_expired": "已過期",
    "by_brand": "{{brand}} 客服",
    "until": "到 {{at}}",
    "runs": "已偵測 {{n}} 次",
    "minutes": "同意多久",
    "approve": "同意",
    "deny": "拒絕",
    "revoke": "撤回"
  },
  "batch": {
    "open": "批次作業（{{n}}）",
    "title_one": "批次作業：{{count}} 台",
    "title_other": "批次作業：{{count}} 台",
    "pick": "選取 {{name}}",
    "pick_all": "全選",
    "mode_rename": "改名",
    "mode_firmware": "更新韌體",
    "rule": "命名規則",
    "start": "序號起點",
    "rule_help": "{name} = 原本的名稱、{n} = 序號、{n:02} = 補零到 2 位。例：1F-{n:02} {name}",
    "fw_help_one": "對 {{count}} 台設備本體檢查並開始韌體更新（通道跟著它的 NVR）；沒有可用更新的會略過，需要擁有者權限。",
    "fw_help_other": "對 {{count}} 台設備本體檢查並開始韌體更新（通道跟著它的 NVR）；沒有可用更新的會略過，需要擁有者權限。",
    "fw_confirm_one": "要對 {{count}} 台設備開始韌體更新嗎？更新期間設備會短暫離線。",
    "fw_confirm_other": "要對 {{count}} 台設備開始韌體更新嗎？更新期間設備會短暫離線。",
    "col_new": "新名稱",
    "col_result": "結果",
    "run": "開始（{{n}} 台）",
    "same": "名稱沒變",
    "st_pending": "等待中",
    "st_running": "進行中…",
    "summary": "成功 {{ok}}、略過 {{skipped}}、失敗 {{failed}}、還沒做 {{left}}",
    "err_BAD_NAME": "名稱不合規（空的或超過 64 字）",
    "err_FORBIDDEN": "沒有權限",
    "mode_settings": "套設定",
    "settings_source": "以這台為範本",
    "settings_help": "把範本那台的設定寫到其他選取的同型號設備，再逐台回讀確認。只複製兩邊都有、而且你有權限改的項目；排程、偵測區這類自訂編輯器與指令不在內。型號不同的會略過。",
    "settings_confirm_one": "要把「{{name}}」的設定套到 {{count}} 台設備嗎？碼流類設定會影響既有的錄影與觀看。",
    "settings_confirm_other": "要把「{{name}}」的設定套到 {{count}} 台設備嗎？碼流類設定會影響既有的錄影與觀看。",
    "skip_model": "型號不同",
    "skip_same": "設定相同",
    "mode_location": "指派位置",
    "loc_site": "位置",
    "loc_pick": "選擇場域…",
    "loc_help": "把選取的設備 / 通道指派到這個場域（要在$t(leaf.cur)的場域錨點之下）。同一個$t(leaf.cur)的設備一次送出：有一台不行，這個$t(leaf.cur)整批都不改。",
    "loc_need_org": "指派位置只用在同一個團體組織的$t(leaf.cur)設備，而且你要能管理那些設備。",
    "err_BATCH_REJECTED": "同一批有一台不行，整批沒改",
    "err_VERSION_CONFLICT": "位置剛被別人改過，重新整理後再試",
    "err_OUT_OF_ANCHOR": "這個場域不在$t(leaf.cur)的錨點之下",
    "err_BAD_TARGET": "設備不在這個$t(leaf.cur)",
    "no_manage": "你不能管理這台（只有$t(leaf.cur)擁有者或管理員可以；分享來的設備不能管理）",
    "no_maintain": "你不能維運這台（要$t(leaf.cur)擁有者 / 管理員，或節點管理員 / 維運員；分享來的設備不行）",
    "denied": "沒有權限，不執行：{{why}}",
    "denied_n_one": "{{count}} 台沒有權限，不會執行。",
    "denied_n_other": "{{count}} 台沒有權限，不會執行。",
    "mode_reboot": "重新開機",
    "reboot_help": "對 {{n}} 台有連線的設備本體下重新開機；伺服器逐台確認權限，沒權限的列出原因、不影響其他台。",
    "reboot_confirm_one": "重新開機 {{count}} 台設備？重開期間會中斷錄影與即時影像。",
    "reboot_confirm_other": "重新開機 {{count}} 台設備？重開期間會中斷錄影與即時影像。",
    "picked_one": "已選 {{count}} 台",
    "picked_other": "已選 {{count}} 台",
    "clear": "取消選取"
  },
  "fwm": {
    "open": "韌體管理",
    "title": "韌體管理",
    "back": "返回設備",
    "help": "每台設備的韌體版本與更新排程。自動更新開著的設備，會在它的維護時段（設備當地時間）內安裝新版；推哪一版、分批與暫停由平台的發佈設定決定。只有擁有者能改設定。",
    "st_latest": "已是最新",
    "st_available": "有新版",
    "st_updating": "更新中",
    "st_unknown": "讀不到",
    "count_one": "{{count}} 台設備",
    "count_other": "{{count}} 台設備",
    "empty": "這個範圍裡沒有可管理韌體的設備。",
    "home_failed": "{{home}} 的韌體狀態讀不到",
    "col_model": "機種",
    "col_state": "狀態",
    "col_window": "維護時段",
    "updating": "更新到 {{v}}（{{p}}%）",
    "available": "可更新到 {{v}}",
    "critical": "重大更新",
    "auto_of": "{{name}} 的自動更新",
    "window_of": "{{name}} 的維護時段",
    "saved": "已儲存",
    "batch_schedule": "套用排程（{{n}}）",
    "batch_update": "立即更新（{{n}}）",
    "batch_schedule_help": "把自動更新與維護時段寫到選取的設備。維護時段格式 HH:MM-HH:MM（可跨午夜）；留空 = 不改。",
    "batch_update_help": "對選取的設備開始更新；沒有新版或正在更新的會略過。更新期間設備會短暫離線。",
    "keep": "不改",
    "skip_updating": "正在更新",
    "retry": "重試失敗的（{{n}}）",
    "err_FORBIDDEN": "沒有權限（要擁有者）",
    "err_FIRMWARE_NOT_CONFIGURED": "這個環境沒有開韌體服務",
    "err_daily_cap": "今天的更新數量已達上限，明天再試",
    "err_offline": "設備離線",
    "report": "更新報表",
    "period": "期間",
    "period_1": "最近 24 小時",
    "period_7": "最近 7 天",
    "period_30": "最近 30 天",
    "report_build": "產生報表",
    "report_csv": "下載 CSV",
    "report_summary": "最近 {{days}} 天：成功 {{success}}、失敗 {{failed}}、其他 {{other}}",
    "report_unread_one": "（{{count}} 台的歷史讀不到）",
    "report_unread_other": "（{{count}} 台的歷史讀不到）",
    "report_empty": "這段期間沒有更新紀錄。",
    "csv_at": "時間",
    "csv_home": "場域",
    "csv_device": "設備",
    "csv_aid": "設備 ID",
    "csv_from": "原版本",
    "csv_to": "版本",
    "csv_status": "結果",
    "csv_reason": "原因",
    "csv_trigger": "觸發",
    "csv_finished": "完成時間",
    "job_success": "成功",
    "job_failed": "失敗",
    "job_rolled_back": "已回滾",
    "job_deferred": "延後",
    "job_canceled": "已取消",
    "job_pending": "等待中",
    "job_sent": "已送出",
    "job_accepted": "設備已接受",
    "job_downloading": "下載中",
    "job_installing": "安裝中",
    "job_rebooting": "重新開機中",
    "trigger_auto": "排程（自動更新）",
    "trigger_user_now": "立即更新",
    "trigger_admin_push": "管理者推送",
    "trigger_legacy_check": "設備檢查更新",
    "trigger_dev_pin": "開發指定",
    "reason_timeout": "逾時",
    "reason_download_failed": "下載失敗",
    "reason_verify_failed": "驗證失敗",
    "reason_suspected_brick": "安裝後沒有回報",
    "reason_outside_window": "不在維護時段",
    "reason_battery_low": "電量不足",
    "reason_busy": "設備忙碌中",
    "st_unknown_offline": "讀不到（離線）",
    "only_outdated": "只看有新版的",
    "how_saved": "「自動更新」一切換就儲存；「維護時段」改完按〔儲存〕或 Enter。設備在維護時段內才會自己更新；要馬上更新請勾選後按〔立即更新〕。"
  },
  "chmx": {
    "title": "比較各通道設定",
    "help": "每一路的設定並排比較，跟多數通道不同的格子會標出來。能改的格子可以直接改（寫到那一路、回讀確認）；要整批對齊用下面的「複製設定到其他通道」。排程、偵測區這類請到該通道的設定頁。",
    "load_one": "比較 {{count}} 路的設定",
    "load_other": "比較 {{count}} 路的設定",
    "reload": "重新載入",
    "only_diff": "只看不一致的項目",
    "diff_count": "{{n}} 個項目各路不一致",
    "unread": "讀不到設定：{{list}}",
    "col_setting": "設定項目",
    "custom": "到設定頁",
    "save_cell": "儲存 {{name}}"
  },
  "tier": {
    "filter": "顯示",
    "common": "常用",
    "advanced": "進階",
    "technical": "技術"
  },
  "scope": {
    "src_own": "我自己的",
    "src_org": "組織授權給我",
    "src_shared": "別人分享給我",
    "external": "外部分享",
    "personal_org": "我的家",
    "sharer_unknown": "分享者",
    "notice_mfa_required": "需要開啟兩步驟驗證",
    "notice_org_suspended": "組織已停用",
    "notice_ip_not_allowed": "不允許從這個網路存取",
    "notice_session_reauth": "需要重新登入",
    "notice_body_mfa_required": "這個組織要求兩步驟驗證。開啟兩步驟驗證並重新登入後，就看得到這個組織的設備；你自己的與其他組織的設備不受影響。",
    "notice_body_org_suspended": "這個組織已被平台停用，暫時看不到它的設備。",
    "notice_body_ip_not_allowed": "這個組織只允許從指定的網路存取，目前的網路看不到它的設備。",
    "notice_body_session_reauth": "這個組織要求重新登入才能繼續使用它的設備。",
    "go_settings": "前往設定",
    "load_failed": "設備清單暫時無法載入，請稍後再試。",
    "notice_delegator_mfa_required": "委派方要求兩步驟驗證",
    "hint_all": "全部",
    "hint_device": "這台設備在 {{path}}，不在目前的範圍（{{scope}}）。",
    "hint_event": "這則事件在 {{path}}，不在目前的範圍（{{scope}}）。",
    "hint_switch": "把範圍切到 {{name}}",
    "switched_to": "已把範圍切到 {{name}}",
    "all_n_orgs_one": "全部（{{count}} 個組織）",
    "all_n_orgs_other": "全部（{{count}} 個組織）",
    "count_one": "{{count}} 台",
    "count_other": "{{count}} 台",
    "count_tip": "你可存取的設備數（不含 NVR 通道）",
    "search": "搜尋組織、場域、$t(leaf.cur)",
    "create_org": "＋ 建立組織",
    "loading": "範圍載入中…",
    "all_n_orgs_homes_one": "全部（{{count}} 個組織、{{homes}} 個家）",
    "all_n_orgs_homes_other": "全部（{{count}} 個組織、{{homes}} 個家）",
    "notice_sso_required": "需要以公司帳號驗證",
    "go_sso": "以公司帳號驗證"
  },
  "access": {
    "shared_by": "{{name}} 分享",
    "expires": "{{date}} 到期",
    "also_via": "也可經：{{list}}"
  },
  "deny": {
    "not_granted": "沒有這項權限",
    "org_mfa_required": "需要開啟兩步驟驗證",
    "org_suspended": "組織已停用",
    "ip_not_allowed": "組織不允許從這個網路存取",
    "session_reauth": "需要重新登入",
    "share_expired": "分享已於 {{date}} 到期",
    "share_expired_nodate": "分享已到期",
    "share_suspended": "分享暫停中",
    "alarm_window": "只在警報後 {{n}} 分鐘內可看",
    "armed": "只在布防時可用",
    "schedule": "不在授權的時段內",
    "before_share_start": "分享開始前的資料看不到",
    "org_unverified": "服務商的審核已失效",
    "parent_restricted": "只開放部分通道",
    "duty_no_export": "值班帳號不能匯出",
    "action_not_available": "這個環境不提供這項功能",
    "device_offline": "設備離線"
  },
  "shr": {
    "tab": "分享",
    "title": "{{name}} 的分享",
    "hint": "把這個$t(leaf.cur)的設備逐台分享給個人或組織（安裝商、保全、監控中心…）。分享只能縮小或撤銷，撤銷後 30 秒內停止對方的影像；收到分享的人不能再分享出去。",
    "to_person": "分享給個人",
    "to_org": "分享給組織",
    "people": "分享給個人",
    "orgs": "分享給組織",
    "none": "目前沒有分享。",
    "no_homes": "你沒有可以管理分享的$t(leaf.cur)（要是$t(leaf.cur)的擁有者或管理員）。",
    "no_expiry": "不到期",
    "renew": "續約",
    "renew_of": "續約「{{name}}」",
    "renew_hint": "輸入組織給你的續約代碼：範圍不變、期限延長。範圍有變的請用「分享給組織」重新同意。",
    "revoke_confirm": "撤銷分享給「{{name}}」？30 秒內生效。",
    "someone": "對方",
    "an_org": "一個組織",
    "person_hint": "輸入對方的 email（同一個帳號池）。對方已有帳號會立即看到、收到通知；還沒有帳號會收到邀請信，註冊後生效。不用對方接受，對方可以隨時移除。",
    "no_reshare": "預設只開「看」；收到的人不能再分享出去。",
    "expires": "到期日（選填）",
    "expires_hint": "不設 = 一直有效，直到你撤銷。",
    "send": "送出",
    "sent": "已送出給 {{email}}。",
    "unverified": "尚未通過審核",
    "is_renewal": "這是續約請求：範圍不變、期限延長。",
    "access_log": "分享存取紀錄",
    "access_log_hint": "經分享看影像、回放、控制設備都會記在這裡，$t(leaf.cur)成員都看得到，無法修改。",
    "grantee": "分享對象",
    "grantee_user": "個人",
    "grantee_org": "組織",
    "wrong_env": "這個代碼屬於另一個環境（{{env}}），這個$t(leaf.cur)不能同意。",
    "requested_devices": "對方要求的設備",
    "unknown_device": "已移除的設備"
  },
  "mine": {
    "shared_tab": "分享給我",
    "shared_title": "別人分享給我的",
    "shared_hint": "別人逐台分享給你個人的設備。不用接受，你可以隨時移除；分享給你所屬組織的設備不在這裡。",
    "shared_none": "目前沒有人分享設備給你。",
    "remove": "移除",
    "remove_confirm": "移除 {{name}} 分享給你的設備？",
    "remove_body": "移除後就看不到這些設備；要再看得請對方重新分享。",
    "access_log": "存取紀錄",
    "access_log_hint": "你經別人分享看影像、回放、控制設備的紀錄；分享給你的人也看得到。",
    "access_log_empty": "還沒有紀錄。",
    "result": "結果",
    "result_ok": "成功",
    "result_denied": "被拒"
  },
  "inv": {
    "tab_unassigned": "未歸戶設備",
    "tab_detected": "偵測到的設備",
    "title": "{{name}} 的設備庫存",
    "hint": "組織擁有、還沒加入$t(leaf.cur)的設備：認領、預先指派到場域的$t(leaf.cur)，設備上線後自動加入。庫存不會讓任何人看到影像。",
    "detected_hint": "場域現場發現、還沒加入的設備（附近的新設備、要位址的 PoE 攝影機、ONVIF 探索）；庫存內的可一鍵加入。",
    "coming_soon": "這個功能即將推出。",
    "no_org": "你沒有可以管理設備庫存的組織。",
    "claim": "認領設備",
    "col_name": "名稱",
    "col_serial": "序號",
    "col_status": "狀態",
    "col_target": "指派 / 所在$t(leaf.cur)",
    "empty": "庫存裡沒有設備。",
    "status_offline": "未上線",
    "status_online_unpaired": "在線、未加入",
    "status_assigned": "已指派、等設備上線",
    "status_joined": "已加入",
    "claim_help": "輸入序號與訂單號（貼上出貨單也可以）：每列一台，序號和訂單號之間用空白或逗號分開。對不上的列一律顯示「對不上」，不會說是哪一項錯。",
    "claim_lines": "序號　訂單號（每列一台）",
    "claim_placeholder": "SN2505A0012 PO-20261009-01",
    "claim_bad_lines": "第 {{lines}} 列格式不對（要「序號 訂單號」兩欄）",
    "claim_over": "一次最多 {{n}} 列，多的這次不送",
    "claim_run": "認領 {{n}} 台",
    "claim_st_pending": "處理中…",
    "claim_st_ok": "✓ 已加入庫存（{{model}}）",
    "claim_st_already": "✓ 已經在庫存（{{model}}）",
    "claim_st_not_found": "序號或訂單號對不上",
    "claim_st_rate_limited": "失敗太多次，請一小時後再試",
    "claim_st_error": "暫時無法認領（{{code}}）",
    "assign_to": "指派到…（{{n}}）",
    "assign_title": "指派 {{n}} 台到$t(leaf.cur)",
    "assign_help": "選要裝的$t(leaf.cur)：設備上線後自動加入；已在線的會馬上加入。指派不會讓任何人看到影像。",
    "assign_search": "找$t(leaf.cur)",
    "assign_home": "$t(leaf.cur)",
    "assign_no_home": "沒有符合的$t(leaf.cur)（$t(leaf.cur)要掛在節點底下）",
    "assign_run": "指派",
    "assign_st_assigned": "✓ 已指派，等設備上線",
    "assign_st_joined": "✓ 已在這個$t(leaf.cur)",
    "err_NOT_FOUND": "不在這個組織的設備庫存",
    "err_DEVICE_ALREADY_BOUND": "已在本組織別的$t(leaf.cur)；要換$t(leaf.cur)先解綁",
    "err_ECOSYSTEM_MISMATCH": "生態系不符",
    "err_UNAVAILABLE": "暫時無法處理，稍後再試",
    "err_INTERNAL": "處理失敗，稍後再試",
    "unassign": "取消指派",
    "unassign_n": "取消指派（{{n}}）",
    "unassign_confirm": "取消 {{n}} 台的預先指派？設備會留在庫存，之後可以再指派。",
    "filter_all_status": "全部狀態",
    "filter_all_models": "全部機種",
    "search_serial": "搜尋序號",
    "filter_node": "只看：{{name}}",
    "filter_node_clear": "看整個組織",
    "select_all": "全選",
    "col_source": "入庫來源",
    "more": "還有更多，請用篩選縮小範圍。",
    "source_admin": "平台配發",
    "source_shop": "商城訂單",
    "source_claim": "序號認領",
    "source_dealer": "經銷出貨",
    "source_org_link": "開發者組織交付",
    "source_transfer": "組織轉移",
    "det_node": "範圍節點",
    "det_scope_node": "目前範圍的節點",
    "det_scan": "掃描 ONVIF",
    "det_scanning": "掃描中…（最多約 15 秒）",
    "det_nearby_pending": "這裡列出向 Station / NVR 要網路位址的設備，以及 ONVIF 掃描找到的攝影機。",
    "det_scan_result": "掃了 {{gateways}} 台閘道，找到 {{found}} 台（{{failed}} 台閘道沒回應）",
    "det_col_kind": "類型",
    "det_col_what": "機種 / 廠商",
    "det_col_seen_by": "在哪裡看到",
    "det_col_sources": "來源",
    "det_col_seen_at": "最後看到",
    "det_kind_kinio": "Kinio 設備",
    "det_kind_third_party": "第三方 ONVIF",
    "det_kind_address_request": "要位址的設備",
    "det_in_inventory": "在庫存",
    "det_gateway": "閘道",
    "det_src_onvif": "ONVIF 探索",
    "det_src_station_dhcp": "要位址",
    "det_src_nearby_wifi": "附近（Wi-Fi）",
    "det_src_nearby_lan": "附近（區網）",
    "det_add": "加入",
    "det_add_onvif": "用 ONVIF 加入",
    "det_approve": "核准位址",
    "det_suspect": "可能是上行網段的設備，核准前先確認",
    "det_empty": "沒有偵測到新設備。按〔掃描 ONVIF〕找網路上的攝影機。",
    "det_col_ident": "尾碼 / MAC",
    "det_lease_error": "偵測沒有開始（清單可能不是即時的）：",
    "det_adopt_title": "把庫存裡的設備加入$t(leaf.cur)",
    "det_adopt_help": "選要加入的$t(leaf.cur)（要在這個節點底下）。設備已經在線就馬上加入，還沒上線的話，設備一上線就自動加入。",
    "det_adopt_joined": "已加入。",
    "det_adopt_assigned": "已指派，設備上線後自動加入。"
  },
  "ot": {
    "dot": "・",
    "you": "你",
    "reauth_suffix": "（需要重新驗證）",
    "optional": "（選填）",
    "reason": "理由",
    "next": "下一步",
    "next_preview": "下一步：看影響",
    "name": "名稱",
    "owner": "擁有者",
    "personal": "個人",
    "org_owned": "組織",
    "add": "加入",
    "clear": "清除",
    "details": "詳情",
    "now": "現在",
    "forever": "永久",
    "until": "至 {{date}}",
    "window": "{{from}}–{{to}}",
    "until_date": "到期日",
    "term": "期限",
    "only_window": "只在這個時段",
    "window_from": "開始",
    "window_to": "結束",
    "expand": "展開",
    "collapse": "收合",
    "no_results": "沒有符合的項目",
    "n_people": "{{n}} 人",
    "n_people_paren": "（{{n}} 人）",
    "n_people_link": "{{n}} 人 ›",
    "n_assignments": "{{n}} 筆指派",
    "n_homes_devices": "{{homes}} 個戶・{{devices}} 台",
    "n_grantees": "{{n}} 位被指派者",
    "member_group_n": "成員群組 · {{n}} 人",
    "member_group_paren": "（成員群組・{{n}} 人）",
    "delegation": "委派",
    "delegations": "委派",
    "verified": "已審核：{{kinds}}",
    "org_code": "組織代號 {{code}}",
    "org_code_line": "本組織代號：{{code}}（對方建立委派時看得到同一組，可以口頭核對）",
    "whole_org": "整個組織",
    "whole_org_name": "{{org}}（整個組織）",
    "whole_org_short": "{{org}}",
    "whole_org_of": "{{org}}（整個組織）",
    "whole_org_now_later": "（現在與之後的節點、戶）",
    "whole_org_check": "整個組織（現在與之後的節點、戶）",
    "leaf_default": "地點",
    "leaf_personal": "家庭",
    "leaf_default_lc": "地點",
    "leaf_default_pl": "地點",
    "leaf_default_lc_pl": "地點",
    "leaf_personal_lc": "家庭",
    "leaf_personal_pl": "家庭",
    "leaf_personal_lc_pl": "家庭",
    "unassigned": "未指派",
    "scope_custom": "（目前範圍）",
    "level": "層級名稱",
    "not_in_list": "已不在清單",
    "lvl_site": "場域",
    "lvl_building": "建築",
    "lvl_floor": "樓層",
    "lvl_zone": "區域",
    "act_view": "看",
    "act_playback": "回放",
    "act_events": "事件",
    "act_alarm": "警報",
    "act_talk": "對講",
    "act_control": "控制",
    "act_arm": "布防",
    "act_disarm": "撤防",
    "act_maintain": "維運",
    "act_export": "匯出",
    "act_profile": "$t(leaf.cur)資料",
    "role": "角色",
    "role_node_admin": "節點管理員",
    "role_operator": "操作員",
    "role_viewer": "觀看者",
    "role_installer": "安裝技師",
    "role_maintainer": "維運員",
    "role_custom": "自訂",
    "role_owner": "擁有者",
    "role_admin": "管理員",
    "role_member": "成員",
    "role_desc_node_admin": "全部資料動作（含布防 / 撤防）+ 維運 + 子節點與指派；不含分享、$t(leaf.cur)角色、錄影設定、解綁、格式化",
    "role_desc_operator": "看、對講、回放、事件、控制、處理警報",
    "role_desc_viewer": "看、事件；不處理警報、警報不推播",
    "role_desc_installer": "看、控制",
    "role_desc_node_admin_d_tail": " + 在這個子樹指派本組織成員；撤防、維運要另勾；不能改 {{from}} 的節點結構",
    "role_node_admin_excl": "（不含分享、$t(leaf.cur)角色、錄影設定、解綁、格式化）",
    "role_effective_title": "角色・實際生效 = 角色 ∩ 委派範圍（{{scope}}）",
    "extra_recording_export": "另加：下載 / 匯出錄影",
    "extra_alarm_receive": "另加：處理警報",
    "extra_security_arm": "另加：遠端布防",
    "extra_security_disarm": "另加：遠端撤防",
    "extra_device_maintain": "另加：維運（韌體更新、重新開機、改名）",
    "tab_tree": "組織樹",
    "tab_views": "版面",
    "tab_groups": "群組",
    "panel_collapse": "收起面板",
    "panel_expand": "展開組織樹 / 版面 / 群組",
    "tree_dlg_changed": "{{from}} 已調整委派範圍",
    "auth_changed": "權限已更新",
    "dlg_ended_short": "{{from}} 已結束委派",
    "tree_search": "搜尋節點、$t(leaf.cur)、設備",
    "search_min": "至少輸入 2 個字",
    "search_more": "還有更多，請縮小範圍",
    "tree_empty": "還沒有任何設備。",
    "count_tip": "你可存取的設備數",
    "dlg_label": "委派：{{from}}",
    "dlg_label_whole": "委派：{{from}}（整個組織）",
    "dlg_tip": "{{from}} 委派，{{until}}",
    "mfa_needed": "{{from}} 要求兩步驟驗證，開啟後才看得到這些設備。",
    "setup_mfa": "設定兩步驟驗證",
    "dlg_ended_line": "{{from}} 已於 {{time}} 結束委派",
    "no_assignment_yet": "你在 {{org}} 還沒有被指派任何節點，請洽 {{org}} 的管理員",
    "more_actions": "{{name}} 的更多動作",
    "notify_me_node": "通知我這個節點",
    "notify_me_group": "通知我這個群組",
    "add_to_view": "加到版面…",
    "add_to_group": "加到群組…",
    "open_in_wall": "在影像牆開啟",
    "no_devices": "沒有你看得到的設備",
    "place_on_wall": "放進影像牆",
    "you_can_view_hint": "畫面 = 攝影機或通道；一台 NVR 有幾個通道就算幾個畫面（樹上每列數的是設備）",
    "live_empty": "這個範圍沒有你看得到的攝影機。",
    "live_dlg_ended": "{{from}} 已於 {{time}} 結束委派，這個畫面已停止",
    "live_dlg_changed": "{{from}} 已調整委派範圍，你已不能看這台",
    "prev_page": "上一頁",
    "next_page": "下一頁",
    "page_n": "第 {{n}} / {{total}} 頁",
    "views_hint": "版面只是整理方式，不會讓任何人看到他原本沒有權限的設備",
    "groups_hint": "群組不授予任何權限；每個人只看到自己有權限的設備",
    "view_new": "新增版面",
    "group_dev_new": "新增設備群組",
    "no_views": "還沒有版面。",
    "no_dev_groups": "還沒有設備群組。",
    "view_label": "版面：{{name}}",
    "group_prefix": "群組：{{name}}",
    "edit_named": "編輯 {{name}}",
    "unavailable_n_one": "{{count}} 個項目已無法參照",
    "unavailable_n_other": "{{count}} 個項目已無法參照",
    "group_batch": "批次作業",
    "view_edit_title": "編輯版面：{{name}}",
    "group_edit_dev_title": "編輯設備群組：{{name}}",
    "org_view_of": "組織：{{org}}",
    "source_personal": "來源（我看得到的）",
    "source_org": "來源（本組織的結構與委派來的節點；只有名稱）",
    "source_structure": "本組織的結構",
    "view_content": "版面內容",
    "group_content": "群組內容",
    "add_folder": "新增資料夾",
    "new_folder": "新資料夾",
    "folder": "資料夾",
    "top_level": "最上層",
    "editor_empty": "從左邊的來源按〔＋〕加入。",
    "ref_folder": "資料夾",
    "ref_node": "節點",
    "ref_home": "$t(leaf.cur)",
    "ref_device": "設備",
    "ref_group": "群組",
    "add_ref": "加入 {{name}}",
    "items_from_ended_one": "來自已結束的委派：{{from}}（{{count}} 個項目）",
    "items_from_ended_other": "來自已結束的委派：{{from}}（{{count}} 個項目）",
    "items_gone_one": "{{count}} 個項目已無法參照",
    "items_gone_other": "{{count}} 個項目已無法參照",
    "add_to_view_title": "把「{{name}}」加到版面",
    "add_to_group_title": "把「{{name}}」加到群組",
    "no_editable_views": "沒有你能編輯的版面，先在〔版面〕分頁新增一個。",
    "no_editable_groups": "沒有你能編輯的群組，先在〔群組〕分頁新增一個。",
    "subs_title": "節點與群組",
    "subs_hint": "組織樹上的節點預設不推一般偵測；訂閱後才推播 / 進收件匣。沒訂閱的只在「事件」清單看得到。",
    "subs_mine": "我訂閱的",
    "subs_none": "還沒有訂閱任何節點或群組。",
    "subs_target": "節點 / 群組",
    "subs_detection": "一般偵測",
    "subs_inactive": "目前不生效",
    "subs_add": "＋ 訂閱節點或群組",
    "subscribe": "訂閱",
    "unsubscribe": "取消訂閱",
    "ch_push": "推播",
    "ch_inbox": "收件匣",
    "ch_email": "Email",
    "implicit_title": "不用訂閱就會收到",
    "implicit_alarm": "警報",
    "implicit_device_status": "設備異常",
    "implicit_alarm_push": "照一般偏好推播",
    "implicit_alarm_feed": "不推，事件清單看得到",
    "implicit_alarm_generic": "角色能處理警報的地方照一般偏好推播；觀看者的地方不推，事件清單看得到",
    "implicit_status": "節點管理員或負責維運的地方：離線、錄影中斷、儲存異常推播；OTA 等其他進收件匣",
    "implicit_mfa": "委派方要求兩步驟驗證、你沒開時：警報照樣推播，內容只寫「<委派方> 有一則警報，開啟兩步驟驗證後才看得到」",
    "structure_title": "組織結構",
    "structure_moved": "節點、$t(leaf.cur)、指派與中斷繼承在「組織結構」管理。",
    "open_structure": "前往組織結構",
    "no_structure_access": "你沒有可以管理的節點。",
    "level_settings": "層級名稱設定",
    "struct_tree_head": "結構樹（數字 = 結構總數）",
    "struct_tree": "結構樹",
    "struct_search": "搜尋節點、{{leaf}}",
    "struct_count_tip": "結構總數（設備）",
    "blocked_tip": "已中斷繼承：上層的指派與委派不適用",
    "select_home": "選取 {{name}}",
    "pick_node": "在左邊選一個節點。",
    "struct_totals": "底下 {{nodes}} 個節點、{{homes}} 個戶、{{devices}} 台（結構總數）",
    "add_child": "＋ 子節點",
    "add_home": "＋ {{leaf}}",
    "rename_level": "改名 / 層級",
    "move": "移動",
    "archive": "停用",
    "archive_title": "停用「{{name}}」？",
    "archive_body": "節點底下要先沒有$t(leaf.cur)與子節點；這個節點上的指派會結束，委派只移除這個節點。",
    "archived": "已停用「{{name}}」",
    "block_label": "中斷繼承（上層的指派與委派不再適用於這個節點以下）",
    "this_node_assignments": "本節點的指派",
    "no_assignments": "這個節點沒有指派。",
    "add_assignment": "＋ 指派",
    "inherited_title": "從上層繼承（唯讀）",
    "delegated_out_title": "委派給其他組織（唯讀）",
    "col_who": "對象",
    "col_role": "角色",
    "col_role_before": "原本的角色",
    "col_term": "期限 / 時段",
    "col_from": "來自",
    "col_to_org": "受託組織",
    "col_from_org": "委派方",
    "col_scope": "範圍",
    "col_how": "怎麼來的",
    "col_granted_by": "授予者",
    "col_lost_actions": "失去的動作",
    "col_effective": "實際生效",
    "col_effective_now": "目前生效",
    "col_after_apply": "套用後多出",
    "col_node": "節點",
    "col_grantees": "被指派人",
    "col_assigned": "已指派",
    "n_selected": "已選 {{n}} 個{{leaf}}",
    "move_to": "移到…",
    "assign_manager": "指定管理人…",
    "only_unassigned": "只能選未指派的戶",
    "batch_max": "一次最多 {{n}} 戶",
    "node_name": "節點名稱",
    "level_hint": "層級名稱只用於顯示與篩選，不決定權限。",
    "create": "建立",
    "add_child_of": "在「{{name}}」底下新增節點",
    "rename_title": "改名 / 層級：{{name}}",
    "node_created": "已建立「{{name}}」",
    "node_saved": "已儲存",
    "add_home_at": "在「{{name}}」新增{{leaf}}",
    "manager": "管理人",
    "manager_none": "未指派（之後再指定）",
    "manager_member": "指定成員",
    "manager_me": "指定我為管理人",
    "home_name": "{{leaf}}名稱",
    "creator_not_manager": "建立者不會成為這一戶的管理人；誰能看由節點指派決定。",
    "cover_summary": "目前會涵蓋這一戶的指派：{{list}}",
    "cover_part": "{{node}}：{{n}} 人",
    "cover_dlg": "委派：{{org}}",
    "no_one_covers": "目前沒有人能看這一戶的影像",
    "whole_org_hint": "每開一個點都要自己看？在「整個組織」指派自己一次（自我授權），之後新增的都會涵蓋",
    "unassigned_install": "未指派也能先裝機：組織管理員與設備庫存權限的成員可以預先指派、收編、配對設備（綁定不給任何人資料權）；錄影用設備預設值（依機種，連續或事件）；要改錄影設定、分享、解綁，先指定管理人（可以之後一次指定多戶）。",
    "self_manager_yellow": "你會成為這個{{leaf}}的管理人並取得全部錄影與事件。",
    "create_home": "建立{{leaf}}",
    "home_created": "已建立{{leaf}}「{{name}}」",
    "pick_target_hint": "選要移到哪個節點（只列你能管理、可以放下的節點）。",
    "move_node_title": "移動「{{name}}」",
    "move_node_confirm": "把「{{name}}」移到「{{to}}」？",
    "move_node_intro": "移動會改變這個子樹被哪些指派與委派涵蓋。",
    "move_action": "移動",
    "move_self_action": "搬移並取得存取",
    "moved": "已移動「{{name}}」",
    "move_homes_title_one": "把 {{count}} 戶移到…",
    "move_homes_title_other": "把 {{count}} 戶移到…",
    "move_homes_confirm_one": "把 {{count}} 戶移到「{{to}}」？",
    "move_homes_confirm_other": "把 {{count}} 戶移到「{{to}}」？",
    "move_homes_intro": "一次預覽、一次確認；全部成功或全部不動。",
    "move_homes_action_one": "搬移 {{count}} 戶",
    "move_homes_action_other": "搬移 {{count}} 戶",
    "homes_moved_one": "已搬移 {{count}} 戶",
    "homes_moved_other": "已搬移 {{count}} 戶",
    "manager_dialog_title_one": "指定 {{count}} 戶的管理人",
    "manager_dialog_title_other": "指定 {{count}} 戶的管理人",
    "manager_pick": "新管理人（本組織成員）",
    "manager_effect_one": "{{name}} 會成為這 {{count}} 戶的管理人（$t(leaf.cur)擁有者）：看得到全部錄影與事件（$t(leaf.cur)角色不受涵蓋起點限制，含指定之前的）、可以改錄影設定、分享、解綁；現有的節點指派不變",
    "manager_effect_other": "{{name}} 會成為這 {{count}} 戶的管理人（$t(leaf.cur)擁有者）：看得到全部錄影與事件（$t(leaf.cur)角色不受涵蓋起點限制，含指定之前的）、可以改錄影設定、分享、解綁；現有的節點指派不變",
    "all_or_nothing": "全部成功或全部不動。",
    "self_manager_batch_one": "你選了自己：這是一次自我授權，會取得這 {{count}} 戶的全部錄影；其他管理員會收到一則通知，並記入稽核。",
    "self_manager_batch_other": "你選了自己：這是一次自我授權，會取得這 {{count}} 戶的全部錄影；其他管理員會收到一則通知，並記入稽核。",
    "manager_submit_one": "指定 {{count}} 戶的管理人",
    "manager_submit_other": "指定 {{count}} 戶的管理人",
    "managers_done_one": "{{name}} 已成為 {{count}} 戶的管理人",
    "managers_done_other": "{{name}} 已成為 {{count}} 戶的管理人",
    "levels_hint": "組織維護一份層級名稱清單，每個節點自己選；同一層可以不同名稱。最多 12 個，每個 1–20 字。",
    "level_n": "層級名稱 {{n}}",
    "from_builtin": "原本的內建名稱",
    "add_level": "＋ 層級名稱",
    "leaf_label": "$t(leaf.cur)的名稱（例：戶、點、店）",
    "levels_preview": "預覽",
    "levels_no_perm": "名稱不決定權限。",
    "levels_builtin_warn": "內建名稱會改成目前語系的文字，其他語系的成員也會看到這段文字；用這些內建名稱的節點會一起改。",
    "levels_saved": "層級名稱已儲存",
    "levels_err_too_many": "最多 12 個層級名稱",
    "levels_err_length": "每個名稱 1–20 字",
    "levels_err_at_prefix": "自訂名稱不能以 @ 開頭",
    "levels_err_duplicate": "名稱不能重複",
    "previewing": "正在計算影響…",
    "preview_again": "重新預覽",
    "preview_restaled": "預覽後資料有變動，已重新預覽並標出變了的列，請再確認一次。",
    "losing_title": "會失去經組織樹的存取（{{n}} 人，含群組展開 · {{orgs}} 個受託組織）",
    "gaining_title": "會得到存取（{{n}} 人）",
    "history_from": "新得到存取的人從 {{time}} 起算，看不到之前的錄影與事件。",
    "remaining_title": "之後仍有存取（不是經組織樹來的，中斷繼承擋不到）",
    "other_paths": "仍經其他路徑看得到（見下）",
    "target_still": "{{name}} 仍經這條看得到",
    "granter_still": "授予者仍經{{path}}看得到",
    "keep": "保留",
    "also_revoke": "一併撤銷",
    "path_home_role": "$t(leaf.cur)角色",
    "path_site_grant": "場域授權",
    "path_share_user": "分享給個人",
    "path_share_org": "分享給組織",
    "path_assignment": "子樹內的指派",
    "path_delegation": "子樹內的委派",
    "granted_by_target_title": "他授出、仍有效的指派",
    "still_visible": "之後仍有 {{n}} 人看得到 {{target}}：{{who}}",
    "more_rows": "還有 {{n}} 人",
    "impact_scope": "受影響：{{homes}} 個戶、{{devices}} 台",
    "active_streams": "目前 {{n}} 人正在看影像（30 秒內停止）",
    "dlg_gained": "{{org}} 的委派會因此多涵蓋 {{n}} 個戶；送出後會通知委派方的擁有者與所有管理員，以及受託方。",
    "dlg_lost": "{{org}} 的委派會因此少涵蓋 {{n}} 個戶（立即生效，雙方都會收到通知）。",
    "self_gain_generic": "這次寫入會讓你自己新得到資料權（自我授權）：理由必填，其他組織管理員與擁有者會收到通知，並記入稽核。",
    "block_on_title": "在「{{name}}」開啟中斷繼承？",
    "block_off_title": "在「{{name}}」關閉中斷繼承？",
    "block_on_intro": "開啟後，更上層的指派與委派不再適用於 {{name}} 以下（{{homes}} 個戶、{{devices}} 台）；{{name}} 自己的指派照常。上層的節點管理員之後看不到 {{name}}（計數、存取、稽核都不列）。",
    "block_off_intro": "關閉後，上層的指派與委派會重新涵蓋 {{name}} 以下；重新得到存取的人從現在起算。",
    "block_on_action": "開啟中斷繼承",
    "block_on_action_revoke": "開啟中斷繼承並撤銷 {{n}} 筆",
    "block_off_action": "關閉中斷繼承",
    "block_off_self_action": "關閉並取得存取",
    "block_on_note": "之後如果關閉中斷繼承，重新得到存取的人從關閉的時間起算，看不到中斷期間的錄影。",
    "blocked_done": "已在「{{name}}」開啟中斷繼承",
    "unblocked_done": "已在「{{name}}」關閉中斷繼承",
    "revoke_assign_title": "撤銷 {{who}} 在「{{node}}」的指派？",
    "revoke_assign_body": "會失去：{{what}}（新請求立即拒、正在看的影像 30 秒內停止）",
    "revoke_assign": "撤銷指派",
    "revoke_node_admin_intro": "撤銷節點管理員前，先看他授出、仍有效的指派，可一併撤銷；沒勾的照舊有效。",
    "revoked": "已撤銷",
    "steps": "步驟",
    "step_who": "對象",
    "step_role": "角色",
    "step_term": "期限 / 時段",
    "step_confirm": "確認",
    "assign_title": "在「{{node}}」指派",
    "assign_edit_title": "編輯 {{name}} 的指派",
    "assign_d_title": "指派「{{path}}」給本組織成員",
    "who": "人員或成員群組",
    "who_search": "搜尋人員、成員群組",
    "d_node_label": "節點（委派子樹內，可以選子節點；只有名稱與結構數）",
    "covers_now": "涵蓋目前 {{homes}} 個戶、{{devices}} 台（結構總數）；",
    "covers_subtree": "涵蓋這個節點子樹內的全部戶；",
    "covers_tail": "之後新增的也會涵蓋；開了中斷繼承的子節點不涵蓋。",
    "effective_now": "實際生效：{{what}}",
    "not_effective": "不會生效：{{what}}",
    "not_effective_paren": "（不會生效：{{what}}）",
    "out_of_scope": "超出委派範圍：{{what}}",
    "ignored_box": "「{{role}}」含「{{what}}」，{{from}} 沒有委派這一項：這部分不會生效。",
    "pick_template": "選一個範本（範本勾了什麼就是什麼）",
    "assign_done": "已指派。",
    "assign": "指派",
    "assign_self": "指派自己",
    "self_yellow": "你會因此取得「{{scope}}」的影像（含錄影）。",
    "self_notify_others": "其他組織管理員與擁有者會收到通知，並記入稽核。",
    "self_notify_owner": "會通知擁有者並記入稽核。",
    "self_notify_audit_only": "會記入稽核。",
    "self_notify_d": "{{from}} 的擁有者與管理員也會收到通知。",
    "self_suggest_term": "建議設期限。",
    "reason_needed_self": "這次會讓你自己取得存取（自我授權），請填理由。",
    "d_visible_to_delegator": "{{from}} 看得到被指派人的顯示名稱、角色與操作紀錄。",
    "member_groups": "成員群組",
    "member_groups_hint": "成員群組只用在節點角色指派的對象（例：夜班保全）；一層、不巢狀。改成員要重新驗證；把自己加進已有指派的群組會讓你取得存取（自我授權）。",
    "group_new": "新增成員群組",
    "no_groups": "還沒有成員群組。",
    "group_name": "群組名稱",
    "group_members": "成員",
    "group_used": "使用中",
    "group_edit_title": "編輯成員群組：{{name}}",
    "group_delete_title": "刪除成員群組「{{name}}」？",
    "group_delete_body": "用這個群組的 {{n}} 筆指派會一起失效，群組成員 30 秒內停止經這些指派看影像。",
    "group_delete": "刪除群組",
    "self_group_yellow": "你把自己加進有 {{n}} 筆指派的群組，會因此取得這些節點的影像。",
    "dlg_out": "委派出去",
    "dlg_in": "委派給本組織",
    "dlg_out_of": "委派出去（{{org}}）",
    "dlg_in_of": "委派給本組織（{{org}}）",
    "no_dlg_out": "還沒有委派給其他組織。",
    "no_dlg_in": "還沒有其他組織委派給本組織。",
    "dlg_scope": "範圍",
    "dlg_forever_short": "永久",
    "dlg_new_by_code": "用對方的委派代碼新增",
    "still_needed": "仍需要",
    "reviewed": "已覆核：對 {{org}} 的委派仍需要",
    "tag_review": "待覆核",
    "tag_expiring": "即將到期",
    "tag_suspended": "暫停",
    "tag_ended": "已結束",
    "delegator_paren": "（委派人：{{name}}）",
    "dlg_mfa_note": "{{from}} 要求兩步驟驗證：被指派的成員也要開",
    "expandable": "範圍已擴大：{{n}} 筆指派可擴大",
    "apply_ellipsis": "套用…",
    "assign_members": "指派成員",
    "gen_code": "產生委派代碼",
    "gen_code_hint": "把代碼、QR 或連結交給要委派給你的組織；7 天內有效、用一次就失效。",
    "code_note": "備註",
    "code": "委派代碼",
    "code_qr": "委派代碼 QR",
    "code_valid": "有效到 {{date}}",
    "my_codes": "我產生的代碼",
    "code_expires": "{{date}} 失效",
    "code_cancel": "撤回",
    "dlg_new_title": "新增委派",
    "wz_code": "代碼",
    "wz_nodes": "節點",
    "wz_scope": "範圍與期限",
    "wz_confirm": "確認",
    "dlg_code_input": "對方的委派代碼",
    "dlg_code_hint": "對方在「委派給本組織」產生的代碼；請確認來自你認識的對象。",
    "requested_by": "請求人：{{name}}（{{domain}}）",
    "unverified_warn": "此組織未經平台審核，請確認代碼來自你認識的對象",
    "single_home_hint": "只要委派單一戶：先建一個節點、把戶搬進去，再委派那個節點。",
    "scope_view": "看（即時影像）",
    "scope_event_read": "事件",
    "scope_recording_read": "回放",
    "scope_alarm_receive": "處理警報",
    "scope_media_talk": "對講",
    "scope_device_control": "控制",
    "scope_security_arm": "遠端布防",
    "scope_security_disarm": "遠端撤防",
    "scope_device_maintain": "維運（韌體更新、重新開機、改名）",
    "scope_home_profile_read": "$t(leaf.cur)資料（地址、時區、地圖、平面圖）",
    "scope_recording_export": "下載 / 匯出錄影",
    "dlg_fixed_1": "解綁、格式化、權限、節點結構永遠留在委派方。",
    "dlg_fixed_2": "對方的 API / webhook 不會取得這些設備（只有對方的成員帳號）。",
    "dlg_fixed_3": "你要求的兩步驟驗證會套用到對方成員；你的 IP 允許清單、閒置逾時不套用。",
    "dlg_forever": "永久（每 12 個月提醒雙方覆核）",
    "dlg_until": "到期日（到期前 30 / 7 天提醒）",
    "dlg_history": "歷史",
    "dlg_history_now": "只從委派開始之後",
    "dlg_history_back": "往前追溯（最多 30 天）",
    "days_back": "天前起",
    "history_days_one": "往前 {{count}} 天",
    "history_days_other": "往前 {{count}} 天",
    "history_since": "從 {{date}} 起",
    "dlg_notify": "建立後會通知：{{from}} 的擁有者與所有組織管理員，以及 {{to}} 的擁有者與管理員",
    "dlg_self_related": "你也是 {{to}} 的成員：這次委派比照自我授權，理由必填、稽核會標記。",
    "dlg_create": "建立委派",
    "dlg_created": "已委派給 {{org}}",
    "dlg_detail_out": "委派給 {{org}}",
    "dlg_detail_in": "{{org}} 委派給本組織",
    "edit_scope": "編輯範圍",
    "extend_term": "延長 / 設期限",
    "revoke_dlg": "撤銷委派",
    "end_dlg": "結束委派",
    "end_dlg_title": "結束 {{from}} 委派給本組織的節點？",
    "end_dlg_body": "本組織成員經這筆委派的存取立即停止（影像 30 秒內停止），本組織在這筆委派下的指派一併失效；雙方稽核各記一筆。",
    "created_reviewed": "建立 / 覆核",
    "expanded_at": "{{date}} 擴大",
    "reviewed_at": "上次覆核 {{date}}",
    "created_by": "建立人 {{name}}",
    "policy": "套用的政策",
    "policy_mfa": "{{from}} 要求兩步驟驗證（IP 允許清單、閒置逾時不套用）",
    "policy_none": "沒有額外要求",
    "grantees_title": "{{org}} 的被指派人（唯讀）",
    "no_grantees": "對方還沒有指派任何成員。",
    "via_group": "經群組 {{ref}}",
    "recent_ops": "最近 30 天經這筆委派的操作：{{n}} 筆",
    "open_audit": "看稽核",
    "my_assignments_title": "本組織的指派",
    "no_d_assignments": "還沒有指派任何成員。",
    "can_expand": "可擴大",
    "delegator_sees_list": "{{from}} 看得到這份名單（顯示名稱、角色、實際生效、節點、期限；不含 email）",
    "revoke_dlg_title": "撤銷對 {{org}} 的委派？",
    "will_lose": "{{org}} 會失去（{{n}} 位被指派人）",
    "revoke_dlg_note": "送出後通知 {{org}} 的擁有者與管理員；他們的成員看到「已結束委派」，不只是「權限已更新」。",
    "dlg_revoked": "已撤銷對 {{org}} 的委派",
    "edit_scope_title": "編輯對 {{org}} 的委派範圍",
    "extend_term_title": "對 {{org}} 的委派期限",
    "edit_dlg_hint": "縮小立即生效、通知對方；擴大不用對方同意，對方既有的指派要按〔套用〕才會擴大。",
    "save_scope": "儲存範圍",
    "save_term": "儲存期限",
    "dlg_updated": "已更新委派",
    "apply_title": "套用 {{from}} 擴大的範圍",
    "apply_hint": "{{from}} 擴大了委派範圍；沒套用前照舊。勾要擴大的指派。",
    "apply_n": "套用 {{n}} 筆",
    "applied": "已套用 {{n}} 筆指派",
    "d_revoke_title": "撤銷 {{who}} 在「{{where}}」的指派？",
    "d_revoke_lose": "會失去：{{what}}",
    "d_revoke_streams": "此刻經這筆指派在看影像：{{n}} 人（30 秒內停止）",
    "d_revoke_notify": "設備異常通知下一則起不再送。",
    "d_revoke_yellow": "{{from}} 的委派詳情名單會拿掉他；雙方稽核各記一筆。",
    "err_rate_limited_one": "預覽太頻繁，{{count}} 秒後再試",
    "err_rate_limited_other": "預覽太頻繁，{{count}} 秒後再試",
    "err_depth": "節點最多 {{n}} 層",
    "err_limit": "已達上限 {{n}}",
    "err_busy": "組織樹正在更新，請稍後再試",
    "err_not_empty": "節點底下還有 {{homes}} 個戶、{{nodes}} 個子節點，先移走才能停用",
    "err_team_org": "只有團體組織能用節點指派與委派",
    "err_use_node_assignment": "「場域管理員」範本已停用，請改用節點指派",
    "err_code_gone": "委派代碼已過期、撤回或用過，請對方重新產生",
    "err_scope_exceeded": "這個角色跟委派範圍沒有交集，指派不會有任何作用",
    "err_cycle": "不能把節點移到自己底下",
    "err_out_of_anchor": "有設備的位置不在新的節點範圍內，先調整設備位置",
    "err_exceeds_actions": "不能給出超過你自己的動作",
    "err_exceeds_expires_at": "期限不能超過你自己的指派",
    "err_exceeds_schedule": "時段不能超過你自己的指派",
    "err_preview_stale": "預覽之後資料有變動，請重新預覽",
    "err_home_assigned": "選取裡有已指定管理人的戶，只能選未指派的戶",
    "err_conflict": "已經有一筆相同的委派或設定",
    "err_history_max_one": "最多往前追溯 {{count}} 天",
    "err_history_max_other": "最多往前追溯 {{count}} 天",
    "err_root_node": "「整個組織」不能這樣做",
    "err_invalid": "輸入的內容不正確",
    "err_forbidden_self_modify": "不能改或撤自己的指派",
    "err_forbidden_inheritance_boundary": "搬進或搬出中斷繼承的子樹只限擁有者與組織管理員",
    "err_forbidden_orgtree_not_open": "節點指派與委派尚未對這個組織開放",
    "pair_joined_no_access": "已加入；你沒有這一戶的影像權",
    "batch_mode": "批次移動 / 指定管理人",
    "batch_mode_move": "批次移動",
    "select_done": "完成選取",
    "select_hint": "勾選要處理的{{leaf}}",
    "struct_count_head": "數字 = 這一層以下的設備總數（含你沒有影像權的）",
    "site_tab_devices": "設備",
    "site_tab_access": "誰能存取",
    "site_tab_settings": "場域設定",
    "site_access_hint": "本節點指派、從上層繼承（唯讀）、委派出去（唯讀）、$t(leaf.cur)角色與分享都在這裡。",
    "maint_title": "維護",
    "block_short": "中斷繼承",
    "block_is_on": "已開啟",
    "block_is_off": "未開啟",
    "archive_desc": "停用後這個節點不再出現在樹上；底下還有戶或子節點時不能停用。",
    "site_dev_count": "你看得到 {{n}} 台（這裡以下共 {{homes}} 個戶）",
    "site_dev_name": "名稱",
    "site_dev_model": "機種",
    "site_dev_status": "狀態",
    "site_dev_home": "戶",
    "site_dev_online": "在線",
    "site_dev_offline": "離線",
    "site_dev_channels_one": "（{{count}} 個通道）",
    "site_dev_channels_other": "（{{count}} 個通道）",
    "site_dev_empty": "這裡以下還沒有設備。",
    "site_dev_hidden": "另有 {{n}} 個戶你沒有影像權，不列設備：{{names}}",
    "set_name": "名稱與層級",
    "set_tz": "時區",
    "set_tz_inherit": "跟上層（沒設定）",
    "set_tz_hint": "時段限制、排程與報表用這個時區；沒設定時跟上層。",
    "set_geo": "地址與座標",
    "set_address": "地址",
    "set_lat": "緯度",
    "set_lng": "經度",
    "set_geo_bad": "緯度與經度要一起填，而且是數字。",
    "set_saved": "已儲存。",
    "set_offline": "斷網可用（本地 VMS）",
    "set_offline_on": "外網斷了，這個場域的電腦仍可用本地 VMS 看 Kinio Station 的攝影機",
    "set_offline_hours": "最長可以斷網（小時）",
    "set_offline_hint": "開啟後，這個場域的成員可以在「我的帳號 › 本地 VMS」登記電腦；團隊組織最長 72 小時。",
    "set_offline_saved_on": "已開啟斷網可用。",
    "set_offline_saved_off": "已關閉斷網可用。",
    "set_computers": "登記過本地 VMS 的電腦",
    "set_computer_updated": "最後更新 {{date}}",
    "views_empty": "這裡放存過的影像牆版面，以及你自己整理的攝影機清單；在影像牆〔另存版面〕或按〔新增版面〕都會存到這裡。",
    "groups_empty": "群組是一組攝影機的名單，可以拿來輪巡、訂閱通知、一次開到影像牆。",
    "layout_cells_one": "版面 · {{count}} 格",
    "layout_cells_other": "版面 · {{count}} 格",
    "layout_open_tip": "開到影像牆並載入這個版面",
    "struct_totals2": "底下 {{nodes}} 個節點、{{homes}} 個戶、{{dev}}（結構總數）",
    "struct_dev_incl_one": "{{count}} 台（含通道）",
    "struct_dev_incl_other": "{{count}} 台（含通道）",
    "struct_dev_split": "{{devices}} 台設備、{{channels}} 個通道",
    "struct_count_tip_incl": "結構總數（台，目前含 NVR 通道）",
    "struct_count_tip_split": "結構總數（台，不含通道；另有 {{channels}} 個通道）",
    "struct_count_head_incl": "；目前含 NVR 通道",
    "set_autosave": "改了會自動儲存（離開欄位就存），不用按儲存。",
    "you_can_view_wall": "這個範圍有 {{n}} 個畫面，牆上放了其中 {{x}} 個",
    "tree_btn": "組織樹",
    "you_can_view_wall_paged": "這個範圍有 {{n}} 個畫面：這一頁 {{x}} 個，下一頁還有 {{rest}} 個",
    "home_devices": "{{count}} 台設備（結構總數）",
    "home_delete": "刪除這個{{leaf}}",
    "home_delete_desc": "設備會一起移除並回到原廠設定，錄影與事件會刪除，無法復原。",
    "home_delete_title": "刪除「{{name}}」？",
    "home_delete_warn_n": "這個{{leaf}}的 {{count}} 台設備會一起移除，並回到原廠設定。",
    "home_delete_warn_empty": "這個{{leaf}}沒有設備。",
    "home_delete_tail": "錄影與事件會刪除，成員會收到通知。刪除後無法復原。",
    "home_delete_archives_n": "這個{{leaf}}有 {{count}} 個長期保管中的匯出包（最晚保管到 {{date}}），刪除後會一起刪掉，已付的保管費用不退。",
    "home_delete_archives_n_nodate": "這個{{leaf}}有 {{count}} 個長期保管中的匯出包，刪除後會一起刪掉，已付的保管費用不退。",
    "home_delete_archives_unknown": "如果這個{{leaf}}有長期保管中的匯出包，會一起刪掉，已付的保管費用不退。",
    "home_delete_action": "刪除這個{{leaf}}（需要重新驗證）",
    "home_deleting": "刪除中…",
    "home_deleted": "已刪除「{{name}}」",
    "err_home_unbind_failed": "有設備解除綁定失敗，這個{{leaf}}沒有刪除，請稍後再試。",
    "err_home_not_found": "這個{{leaf}}已經不存在，或你看不到。",
    "err_home_delete_forbidden": "要組織擁有者 / 管理員或這個{{leaf}}的管理人才能刪除。",
    "high_risk_badge": "高風險：要填理由",
    "high_risk_reason_note": "（高風險委派：要填理由，送出立即生效）",
    "reason_required_body": "這次會擴大高風險委派（整個組織、匯出或解除警戒）：要填理由，送出後立即生效，並通知雙方的擁有者與管理員。",
    "err_high_risk_reason": "高風險委派要填理由",
    "dlg_notify_high_risk": "高風險委派：送出後立即生效。會通知 {{from}} 的擁有者與所有組織管理員，以及 {{to}} 的擁有者與管理員（通知帶建立者與理由）",
    "local_playback_full": "可回放本機錄影（SD 卡 / 硬碟，含分享 / 指派之前錄的）",
    "local_playback_full_hint": "打開後，這個人可以回放設備裡所有的本機錄影，包含分享 / 指派之前錄的；雲端錄影與事件照常只到開始的時間之後。只有組織擁有者或管理員能設定。",
    "lpf_on": "可以",
    "lpf_off": "不可以",
    "hm_title": "成員",
    "hm_you": "（你）",
    "hm_default_role": "跟著組織角色",
    "hm_add": "加入成員",
    "hm_pick": "選一位組織成員",
    "hm_add_submit": "加入",
    "hm_no_candidates": "組織裡沒有可以加入的成員",
    "hm_added": "已把 {{name}} 加成{{role}}",
    "hm_role_changed": "已把 {{name}} 改成{{role}}",
    "hm_remove": "移出",
    "hm_remove_title": "把 {{name}} 移出「{{home}}」？",
    "hm_remove_body": "{{name}} 會看不到這一戶的設備，仍是組織成員。",
    "hm_removed": "已移出 {{name}}"
  },
  "aiLocal": {
    "title": "誰在分析",
    "help": "每台攝影機目前由誰做 AI 分析。指派給本地 AI（AI box、NVR、Kinio Station 電腦版）的攝影機，雲端 AI 預設跳過、不扣雲端額度。",
    "local_too": "本地與雲端都分析",
    "local_too_help": "指派給本地 AI 的攝影機也送雲端 AI（會扣雲端額度；打開要重新驗證）",
    "col_camera": "攝影機",
    "col_analyzer": "分析者",
    "col_detail": "說明",
    "who_local": "本地 AI",
    "who_cloud": "雲端 AI",
    "who_both": "本地 + 雲端",
    "who_none": "無",
    "offline": "本地 AI 離線，事件暫時不分析",
    "excluded": "已排除雲端 AI",
    "status_pending": "套用中",
    "status_running": "執行中",
    "status_degraded": "降載",
    "status_unreachable": "取不到影像",
    "status_rejected": "提供者拒收",
    "who_unknown": "無法確認",
    "providers_failed": "讀不到這個$t(leaf.cur)的本地 AI 狀態",
    "not_queried": "這個$t(leaf.cur)的本地 AI 狀態看不到（分享進來的$t(leaf.cur)）",
    "cloud_failed": "讀不到雲端 AI 的同意或用量",
    "status_starting": "啟動中",
    "status_detector_error": "偵測器出錯",
    "status_other": "狀態：{{status}}"
  },
  "poeports": {
    "intro": "這台 Station 每個 PoE 孔的供電與接著的設備。沒回報的數值顯示「不知道」。",
    "none": "這台沒有回報 PoE 孔。",
    "unknown": "不知道",
    "col_port": "孔",
    "col_power": "供電",
    "col_meas": "量測",
    "col_link": "連線",
    "col_devices": "接著的設備",
    "col_actions": "動作",
    "st_disabled": "已關閉",
    "st_powered": "供電中",
    "st_idle": "未供電",
    "class": "等級",
    "temp": "溫度",
    "link_up": "已連線",
    "link_down": "未連線",
    "not_home": "未對到本$t(leaf.cur)通道",
    "macs_more": "還有更多設備（只列前 4 個）",
    "act_on": "開啟供電",
    "act_off": "關閉供電",
    "act_cycle": "重新上電",
    "confirm_on": "開啟孔 {{port}} 的供電？",
    "confirm_off": "關閉孔 {{port}} 的供電？",
    "confirm_cycle": "孔 {{port}} 重新上電？",
    "confirm_body": "接在這一孔的設備會斷電；攝影機會停止錄影直到重新開機完成。",
    "sending": "傳送中…",
    "done": "孔 {{port}} 已套用。",
    "not_persistent": "關掉的孔在 Station 重新開機後會自動恢復供電。",
    "err_FORBIDDEN": "需要維運權限才能控制 PoE 孔。",
    "err_UNSUPPORTED_COMMAND": "這台不支援 PoE 孔控制。",
    "err_BAD_PARAMS": "孔號不正確。",
    "err_HAL_ERROR": "設備沒有套用成功，請再試一次。",
    "err_DEVICE_OFFLINE": "設備離線，無法控制。",
    "err_COMMAND_TIMEOUT": "設備沒有回應，請稍後確認孔的狀態。",
    "err_other": "沒有成功（{{code}}）。"
  },
  "apikeys": {
    "title": "API 金鑰",
    "count": "{{n}} / {{limit}}",
    "hint": "金鑰代表你本人。Claude 用它做的事，跟你自己在這裡做的一樣，會記在你的名下。不要把金鑰貼到聊天、程式碼或文件裡；外洩了請立刻撤銷。這裡的金鑰只能用在 VMS（含 Kinio Node / Station）；develop portal 要在 portal 另建一把。",
    "created": "已建立「{{name}}」——金鑰只會顯示這一次：",
    "copy": "複製",
    "setup_hint": "打開電腦的終端機（macOS 的「終端機」、Windows 的 PowerShell）執行這一行，就會把 Kinio VMS 加進 Claude（不用裝程式）。不要貼進 Claude 的對話框，金鑰會留在對話紀錄裡：",
    "saved": "我已存好",
    "name": "名稱",
    "name_placeholder": "例：我的筆電 Claude",
    "scopes": "範圍",
    "last_used": "最後使用",
    "expires": "到期",
    "never_used": "還沒用過",
    "revoke": "撤銷",
    "revoke_confirm": "撤銷「{{name}}」？用這把金鑰的 Claude 最遲 5 分鐘內就不能再呼叫。",
    "revoke_all": "全部撤銷",
    "revoke_all_confirm": "撤銷全部 {{n}} 把金鑰？最遲 5 分鐘內全部失效。",
    "revoked": "已撤銷",
    "expired": "已到期",
    "empty": "建一把金鑰，讓 Claude 用你的權限查設備、事件與警報。",
    "need_mfa": "要先開兩步驟驗證（驗證器 App 或 passkey）才能建 API 金鑰。",
    "create": "建立金鑰",
    "days_one": "{{count}} 天",
    "days_other": "{{count}} 天",
    "limit_hint": "能做的永遠不超過你此刻的權限；團隊組織要管理員在安全政策打開「成員可用 API 金鑰」。建立、修改範圍、輪換、撤銷都要 5 分鐘內重新驗證過。",
    "media_confirm": "我了解：Claude 可以下載這些設備的畫面與錄影片段到我的電腦（每次都會記錄）",
    "console_confirm": "我了解：AI 助理或工具可以讀寫接在 Kinio Node 上的設備的序列埠",
    "control_confirm": "我了解：AI 助理或工具可以用我的身分控制我有權限的設備、改設定，包括 Kinio Node 指令與 Kinio Station 的本機設定",
    "pairing_confirm": "我了解：Claude / 工具可以用我連結的開發者帳號額度，替我開「配網時配發 AID」的配對（只在 DEV 雲端）",
    "scope_devices_read": "設備",
    "scope_devices_read_hint": "設備、$t(leaf.cur)與組織樹、狀態與設定、OTA 狀態、Kinio Node / Station",
    "scope_events_read": "事件與警報",
    "scope_events_read_hint": "事件清單、警報與處理狀態",
    "scope_recordings_read": "錄影時間軸",
    "scope_recordings_read_hint": "哪些時段有錄影（不含影片）",
    "scope_alarms_handle": "處理警報",
    "scope_alarms_handle_hint": "把警報標成已看到 / 我來處理 / 已處理 / 誤報",
    "scope_devices_console": "Kinio Node console",
    "scope_devices_console_hint": "讀寫接在 Kinio Node 上的設備的序列埠（寫入要管理角色），含區網直連 token",
    "scope_devices_control": "對設備下命令、改設定",
    "scope_devices_control_hint": "用我的身分開關設備、PTZ、錄影設定、自動化、Kinio Node 指令、Kinio Station 的本機設定（照我的角色）；刪除、原廠重置、格式化等會刪資料的操作不行",
    "scope_pairing_allocate": "配網時配發 AID（只在開發環境）",
    "scope_pairing_allocate_hint": "用我連結的開發者帳號額度，替我在 DEV $t(leaf.cur)開「配網時配發 AID」的配對；設備端仍要實際配網",
    "scope_media_snapshot_read": "快照",
    "scope_media_snapshot_read_hint": "事件快照、最近一張快照、即時拍照、錄影縮圖（每小時最多 60 張）",
    "err_API_KEY_MFA_REQUIRED": "要先開兩步驟驗證才能建 API 金鑰。",
    "err_API_KEY_LIMIT": "每個人最多 5 把使用中的金鑰，先撤銷不用的。",
    "err_API_KEY_PROD_WRITE": "這個環境的金鑰只能有讀取範圍。",
    "err_FEATURE_DISABLED": "這個環境不提供 API 金鑰。",
    "err_default": "沒有成功（{{code}}）",
    "scope_media_clip_read": "錄影片段",
    "scope_media_clip_read_hint": "一段最多 60 秒的雲端錄影下載網址（每天最多 20 次、合計 10 分鐘；要有匯出權）",
    "rotate": "輪換",
    "rotate_confirm": "輪換「{{name}}」？會用同樣的名稱、範圍與效期長度建一把新的金鑰（只顯示一次）；舊的 24 小時後失效，期間照常能用。",
    "rotated": "已輪換",
    "rotated_until": "{{at}} 失效",
    "rotated_created": "已輪換「{{name}}」——新金鑰只會顯示這一次：",
    "rotated_old_until": "舊金鑰到 {{at}} 前照常能用；把 Claude 換成新金鑰後，可以在清單先撤銷舊的。",
    "err_API_KEY_ROTATED": "這把金鑰已經輪換過，請用新的那把。",
    "edit_scopes": "修改範圍",
    "edit_scopes_title": "修改「{{name}}」的範圍",
    "edit_scopes_hint": "金鑰不變，Claude 不用重新設定；最遲 5 分鐘內生效。",
    "save_scopes": "儲存範圍",
    "scopes_saved": "範圍已更新；Claude 不用重新設定，最遲 5 分鐘內生效。",
    "err_NOT_FOUND": "沒有這把金鑰，或已經撤銷 / 到期。",
    "err_INVALID_ARGUMENT": "範圍不合法，請重新勾選。",
    "scope_devices_maintain": "改名與更新韌體",
    "scope_devices_maintain_hint": "改設備名稱、立即更新韌體、改自動更新設定（要維運權限）",
    "maintain_confirm": "我了解：AI 助理或工具可以替我改設備名稱、立即更新韌體（更新期間設備會離線幾分鐘）",
    "scope_vms_organize": "整理 VMS",
    "scope_vms_organize_hint": "我的版面、檢視、設備群組、搜尋條件、書籤與偏好；$t(leaf.cur)的房間、平面圖與擺放",
    "group_read": "讀取",
    "group_media": "影像（預設不勾）",
    "group_write": "寫入（預設不勾）"
  },
  "zed": {
    "snapshot_loading": "正在載入最新快照…",
    "live_connecting": "正在載入即時影像…",
    "no_snapshot": "沒有快照，按〔看即時〕載入畫面",
    "live_unavailable": "無法載入即時影像，仍可編輯",
    "snapshot_shown": "底圖是最新的事件快照",
    "view_live": "看即時",
    "back": "返回",
    "clear_all": "全部清除",
    "saving": "儲存中…",
    "saved": "已儲存",
    "mode_full": "全畫面",
    "mode_zones": "指定區域",
    "kept_hint": "已畫的 {{count}} 個區域會保留，切回「指定區域」還在",
    "surface": "偵測區域編輯區",
    "zone_label": "區域 {{n}}",
    "delete": "刪除區域 {{n}}",
    "full_frame": "全畫面",
    "count_one": "1 個區域",
    "count": "{{count}} 個區域",
    "limit_counter": "{{count}} / {{max}}",
    "read_only": "目前無法變更偵測區域。",
    "limit": "最多 {{max}} 個區域",
    "reported_updated": "已依設備回報更新。",
    "hint": "在畫面空白處拖曳畫出區域；點選區域可移動、拖四角縮放，選取後按 Delete 刪除。",
    "hint_full": "全畫面偵測：整個畫面都會觸發。要限定範圍請選「指定區域」。",
    "discard_title": "捨棄未儲存的變更？",
    "discard_body": "偵測區域的變更還沒有儲存，離開後會遺失。",
    "discard_body_schedule": "排程的變更還沒有儲存，離開後會遺失。",
    "discard": "捨棄",
    "tpl_all_day": "全天",
    "tpl_night": "夜間（18:00–06:00）",
    "tpl_office": "上班時間（週一到週五 09:00–18:00）",
    "tpl_clear": "清除",
    "device_tz": "設備時區：{{tz}}",
    "read_only_schedule": "目前無法變更排程。",
    "hint_schedule": "拖曳塗格：從關的格子開始拖是開啟、從開的格子開始拖是關閉；每格半小時。",
    "sum_all_day": "全天",
    "sum_off": "不啟用",
    "sum_custom": "自訂",
    "edit": "編輯",
    "view": "檢視",
    "offline": "設備離線，暫時不能變更",
    "no_write": "你沒有變更這項設定的權限",
    "load_failed": "讀不到設備目前的偵測區域設定，暫時只能檢視；請稍後再開一次",
    "layers": "圖層",
    "mask_off": "關",
    "mask_count_one": "1 個遮罩",
    "mask_count": "{{count}} 個遮罩",
    "mask_mode_off": "關",
    "mask_mode_on": "開",
    "mask_kept_hint": "已畫的 {{count}} 個遮罩會保留，切回「開」還在",
    "mask_warn": "遮罩在設備編碼前塗黑：即時影像、錄影、快照都看不到，之後也無法解除；遮罩內不會觸發偵測。",
    "mask_label": "遮罩 {{n}}",
    "mask_delete": "刪除遮罩 {{n}}",
    "mask_limit": "最多 {{max}} 個遮罩",
    "mask_hint": "在畫面空白處拖曳畫出要遮蔽的範圍；點選遮罩可移動、拖四角縮放，選取後按 Delete 刪除。",
    "mask_hint_off": "隱私遮罩關閉：畫面不遮蔽。要遮蔽請選「開」。",
    "read_only_masks": "目前無法變更隱私遮罩。",
    "discard_body_masks": "隱私遮罩的變更還沒有儲存，離開後會遺失。",
    "grid_full_frame": "全畫面",
    "grid_custom": "部分區域",
    "grid_cells": "偵測 {{count}} / {{total}} 格",
    "grid_fill": "全選",
    "grid_clear": "清除",
    "grid_cell": "第 {{row}} 列第 {{col}} 格",
    "grid_hint": "拖曳塗格：從沒選的格子開始拖是加入、從已選的格子開始拖是移除；全部不選 = 全畫面偵測。"
  },
  "poe": {
    "title": "偵測到 {{n}} 台新攝影機要位址",
    "new_camera": "偵測到新攝影機",
    "port": "PoE 第 {{port}} 孔",
    "asked": "要位址 {{count}} 次（第一次 {{first}}、最近 {{last}}）",
    "suspect_uplink_ip": "這台的位址像是上行網段的設備（例如路由器或你家的電腦），不是插在 PoE 孔的攝影機。不能一鍵加入；確定要加入請寫原因。",
    "suspect_uplink_arp": "上行網段看得到這台（可能是接在上行的設備）。不能一鍵加入；確定要加入請寫原因。",
    "suspect_other": "這台可能不是插在 PoE 孔的攝影機。不能一鍵加入；確定要加入請寫原因。",
    "approve": "加入",
    "ignore": "忽略",
    "force_reason": "強制加入的原因（至少 5 個字）",
    "force": "強制加入",
    "waiting_ip": "已核准，等攝影機拿到位址（最多 2 分鐘）…",
    "got_ip": "攝影機已拿到位址 {{ip}}。輸入攝影機的帳密接進通道。",
    "own_camera": "這是 Kinio 攝影機，NVR 會自己接進通道，不用帳密。",
    "add_channel": "接進通道",
    "added": "已接進通道。",
    "no_ip": "2 分鐘內攝影機沒有拿到位址：確認網路線與供電後再試。",
    "err_SUSPECT_UPLINK": "這台有上行網段嫌疑，要寫原因才能強制加入",
    "err_NOT_PENDING": "這台已經不在待核准清單（可能別人處理了）",
    "err_BAD_IP": "位址不能用（不在 PoE 網段或已配給別台）",
    "err_default": "操作失敗（{{code}}）",
    "wait_again": "再等一次",
    "block_title": "PoE 新攝影機（點開檢查有沒有要核准的）",
    "none": "目前沒有要核准的 PoE 攝影機。",
    "unsupported": "這台沒有 PoE 自動核准功能；請用「新增 ONVIF 攝影機」接入。"
  },
  "moment": {
    "title": "同一時刻",
    "help": "選一個時間點，看範圍內每台攝影機那一刻的畫面：那一刻有雲端錄影用雲端的縮圖，沒有就用 NVR 硬碟或 SD 卡的畫面。點一格從那一刻開始回放。",
    "at": "時間",
    "browser_tz": "時間以瀏覽器時區（{{tz}}）選；每格下方是該場域的當地時間",
    "filter": "篩選攝影機名稱",
    "none": "範圍內沒有可以回放的攝影機",
    "no_frame": "沒有雲端畫面",
    "more": "還有 {{n}} 台沒列出（一次最多 {{max}} 台），請用篩選或切換範圍縮小",
    "all_empty": "這一刻這些攝影機都沒有畫面（雲端、NVR 硬碟、SD 卡都沒有讀到）。可以換個時間，或用單路回放看前後的錄影。",
    "go_single": "看單路",
    "clip_suspect": "⚠ 雲端片段可能不完整",
    "clip_suspect_hint": "這一刻的雲端片段長度不合理，縮圖可能是綠色或停住；點進回放頁會先找其他來源",
    "no_cloud_at": "這個時間沒有雲端錄影",
    "from_local": "{{src}}的畫面（這個時間沒有雲端錄影）",
    "no_rec_at": "這個時間沒有錄影",
    "local_has": "{{src}}有這個時間的錄影（沒有縮圖）",
    "local_unknown": "沒有雲端錄影；讀不到 {{src}}（點開到回放頁看）",
    "no_cloud_scope": "這個範圍的攝影機最近兩個月都沒有雲端錄影；有本地錄影（NVR / Station 硬碟、SD 卡）的格子會顯示本地畫面。"
  },
  "hnodes": {
    "intro": "接在這台 Host 上的 Kinio Node 板子。斷電、重設、燒錄由持有 Host 的組織管理員操作。",
    "none": "這台 Host 目前沒有接節點。",
    "unknown": "不知道",
    "col_node": "節點",
    "col_health": "健康",
    "col_fw": "韌體",
    "col_seen": "最後回應",
    "col_thing": "節點設備",
    "h_healthy": "正常",
    "h_busy": "使用中",
    "h_unhealthy": "異常",
    "h_unknown": "不知道",
    "not_visible": "不在這個$t(leaf.cur)或沒有權限",
    "no_aid": "還沒讀到節點 AID"
  },
  "localvms": {
    "tab": "本地 VMS",
    "title": "斷網時的本地 VMS",
    "intro": "外網斷了，這個場域的 Station 照樣能用瀏覽器看即時、回放硬碟錄影。每台電腦要在有網路時先登記一次。",
    "no_stations": "沒有可以登記的 Station。經組織分享或委派取得權限的場域只能在雲端看。",
    "col_station": "錄影主機",
    "col_home": "$t(leaf.cur)",
    "col_offline": "斷網可用",
    "not_allowed": "場域沒有開「斷網可用」",
    "allowed": "已開啟",
    "max_hours": "最長 {{n}} 小時",
    "open_here": "在這台電腦開啟本地 VMS",
    "ask_admin": "—（請組織管理員到場域設定開啟）",
    "not_ready": "本地網址還在準備中（Station 要在線）",
    "fixed_ip_hint": "建議在路由器替 Station 保留固定位址（固定 IP），備援網址才不會失效。",
    "enrolled_title": "已登記的電腦",
    "enrolled_empty": "還沒有登記任何電腦。",
    "col_computer": "電腦",
    "col_updated": "最後更新",
    "col_expires": "到期",
    "fallback_update": "備援網址需要更新",
    "expired": "已到期",
    "expires_in": "{{n}} 天後到期",
    "days_left": "還有 {{n}} 天",
    "pin_locked": "PIN 已鎖（到 {{until}}）",
    "reset_pin": "重設 PIN",
    "redo": "重新登記",
    "redo_unavailable": "這台 Station 現在不能登記（場域沒開斷網可用，或本地網址還沒準備好）",
    "revoke": "撤銷",
    "revoke_confirm": "撤銷「{{label}}」？",
    "revoke_body": "這台電腦斷網時就不能再開「{{station}}」的本地畫面。Station 斷線中的話，最晚在它上線或斷網可用期限到時停用。",
    "revoked": "已撤銷「{{label}}」。",
    "pin_lock_hint": "PIN 連錯會暫時鎖住；有網路時按〔重設 PIN〕（要重新驗證身分）就能馬上再用。斷網時請店內管理員在 Station 螢幕解鎖。",
    "pin_reset_done": "「{{label}}」的 PIN 已重設。",
    "reset_pin_title": "重設「{{label}}」的本地 PIN",
    "reset_pin_body": "新的 PIN 會在 Station 上線時生效，錯誤次數歸零。",
    "pin_label": "這台電腦的本地 PIN（6 位數，斷網登入時要輸入）",
    "stepup_note": "接著要重新驗證身分（密碼 + 驗證碼）。",
    "pin_invalid": "PIN 要剛好 6 位數字。",
    "reset_pin_submit": "驗證並重設",
    "err_default": "沒有完成（{{code}}），請再試一次。",
    "err_REAUTH_REQUIRED": "要重新驗證身分才能完成。",
    "err_OFFLINE_NOT_ALLOWED": "這個場域沒有開「斷網可用」。",
    "err_CLOUD_REQUIRED": "這個場域只有在雲端才能看（你是經組織分享 / 委派取得權限）。",
    "err_NOT_FOUND": "找不到這筆登記。",
    "req_missing_title": "找不到這次登記",
    "req_missing": "連結不完整，請回到「設定 › 本地 VMS」重新開始。",
    "back": "回到本地 VMS 設定",
    "done_title": "這台電腦已登記",
    "done_body": "回到「{{station}}」的本地分頁，它會顯示完成。斷網時開主網址（已加入書籤）；名字打不開再開備援網址（只能看）。",
    "expired_title": "這次登記已過期",
    "expired_body": "登記要在 5 分鐘內完成。請回到清單重新開始。",
    "no_tab_title": "新分頁沒有打開本地畫面？",
    "no_tab_body": "這台電腦要接在「{{station}}」的區網上（同一個店內網路）才能登記。",
    "no_tab_continue": "如果新分頁有開起來，請在那邊繼續。",
    "waiting_title": "等待本地畫面",
    "waiting_body": "已在新分頁打開「{{station}}」的本地畫面。在那邊完成後，這裡會自動切換到確認畫面。",
    "popup_blocked": "瀏覽器擋住了新分頁，請按〔重新開啟〕。",
    "reopen": "重新開啟",
    "confirm_title": "讓這台電腦斷網也能看「{{station}}」？",
    "computer_name": "電腦名稱",
    "computer_name_ph": "例：監控室 PC-1",
    "confirm_body": "斷網時可用多久照場域設定；有網路時平台每天自動更新，這台電腦不用開著。權限照你在這個$t(leaf.cur)的角色。只綁這台電腦，最長 30 天要重新登記。",
    "code_main": "核對碼（主網址）：",
    "code_hint": "跟本地分頁顯示的一樣才繼續",
    "fallback_label": "備援網址：",
    "fallback_attached": "已加入（只能看）",
    "fallback_waiting": "等待中",
    "fallback_hint": "名字打不開時用；斷網登入一樣要輸入下面的 PIN。按確認時還是「等待中」就不登記備援網址。",
    "approve": "驗證並登記",
    "with_fallback": "含備援網址（只能看）",
    "pin_locked_plain": "PIN 已鎖",
    "someone": "使用者 …{{id}}",
    "home_title": "這個$t(leaf.cur)的其他登記",
    "home_hint": "你是$t(leaf.cur)的擁有者或管理員：可以撤銷別人在這些 Station 登記的電腦（只停那台電腦的本地 VMS，不影響對方的 App）。",
    "col_person": "登記的人",
    "err_LOCAL_VMS_LIMIT": "這台 Station 登記的電腦已達上限（{{limit}} 台），請先撤銷不用的電腦。",
    "err_LOCAL_VMS_REQUEST_EXPIRED": "這次登記已過期（5 分鐘），請重新開始。",
    "err_LOCAL_VMS_ALREADY_APPROVED": "這次登記已經確認過了。",
    "err_LOCAL_VMS_KEY_PENDING": "本地分頁還沒完成這台電腦的設定，請在本地分頁繼續。",
    "err_LOCAL_VMS_ENROLLMENT_EXPIRED": "這台電腦的登記已過期，請重新登記。",
    "err_INVALID_ARGUMENT": "電腦名稱必填（最多 64 字），PIN 要 6 位數字。",
    "not_allowed_short": "沒開",
    "not_allowed_banner_one": "有 {{count}} 台所在的場域沒有開「斷網可用」，還不能登記；請組織管理員到 組織與場域 › 場域設定 開啟。",
    "not_allowed_banner_other": "有 {{count}} 台所在的場域沒有開「斷網可用」，還不能登記；請組織管理員到 組織與場域 › 場域設定 開啟。"
  },
  "nenr": {
    "tab": "Kinio Node 開通",
    "title": "「{{name}}」的 Kinio Node 開通",
    "just_now": "剛剛",
    "min_ago": "{{n}} 分鐘前",
    "hour_ago": "{{n}} 小時前",
    "quota_title": "開通額度",
    "no_quota": "本組織還沒有 Kinio Node 開通額度。額度由平台配發，請聯絡你的經銷商或平台。",
    "quota_line": "{{type}} 剩 {{n}}",
    "alloc_line": "{{date}} 配發，剩 {{n}}",
    "find_title": "找節點",
    "find_help": "在節點 console 打 enroll_status，把整行貼上，或只貼 fp= 後面的 16 碼。",
    "enroll_url": "本平台的報到網址：{{url}}",
    "find_placeholder": "state=pending url=… keypwd=1 … fp=…",
    "find": "找",
    "name_hint": "節點的 Wi-Fi / 藍牙名稱只有 MAC 末 6 碼，不能用來找。",
    "bad_fp": "找不到 fp= 後面的 16 個十六進位字。",
    "wrong_platform": "這塊板子報到的是別的平台；請在 console 用 fac_set enroll 改成 {{url}}。",
    "not_found": "找不到可以開通的節點",
    "check_fp": "貼的是 fp= 後面 16 碼（或整行 enroll_status）",
    "check_pending": "節點還在報到（enroll_status 是 state=pending）",
    "check_url": "節點的 url= 是本平台的報到網址 {{url}}",
    "check_quota": "這個機種本組織有開通額度",
    "contact": "還是找不到請聯絡平台，並提供：指紋前 8 碼 {{fp8}}、時間 {{at}}。",
    "fw": "韌體",
    "last_seen": "最近報到",
    "maybe_offline": "節點可能已離線",
    "mac_conflict": "同一個 MAC 有兩筆報到，請聯絡平台處理。",
    "keypwd_missing": "板子還沒設開通密碼：先在 console 打 fac_set keypwd …",
    "identify": "閃燈",
    "identify_waiting": "等節點報到（約 1 分鐘內）會閃白燈 30 秒",
    "identify_blinking": "正在閃白燈（30 秒）",
    "identify_missed": "節點 90 秒內沒報到，可能已離線",
    "approve": "開通…",
    "approve_title": "開通 Kinio Node",
    "alloc": "用哪筆配發",
    "alloc_pick": "選一筆",
    "note": "備註（選填）",
    "note_placeholder": "一行、200 字內，不寫 email、電話、地址",
    "note_bad": "備註只能一行、最多 200 字",
    "approve_explain": "用掉「{{name}}」一顆開通額度（之後剩 {{n}}），這塊板子歸「{{name}}」持有。開通後不能自己撤銷，開錯要聯絡平台。",
    "confirm": "我已確認這是本組織的板子（指紋是從板子的 console 讀的，或看過閃燈）",
    "approve_do": "開通",
    "wait_online": "已開通，等節點上線（下次報到約 1 分鐘內會領到身分）",
    "now_online": "已上線",
    "not_online_long": "節點還沒上線：可能是燒錄的開通密碼（keypwd）跟這筆配發不符，請聯絡平台。",
    "approved_title": "本組織開通過的",
    "approved_empty": "還沒有開通過節點。",
    "col_at": "開通時間",
    "col_model": "機種",
    "col_by": "開通者",
    "col_note": "備註",
    "col_state": "狀態",
    "by_member": "本組織成員",
    "by_platform": "平台",
    "online": "在線",
    "last_online": "最後上線 {{at}}",
    "revoked": "已停用",
    "revoked_hint": "平台收回後，板子要在 console 打 fac_cred clear 再重開機才會重新報到。",
    "pair_hint": "要放進$t(leaf.cur)：用 App 的區網配對把它加進$t(leaf.cur)。",
    "err_gone": "這台現在不能開通了（可能已被開通或被平台處理），請重新找。",
    "err_lookup_limit": "找不到的次數太多，{{at}} 後再試。",
    "err_daily_cap": "你 24 小時內已開通 100 台，{{at}} 後再試，或請組織管理員開通。",
    "err_no_quota": "這筆配發用完了，請選別筆或向平台申請。",
    "err_alloc": "這筆配發不能用在這台。",
    "err_mac_in_use": "這個 MAC 已經屬於另一顆有效的設備身分，請聯絡平台。",
    "err_forbidden": "你的權限已變更，請重新整理。",
    "err_unavailable": "暫時無法開通，請稍後再試。"
  },
  "ncon": {
    "close": "關閉",
    "status_idle": "未連線",
    "status_ticket": "要票中…",
    "status_connecting": "連線中…",
    "status_opening": "等設備回應…",
    "status_open": "已連線",
    "status_reconnecting": "設備重新連線中…",
    "status_closed": "已斷線",
    "reason_device_offline": "設備離線",
    "reason_data_lost": "中間有資料接不上",
    "reason_session_superseded": "被新的連線取代（設備韌體不能續傳）",
    "reason_device_revoked": "設備已撤銷",
    "reason_DEVICE_OFFLINE": "設備離線，連上後再試",
    "reason_RATE_LIMITED": "開太頻繁，稍後再試",
    "reason_NOT_FOUND": "沒有這台的權限",
    "reason_NOT_SUPPORTED": "這台不支援終端機",
    "reason_NETWORK": "連不到 Kinio",
    "role_me": "你可以輸入",
    "role_other": "別人正在輸入，你只能看",
    "role_none": "目前沒人輸入",
    "take": "取得寫入權",
    "release": "交出寫入權",
    "lost": "斷線時有 {{n}} 個位元組接不上。",
    "rebooted": "設備重開過。",
    "dropped": "網路太慢，掉了 {{n}} 段輸出。",
    "in_dropped": "設備來不及收，{{n}} 個輸入位元組沒送到。",
    "err_NOT_WRITER": "你沒有寫入權",
    "err_RATE_LIMITED": "輸入太快，稍後再送",
    "err_DEVICE_RECONNECTING": "設備重新連線中，稍後再送",
    "input_ro": "取得寫入權後才能輸入（按鍵不會送出）",
    "title": "終端機",
    "via_platform": "經 Kinio 平台",
    "auto_reconnect": "連線中斷，自動重新連線",
    "clear": "清畫面",
    "reconnect": "重新連線",
    "popout": "新視窗",
    "tunnel": "複製連線指令",
    "tunnel_hint": "在你電腦原本的終端機跑這行，nodectl 會自動選路：跟 Kinio Node 同一個區網就直連，不同網路經 Kinio 平台中繼。Ctrl-] 離開。",
    "tunnel_step_download": "下載 nodectl：develop portal〔平台工具〕的 Kinio Node 套件（macOS、Linux、Windows）。",
    "tunnel_step_key": "金鑰：把自己的 VMS 金鑰設成環境變數 KINIO_VMS_KEY，金鑰範圍要勾「Kinio Node 區網 console」。",
    "tunnel_key_link": "到 API 金鑰",
    "tunnel_step_writer": "跟網頁終端機同時開時，網頁這邊的寫入權照常運作；nodectl 直連時不經寫入權。",
    "copy": "複製",
    "copied": "已複製",
    "direct": "進階：用自己的工具直接連",
    "direct_hint": "只在你要用自己的工具直接連這台 Kinio Node 時用：拿一把短期直連 token 與區網位址（8788，kttl/2）。平常用網頁終端機或上面的 nodectl 指令就好，會自動選路。",
    "direct_confirm": "我了解：拿到 token 的人可以讀寫接在這台 Kinio Node 上的設備的序列埠",
    "direct_get": "拿直連 token",
    "direct_addr": "區網位址",
    "direct_token": "token",
    "direct_no_lan": "節點沒回報區網位址，只能經平台連線（nodectl ttl 會自動走中繼）",
    "direct_token_once": "只顯示這一次（{{id}}），{{at}} 到期",
    "reason_FIRMWARE_UNSUPPORTED": "節點韌體太舊（要 1.0.52 以上）",
    "connect_ro": "連線（唯讀）",
    "intro": "這是 Kinio Node 接的設備的序列埠（root shell），給安裝與開發用。連線後看得到別人正在下的指令與輸出；先以唯讀連線，要輸入再取得寫入權。",
    "take_ellipsis": "取得寫入權…",
    "take_confirm_title": "要在 {{name}} 的序列埠輸入指令？",
    "take_confirm_body": "你輸入的會直接送到設備（root）。目前有其他人連線時，他們會變成唯讀。",
    "take_confirm_others": "現在有其他人連線中；會把寫入權從正在輸入的人那裡拿過來。",
    "others_n_one": "另外 {{count}} 人連線中",
    "others_n_other": "另外 {{count}} 人連線中",
    "need_admin": "需要管理員才能輸入（組織管理員、節點管理員、安裝技師或$t(leaf.cur)擁有者 / 管理員）；你可以看輸出。",
    "write_forbidden": "你的角色不能在這台輸入，需要管理員（組織管理員、節點管理員、安裝技師或$t(leaf.cur)擁有者 / 管理員）。已回到唯讀。",
    "reason_FORBIDDEN": "需要管理員才能拿直連 token（它可以在這台輸入）"
  },
  "devacct": {
    "tab": "開發者帳號",
    "title": "開發者帳號",
    "hint": "把開發者入口的開發者帳號連到這個帳號：輸入開發者入口〔App 帳號連結〕產生的 8 碼。連結後開發者帳號可以用名下的 AID 在這個帳號配對設備，但看不到你的設備影像、事件或錄影。",
    "code_label": "連結碼（8 碼）",
    "next": "下一步",
    "where": "在開發者入口：帳號與安全 › App 帳號連結 › 產生連結碼。",
    "where_dev": "在 DEV 的開發者入口：帳號與安全 › App 帳號連結 › 產生連結碼（碼 10 分鐘內有效、只能用一次）。",
    "confirm_title": "要連結這個開發者帳號嗎？",
    "confirm_who": "{{email}}（開發者帳號）要連結你的這個帳號。兩個帳號都是你本人的才確認；別人傳給你的連結碼請不要確認。",
    "confirm_can_dev": "連結後這個開發者帳號可以：用它名下的 AID 額度在這個帳號配對沒燒 AID 的設備；把雲端模擬開發機放進你是擁有者 / 管理員的 DEV 雲端家庭；讓它所屬開發者組織的成員對你 DEV 雲端家庭裡該組織機種的設備推開發版韌體；讓這個帳號在 DEV 雲端可以建家庭。它不能看你的設備影像、事件或錄影。你可以隨時在「開發者帳號」解除。",
    "confirm_can_prod": "連結後這個開發者帳號可以：用它名下的 AID 額度在這個帳號配對沒燒 AID 的設備；讓這個帳號加入它的產品測試回合。它不能看你的設備影像、事件或錄影。你可以隨時在「開發者帳號」解除。",
    "confirm": "確認連結",
    "linked_done": "已連結 {{email}}。",
    "linked_at": "{{date}} 連結",
    "unlink": "解除",
    "unlink_confirm": "解除後不能再用這個帳號配發 AID、開發者不能對它的開發機推韌體。",
    "kind_grant": "額度授權",
    "grant_title": "要接受這個開發者帳號的 AID 額度授權嗎？",
    "grant_who": "{{email}}（開發者帳號）要把它名下的 AID 額度授權給你這個 App 帳號。這不一定是你本人的帳號——只有你認得、且同意讓它用你這個帳號配設備時才確認；不確定就不要確認、回報給 {{brand}}。",
    "grant_can": "接受後這個開發者帳號可以：用它名下的 AID 額度在你這個帳號配對沒燒 AID 的設備（每天有上限，每次都會通知你）。它不能看你的設備、影像、事件或錄影，不能推韌體、放模擬器、或在你帳號建家庭。你可以隨時在「開發者帳號」解除。",
    "grant_confirm": "確認授權",
    "grant_done": "已接受 {{email}} 的 AID 額度授權。",
    "grant_linked_at": "{{date}} 接受授權",
    "grant_unlink_confirm": "解除後這個開發者帳號不能再用它的額度在你這個帳號配設備。已配好的設備留在你這裡。",
    "err_LINK_CODE_GONE": "連結碼無效或已過期，請回開發者入口重新產生。",
    "err_gone_dev_hint": "這組碼如果是在 DEV 的開發者入口產生的，要用 DEV 雲端的帳號確認。",
    "err_LINK_POOL_MISMATCH": "這組碼要用另一個 App 的帳號確認。",
    "err_APP_ACCOUNT_LINKED": "這個帳號已經連結別的開發者帳號，先解除才能連新的。",
    "err_APP_LINK_EXISTS": "這個開發者帳號已經連結這個 App 的另一個帳號，請先在開發者入口解除。",
    "err_LINK_TARGET_MISMATCH": "這組碼不是給這個帳號的；請對方用你這個 App 帳號的 email 重新產生。",
    "err_RATE_LIMITED": "嘗試太多次，請稍後再試。",
    "err_INVALID_ARGUMENT": "連結碼是 8 個英數字。",
    "err_REAUTH_REQUIRED": "要先重新驗證身分才能確認。",
    "err_WRONG_ACCOUNT_POOL": "開發者帳號不能在這裡確認，請用 App 帳號登入。",
    "err_default": "沒有完成（{{code}}）"
  },
  "navg": {
    "watch": "監看",
    "manage": "設備與場域",
    "org": "組織管理"
  },
  "orggate": {
    "capsule": "組織：{{name}}",
    "pick_title": "要管理哪個組織？",
    "pick_body": "目前範圍是「全部」。選一個組織，頁首的範圍也會切到那裡。",
    "your_role": "你的角色：{{role}}",
    "devices_one": "{{count}} 台設備",
    "devices_other": "{{count}} 台設備"
  },
  "time": {
    "just_now": "剛剛",
    "min_ago_one": "{{count}} 分鐘前",
    "min_ago_other": "{{count}} 分鐘前",
    "hour_ago_one": "{{count}} 小時前",
    "hour_ago_other": "{{count}} 小時前",
    "day_ago_one": "{{count}} 天前",
    "day_ago_other": "{{count}} 天前"
  },
  "user": {
    "me": "我",
    "menu": "帳號選單",
    "tz": "時間顯示",
    "tz_site": "場域時區",
    "tz_browser": "我的時區",
    "version": "{{brand}} · 版本 {{version}}（網頁 {{build}}）",
    "version_copy": "複製版本資訊",
    "version_copied": "已複製",
    "map_provider": "地圖供應商",
    "map_auto": "依地區自動選"
  },
  "gsearch": {
    "label": "全域搜尋",
    "placeholder": "搜尋設備、場域、人、功能…  {{key}}",
    "g_pages": "頁面",
    "g_devices": "設備",
    "g_places": "場域與$t(leaf.cur)",
    "g_people": "人",
    "g_events": "事件",
    "in_events": "在事件中搜尋「{{q}}」",
    "places_failed": "場域與$t(leaf.cur)查不到，其他結果照常",
    "seats": "雲端錄影席次",
    "syn_overview": "首頁,儀表板,健康",
    "syn_live": "影像牆,看畫面,直播",
    "syn_playback": "錄影,時間軸,看錄影",
    "syn_events": "警報,偵測,告警",
    "syn_map": "平面圖,位置",
    "syn_exports": "匯出,下載,證據包,驗證",
    "syn_devices": "攝影機,NVR,設備清單,新增設備,配對",
    "syn_firmware": "韌體,更新,OTA,版本",
    "syn_inventory": "庫存,認領,序號,未歸戶,偵測到的",
    "syn_enroll": "開通,Kinio Node,node",
    "syn_sites": "場域,組織結構,節點,樓層,據點,指派",
    "syn_rules": "規則,自動化,場景",
    "syn_backup": "備份,異地",
    "syn_people": "成員,權限,授權,角色,分享,委派,邀請",
    "syn_audit": "稽核,紀錄,操作紀錄",
    "syn_billing": "方案,帳單,付款,訂閱,購買",
    "syn_seats": "席次,雲錄,雲端錄影",
    "syn_org": "組織,安全政策,MyCam 政策,層級名稱",
    "syn_account": "帳號,個人設定,設定,兩步驟驗證,密碼,passkey,登入裝置",
    "syn_apikeys": "API 金鑰,API,金鑰,token",
    "syn_notify": "通知設定,勿擾,浮動通知,email",
    "syn_verify": "驗證,證據包,SHA-256,簽章",
    "syn_access": "存取權,權限,授權,給存取權,$t(leaf.cur)成員,分享,指派",
    "syn_external": "對外,委派,委派代碼,分享給本組織",
    "g_other": "其他範圍",
    "only_other": "目前範圍沒有符合的結果；其他範圍有 {{n}} 筆（點了會先切範圍）",
    "syn_shares": "分享,連結,收件人,撤銷,浮水印"
  },
  "devtabs": {
    "all": "全部設備",
    "firmware": "韌體",
    "inventory": "庫存",
    "add": "新增",
    "add_kinio": "新增 Kinio 設備",
    "add_onvif": "新增 ONVIF 攝影機",
    "add_enroll": "開通 Kinio Node",
    "add_claim": "用序號認領",
    "enroll": "開通",
    "add_kinio_channel": "把 Kinio 攝影機接到錄影主機的通道"
  },
  "toastpref": {
    "title": "浮動通知",
    "help": "新通知要不要在畫面右下角跳出來。只影響這台電腦；鈴鐺裡的通知照常都在。",
    "alarm": "只有警報（建議）",
    "alarm_help": "布防中的偵測、感測器觸發、門鈴、帳號安全",
    "alarm_detect": "警報與偵測",
    "alarm_detect_help": "另外加上一般的移動、人、車偵測",
    "none": "都不跳",
    "none_help": "只看鈴鐺（警報卡也不跳；影像牆指定格位照常）"
  },
  "iam": {
    "tab_access": "存取權",
    "tab_external": "對外",
    "left_member": "已離開的成員",
    "a_group": "成員群組",
    "an_org": "另一個組織",
    "org_role_other": "其他角色",
    "home_role": "$t(leaf.cur){{role}}",
    "src_org_role": "組織角色",
    "src_home_role": "$t(leaf.cur)角色",
    "src_site_grant": "場域授權",
    "src_node_assignment": "節點指派",
    "src_share": "分享",
    "src_delegation": "委派",
    "col_who": "對象",
    "col_where": "範圍",
    "col_what": "能做什麼",
    "col_source": "來源",
    "col_term": "期限",
    "inherited_from": "從「{{path}}」繼承（唯讀）",
    "filter_who": "篩選對象",
    "filter_who_all": "全部的人",
    "filter_where": "篩選範圍",
    "filter_where_all": "全部範圍",
    "filter_source": "篩選來源",
    "filter_source_all": "全部來源",
    "grant_btn": "＋ 給存取權",
    "empty": "沒有符合的存取權。",
    "more": "載入更多",
    "details": "詳情",
    "revoke": "撤銷",
    "revoke_title": "撤銷 {{who}} 在「{{where}}」的存取？",
    "revoke_body": "對方 30 秒內會失去這裡的即時影像、回放與控制。",
    "revoke_body_home_role": "會把他從這個$t(leaf.cur)的成員移除，30 秒內停止他正在看的影像。",
    "revoke_body_share": "分享會結束，對方 30 秒內看不到這些設備。",
    "revoke_body_site_grant": "場域授權會撤銷，對方 30 秒內會失去這些設備的存取。",
    "revoke_action": "撤銷存取",
    "revoke_gone": "這筆存取已經不在了，請重新整理。",
    "revoked": "已撤銷 {{who}} 的存取。",
    "refresh": "刷新",
    "refresh_hint": "依目前的設備重新展開（之後新增的設備不會自動加入）",
    "refreshed": "已依目前的設備重新展開 {{who}} 的存取。",
    "all_now": "這一戶現在的所有設備（之後新增的設備不會自動加入）",
    "grant_title": "給存取權",
    "step_who": "給誰",
    "step_where": "哪裡",
    "step_what": "能做什麼",
    "step_term": "多久",
    "kind_member": "本組織成員",
    "kind_member_desc": "組織裡的人",
    "kind_group": "成員群組",
    "kind_group_desc": "一次給一群人（只能給節點）",
    "kind_org": "另一個組織",
    "kind_org_desc": "委派場域給對方代管，或把設備分享給服務商",
    "kind_person": "組織外的個人",
    "kind_person_desc": "用 email 分享某一戶的設備",
    "person_hint": "對方有帳號就立即生效，沒有會收到邀請信；畫面一律只顯示「已送出」。",
    "org_delegation": "用對方的委派代碼",
    "org_delegation_desc": "把場域交給另一個組織代管，對方再指派他們的人",
    "org_share": "用對方的分享請求代碼",
    "org_share_desc": "把某一戶的設備分享給安裝商、保全或監控中心",
    "where_hint": "挑一個節點（含底下的子場域與戶）或一個戶。",
    "where_hint_group": "成員群組只能給節點（含底下的子場域與戶）。",
    "picked": "已選：{{where}}",
    "size_node": "{{homes}} 戶、{{devices}} 台",
    "size_home_one": "{{count}} 台",
    "size_home_other": "{{count}} 台",
    "size_list": "指定 {{n}} 台",
    "devices_all": "這一戶現在的所有設備（之後新增的設備不會自動加入）",
    "devices_list": "只選幾台",
    "devices_list_na": "只選幾台（你沒有這一戶的影像權，不能逐台挑）",
    "role_node_admin": "管理這個場域（節點管理員）",
    "role_operator": "看與操作（操作員）",
    "role_viewer": "只看（觀看者）",
    "role_installer": "安裝調校（安裝技師）",
    "role_maintainer": "設備維運（維運員）",
    "role_custom": "自訂…",
    "role_custom_desc": "用自訂角色範本的動作",
    "term_n_days": "天數",
    "term_max": "最長 90 天",
    "term_window_label": "只在某些時段",
    "term_days_one": "{{count}} 天",
    "term_days_other": "{{count}} 天",
    "term_window": "每天 {{from}}–{{to}}",
    "site_grant_term": "指定到單一戶的存取一定有期限（最長 90 天），到期前可以延長。",
    "summary": "{{who}} 可以{{verb}} {{where}}{{size}}，{{term}}",
    "verb_node_admin": "管理",
    "verb_operator": "看與操作",
    "verb_viewer": "只看",
    "verb_installer": "安裝調校",
    "verb_maintainer": "維運設備",
    "verb_custom": "照「{{name}}」使用",
    "verb_share": "「{{what}}」",
    "grant_submit": "給存取權",
    "done": "已給 {{who}}「{{where}}」的存取。",
    "done_share": "已送出分享給 {{email}}。",
    "done_org_share": "已同意分享請求。",
    "drawer_title": "{{name}} 能做什麼",
    "org_role": "組織角色",
    "powers": "組織權限",
    "no_powers": "沒有組織事務的權限（能看什麼看下方清單）",
    "can_all_org": "組織的一切（場域、成員、帳單、稽核、設備庫存、問題回報）",
    "can_org_sites": "可以管場域與人員",
    "can_org_devices": "可以管設備庫存",
    "can_org_audit": "可以看稽核",
    "can_org_billing": "可以管帳單",
    "can_svc": "服務角色：{{role}}",
    "duty": "值班操作台帳號",
    "drawer_access": "依範圍列出的存取權",
    "drawer_hint": "含他所屬成員群組的節點指派；每列可以撤銷。",
    "drawer_need_admin": "只有組織擁有者與管理員看得到完整的存取權。",
    "what_can": "{{name}} 能做什麼",
    "change_role": "變更角色…",
    "edit_perms": "組織權限…",
    "more_of": "{{name}} 的更多動作",
    "suspend_title": "停用 {{name}}？",
    "suspend_body": "他 30 秒內會被中斷即時影像與回放，之後也進不了這個組織；可以再恢復。",
    "change_role_of": "變更 {{name}} 的角色",
    "new_role": "新角色",
    "role_before": "變更前：{{role}}——{{desc}}",
    "role_after": "變更後：{{role}}——{{desc}}",
    "change_role_action": "變更角色",
    "org_role_desc_owner": "組織的一切，含指定組織管理員",
    "org_role_desc_org_admin": "組織、場域樹、成員、帳單、稽核、設備庫存；看影像要另外給存取權",
    "org_role_desc_member": "組織成員；能看什麼由節點指派、場域授權、$t(leaf.cur)角色或分享決定",
    "org_role_desc_guest": "預設看不到設備，要另外給存取權",
    "org_role_desc_developer": "開發者帳號（develop portal 的工作）",
    "org_role_desc_factory_ops": "產線帳號（產測與出貨）",
    "roles_hint": "每個角色一行「可以做」、一行「不可以」。要給人存取權，到「存取權」分頁按〔＋ 給存取權〕。",
    "roles_export_note": "下載 / 匯出錄影一律要另外勾，不會隨任何角色自動帶入。",
    "col_layer": "層",
    "col_can": "可以做",
    "col_cannot": "不可以",
    "layer_org": "組織層",
    "layer_site": "場域層",
    "layer_home": "$t(leaf.cur)層",
    "layer_custom": "自訂角色",
    "custom_cannot": "沒勾的動作",
    "rl_owner_name": "擁有者",
    "rl_owner_how": "組織角色",
    "rl_owner_can": "組織的一切，含指定組織管理員",
    "rl_owner_cannot": "—",
    "rl_org_admin_name": "組織管理員",
    "rl_org_admin_how": "組織角色",
    "rl_org_admin_can": "組織、場域樹、成員、帳單、稽核、設備庫存與收編",
    "rl_org_admin_cannot": "本身不帶看影像的權限；分享進本組織的設備不能管理",
    "rl_member_name": "成員 / 訪客",
    "rl_member_how": "組織角色",
    "rl_member_can": "組織成員資格；能看什麼由場域層角色、$t(leaf.cur)角色或分享決定",
    "rl_member_cannot": "組織事務",
    "rl_auditor_name": "稽核員",
    "rl_auditor_how": "組織權限「可以看稽核」",
    "rl_auditor_can": "稽核日誌、事件",
    "rl_auditor_cannot": "即時影像、回放",
    "rl_node_admin_name": "節點管理員",
    "rl_node_admin_how": "節點指派",
    "rl_node_admin_can": "範圍內全部資料動作含布防 / 撤防、維運、子節點與指派",
    "rl_node_admin_cannot": "分享、$t(leaf.cur)角色、錄影設定、解綁、格式化",
    "rl_operator_name": "操作員",
    "rl_operator_how": "節點指派或場域授權",
    "rl_operator_can": "看即時與回放、對講、PTZ、警報器、處理警報",
    "rl_operator_cannot": "匯出、設定、授權",
    "rl_viewer_name": "觀看者",
    "rl_viewer_how": "節點指派或場域授權",
    "rl_viewer_can": "即時與事件",
    "rl_viewer_cannot": "回放、匯出、控制、處理警報（警報不推播）",
    "rl_installer_name": "安裝技師",
    "rl_maintainer_name": "維運員",
    "rl_installer_how": "節點指派或場域授權",
    "rl_maintainer_how": "節點指派，或場域授權給單台",
    "rl_installer_can": "對焦調角度、設定",
    "rl_maintainer_can": "看設備與狀態、OTA、重新開機、改名、看 Kinio KMS 監控",
    "rl_installer_cannot": "回放、匯出、事件歷史",
    "rl_maintainer_cannot": "影像、對講、事件、回放、匯出、設定、授權；KMS 的設定與處置",
    "rl_home_roles_name": "$t(leaf.cur)擁有者 / 管理員 / 成員 / 訪客",
    "rl_home_roles_how": "$t(leaf.cur)角色",
    "rl_home_roles_can": "擁有者：$t(leaf.cur)的一切含解綁與分享；管理員：設定、授權、錄影政策；成員：看、回放、事件、控制；訪客：只看被分享的設備",
    "rl_home_roles_cannot": "依角色",
    "ext_out_desc": "把本組織的場域交給另一個組織代管，對方再指派他們的人。",
    "ext_in_desc": "別的組織把場域交給你們代管。",
    "ext_shares_title": "分享給本組織",
    "ext_shares_desc": "其他$t(leaf.cur)把設備分享給你們組織時，會出現在這裡；你可以決定哪些成員能看。",
    "size_struct": "{{x}}（結構總數）",
    "here": "這一層",
    "maintenance": "維護",
    "maintenance_hint": "停用會暫時拿掉這個人在本組織的所有存取；移出組織會永久拿掉，之後要重新邀請。",
    "email_need": "請輸入對方的 email",
    "assign_site_role": "指派場域角色",
    "subtree_scope": "涵蓋此場域及繼承權限的子場域與$t(leaf.cur)設備，包含日後新增的設備；中斷繼承的子場域不涵蓋。",
    "site_admin_help": "可查看、回放、控制、布撤防及維運設備，並管理子場域與角色指派。下載／匯出需另行授權。",
    "site_scope_help": "目前範圍：{{scope}}。要讓成員管理此範圍的設備，按「指派場域角色」，選擇「管理這個場域」。下方每筆授權的範圍可能不同；子場域的指派不會向上擴及整個組織。",
    "can_org_support": "可以回報問題、看本組織的回報",
    "err_dup_assignment": "{{who}} 在「{{where}}」已經有一筆指派：{{role}}，{{term}}。要改角色或期限，請到「存取權」分頁改那一筆，不用再新增。",
    "err_dup_assignment_unknown": "這個對象在「{{where}}」已經有一筆指派。要改角色或期限，請到「存取權」分頁改那一筆，不用再新增。",
    "dup_until": "到 {{date}}",
    "dup_schedule": "有時段限制"
  },
  "notfound": {
    "title": "找不到這一頁",
    "body": "{{path}} 不是 VMS 的頁面。可能網址打錯了，或這一頁已經搬家。",
    "home": "回總覽"
  },
  "nuart": {
    "row": "UART（TTL）接著的設備",
    "open": "開它的頁面",
    "label_was": "接線時取的名字：{{label}}",
    "not_visible": "沒有對到你看得到的 Kinio 設備（可能不是 Kinio 設備、在別的$t(leaf.cur)，或你沒有查看權限），所以沒有連結",
    "unset": "還沒設定接了哪台設備",
    "howto": "接線的人可以用設備群控制送 ttl_config 帶 dut，或在這台 Node 的 console 打",
    "howto_name": "名稱",
    "howto_model": "機種",
    "old_fw": "這台 Node 的韌體 {{v}} 還不會回報接了哪台設備，要先升級到 {{min}} 以上（可用更新 {{next}}）",
    "see_fw": "看韌體",
    "rx_none": "還沒收到接著的設備的輸出",
    "rx_just_now": "接著的設備剛剛有輸出",
    "rx_recent": "接著的設備 {{when}}有輸出",
    "rx_quiet": "接著的設備超過 24 小時沒有輸出（最後 {{at}}），可能沒接好或那台沒開機",
    "rx_node_offline": "Node 離線前最後收到輸出：{{when}}",
    "summary": "UART（TTL）接著的設備：{{name}}",
    "old_fw_unreleased": "這台 Node 的韌體（{{v}}）還不會回報接了哪台設備；支援的版本（{{min}} 以上）還沒發佈到更新通道"
  },
  "kinioch": {
    "title": "Kinio 攝影機接到錄影主機的通道",
    "help": "讓 Kinio Station 用自己的身分把一台 Kinio 攝影機接到它的某一路，跟其他通道一樣錄影、移動偵測、在影像牆看。攝影機不用跟 Station 在同一個家或場域，只要你看得到它的即時影像。",
    "no_station": "這個範圍裡沒有你能管理的 Kinio Station（需要擁有者或管理員）。",
    "station": "錄影主機",
    "camera": "攝影機",
    "pick_camera": "選一台你看得到即時影像的攝影機",
    "no_camera": "沒有你看得到即時影像的 Kinio 攝影機。",
    "channel": "通道（留空 = 第一個空的）",
    "channel_auto": "自動",
    "add": "接上",
    "whose": "權限算設定的人：之後你看不到這台攝影機（例如分享被收回、離開組織），這一路就會停，要由別人重設或移除。",
    "added": "已接到 CH{{ch}}：{{name}}",
    "current": "這台錄影主機的 Kinio 攝影機通道",
    "none": "還沒有",
    "by_me": "你設定的",
    "by_other": "別人設定的",
    "ok": "可以使用",
    "remove": "移除",
    "denied": "設定的人已無法看這台攝影機",
    "denied_not_granted": "設定的人已無權限看這台攝影機",
    "denied_org_mfa_required": "攝影機的組織要求兩步驟驗證：設定的人用兩步驟驗證登入後重設一次",
    "denied_ip_not_allowed": "攝影機的組織不允許設定時的網路",
    "denied_session_reauth": "設定的人要重新登入後重設",
    "denied_share_expired": "分享已到期",
    "denied_share_suspended": "分享暫停中",
    "denied_alarm_window": "只在警報後的時窗內可看",
    "denied_armed": "只在布防時可看",
    "denied_schedule": "不在授權的時段內",
    "denied_org_suspended": "攝影機的組織已停用",
    "denied_station_rebound": "錄影主機重新綁定過，要重設",
    "denied_device_unbound": "攝影機已解綁",
    "denied_no_assignment": "沒有設定",
    "err_DEVICE_NOT_FOUND": "找不到這台攝影機，或你看不到它",
    "err_FORBIDDEN": "你沒有這台攝影機的即時影像權限",
    "err_KINIO_SOURCE_SELF": "不能接這台錄影主機自己的通道",
    "err_KINIO_SOURCE_UNSUPPORTED": "這台錄影主機不支援 Kinio 攝影機通道",
    "err_NO_FREE_CHANNEL": "錄影主機的通道都用完了",
    "err_ORG_MFA_REQUIRED": "攝影機的組織要求兩步驟驗證，請開啟後重新登入",
    "err_GATEWAY_OFFLINE": "錄影主機離線"
  },
  "rech": {
    "title": "錄影健康",
    "table_title": "每路錄影健康",
    "col_channel": "通道",
    "col_state": "狀態",
    "state_ok": "正常錄影中",
    "state_idle": "現在不用錄",
    "idle_note": "不在錄影排程內，或錄影關著",
    "state_interrupted": "錄影中斷：{{reason}}",
    "since": "從 {{at}} 起（已 {{dur}}）",
    "state_none": "沒有回報",
    "none_note": "這台錄影主機的韌體還沒支援，或還沒連上雲端",
    "state_unreadable": "讀不到",
    "host_offline": "錄影主機離線，下面是最後一次回報（{{at}}）",
    "reason_disk_repairing": "硬碟正在修復，暫時不能寫入",
    "reason_no_storage": "找不到錄影硬碟",
    "reason_no_space": "硬碟滿了，而且設定成不覆寫",
    "reason_io_error": "寫入硬碟失敗",
    "reason_no_stream": "收不到攝影機的影像（攝影機離線或斷流）",
    "reason_unsupported_stream": "攝影機的影像格式錄不了",
    "reason_not_writing": "該錄影卻沒有寫出檔案（原因不明）",
    "reason_unknown": "原因不明",
    "last_write": "最後寫入",
    "dropped": "過去 1 小時丟掉的影格",
    "dropped_n": "{{n}} 格",
    "dropped_note": "錄影寫入跟不上時丟掉的，攝影機那端斷訊不算",
    "fsync": "存檔耗時（過去 1 小時）",
    "fsync_v": "一般 {{p95}} 毫秒內 · 最慢 {{max}} 毫秒",
    "fsync_none": "這一小時沒有存檔",
    "write_err": "過去 24 小時寫入失敗",
    "write_err_n": "{{n}} 次",
    "reset_note": "錄影主機重新開機後，這些數字從 0 重新算",
    "loading": "讀取中…",
    "dur_lt1m": "不到 1 分鐘",
    "dur_min_one": "{{count}} 分鐘",
    "dur_min_other": "{{count}} 分鐘"
  },
  "lens": {
    "lens_upper": "上鏡頭",
    "lens_lower": "下鏡頭",
    "lens_wide": "廣角鏡頭",
    "lens_tele": "長焦鏡頭",
    "lens_left": "左鏡頭",
    "lens_right": "右鏡頭",
    "lens_n": "鏡頭 {{n}}",
    "group": "鏡頭",
    "group_playback": "回放鏡頭",
    "filter_all": "全部鏡頭",
    "switching": "正在切換到{{name}}…",
    "switched": "已切換到{{name}}",
    "timeout": "{{name}}沒有回應",
    "unsupported": "這台目前不能看{{name}}",
    "privacy": "開了隱私遮罩時不能看{{name}}",
    "moved_back": "開了隱私遮罩，已切回{{name}}",
    "old_fw": "這台目前只能看一顆鏡頭",
    "look": "看{{name}}",
    "timeline_main": "{{name}}的錄影",
    "no_rec": "{{name}}沒有開錄影",
    "no_rec_at": "{{name}}這時沒有錄影",
    "open_settings": "到設定開啟",
    "ask_owner": "請屋主到設定開啟"
  },
  "wb": {
    "filter": "篩選",
    "filter_all": "全部",
    "filter_mine": "指派給我",
    "filter_overdue": "逾時",
    "list": "警報清單",
    "pane": "警報詳細",
    "empty": "目前沒有警報",
    "empty_mine": "沒有指派給你、還沒處理的警報",
    "empty_overdue": "沒有超過接手時限的警報",
    "all_done": "全部處理完了",
    "recent_closed": "最近結案的",
    "group_security": "還沒處理（安防）",
    "group_status": "還沒處理（狀態）",
    "group_recovered": "還沒處理（已恢復）",
    "group_claimed": "處理中",
    "group_closed": "已結案",
    "group_unlisted": "未登記或已移除的設備",
    "recovered": "↺ 已恢復",
    "me": "我",
    "left_member": "已離開的成員",
    "system": "系統",
    "assigned_to": "指派給 {{name}}",
    "assigned_line": "指派給 {{name}}（{{by}} 指派，{{at}}）",
    "assigned_now": "目前指派",
    "assign": "指派…",
    "assign_me": "{{name}}（我）",
    "unassign": "取消指派",
    "assign_filter": "輸入名字篩選",
    "assign_none": "沒有其他能處理這台的人",
    "assign_truncated": "只列前 500 位，請輸入名字篩選",
    "assign_not_eligible": "這個人目前不能處理這台的警報",
    "assign_invalid": "目前的狀態不能這樣指派",
    "assign_closed": "已結案的警報不能指派",
    "cannot": "這則是「{{state}}」，不能按「{{act}}」",
    "conflict": "已被 {{name}} 改成「{{state}}」，請再確認",
    "wave_skipped": "{{n}} 則已被別人處理，略過",
    "note_placeholder": "備註（一行，最多 {{max}} 字；Enter 只加備註）",
    "note_saved": "已加備註",
    "read_only": "你只能看這則警報",
    "no_media": "這台不是攝影機，沒有片段",
    "live": "即時",
    "live_open": "看即時",
    "live_offline": "離線中",
    "enlarge": "開大圖",
    "floorplan": "平面圖",
    "floorplan_open": "在地圖頁開這張平面圖",
    "related_more": "另有 {{n}} 台",
    "wave": "這一波 {{n}} 次",
    "wave_more": "全部列出",
    "wave_less": "收起",
    "wave_rest": "另有 {{n}} 次",
    "unlisted": "這台不在設備清單裡（未登記的通道或已移除的設備），不算在未處理數裡、沒有處理時限。",
    "started_before_alarm": "這次偵測開始時還不是警報（布防後才算警報，或沒收到開始紀錄）。",
    "sla_left": "剩 {{d}}",
    "sla_over": "逾時 {{d}}",
    "sla_over_now": "已逾時",
    "sla_line": "接手時限 {{m}} 分 · {{s}}",
    "sla_recovered": "已恢復，不計時",
    "sla_stopped": "已接手",
    "sla_met": "{{d}}內接手",
    "sla_met_late": "超過時限 {{d}}才接手",
    "sla_src_org": "來源：組織的預設",
    "sla_src_site": "來源：節點的設定",
    "sla_src_share": "來源：{{org}}（分享）的預設",
    "sla_src_other_org": "另一個組織",
    "dur_min_one": "{{count}} 分",
    "dur_min_other": "{{count}} 分",
    "dur_hour_one": "{{count}} 小時",
    "dur_hour_other": "{{count}} 小時",
    "dur_day_one": "{{count}} 天",
    "dur_day_other": "{{count}} 天",
    "h_assign": "{{by}} 指派給 {{to}}",
    "h_unassign": "{{by}} 取消指派（原本是 {{to}}）",
    "h_note": "{{by}} 加了備註",
    "h_overdue": "超過接手時限，已通知 {{list}}",
    "h_overdue_none": "超過接手時限（沒有可通知的人）",
    "h_overdue_merged": "超過接手時限，併入 {{at}} 的逾時通知",
    "h_cleared": "（原本指派給 {{name}}）",
    "help_title": "鍵盤快捷鍵",
    "help_hint": "游標在輸入框裡、或有對話框開著時，快捷鍵不作用。",
    "key_jk": "J / K（↓ / ↑）",
    "key_a": "A",
    "key_c": "C",
    "key_r": "R",
    "key_f": "F",
    "key_s": "S",
    "key_n": "N",
    "key_enter": "Enter",
    "key_x": "X",
    "key_q": "?",
    "key_esc": "Esc",
    "keydesc_jk": "下一則 / 上一則",
    "keydesc_a": "已看到",
    "keydesc_c": "我來處理（別人處理中 = 接手）",
    "keydesc_r": "已處理（自動到下一則）",
    "keydesc_f": "誤報（自動到下一則）",
    "keydesc_s": "指派給同事",
    "keydesc_n": "備註（Enter 只加備註、Esc 不送）",
    "keydesc_enter": "開大圖（有片段就播）",
    "keydesc_x": "展開 / 收起這一波",
    "keydesc_q": "列出快捷鍵",
    "keydesc_esc": "關大圖、選單、抽屜",
    "assigned_line_noat": "指派給 {{name}}（{{by}} 指派）"
  },
  "sla": {
    "title": "警報處理時限",
    "hint": "還沒有人接手的警報超過這個時間，會在畫面標「逾時」，並通知被指派的人與主管（組織擁有者、管理員、節點管理員）一次。逾時只提醒、不會改狀態。空白 = 不設。",
    "default": "組織預設",
    "security": "安防類",
    "status": "狀態類（影像訊號中斷）",
    "minutes": "分鐘",
    "off": "不設",
    "invalid": "請填 1–{{max}} 的整數，或留空",
    "invalid_node": "請填正確的分鐘數",
    "nodes": "節點覆寫",
    "nodes_none": "沒有節點覆寫，全部照組織預設。",
    "node_unknown": "（已刪除的節點）",
    "inherit": "沿用上一層",
    "set": "自訂",
    "node_off": "這個節點不設",
    "reset": "回到沿用",
    "pick_node": "選一個節點",
    "add": "新增覆寫"
  },
  "mycam": {
    "full_mode": "完整模式",
    "simple_mode": "簡易模式",
    "add_title": "用舊手機加入攝影機",
    "add_intro": "在舊手機安裝 MyCam，用這裡產生的 QR 碼或 8 碼把它加進你的家。",
    "home": "加到哪個家",
    "pick_home": "選一個家",
    "create_code": "產生綁定碼",
    "steps": "在舊手機打開 MyCam，掃描這個 QR 碼，或輸入下面的 8 碼。",
    "qr_label": "MyCam 綁定碼的 QR 碼",
    "expires": "{{n}} 分鐘內有效",
    "waiting": "等舊手機掃描…",
    "compare_title": "舊手機上顯示的是這個數字嗎？",
    "compare_device": "要加入的手機：{{device}}",
    "name": "名稱",
    "name_default": "客廳",
    "confirm": "是，加入",
    "reject": "不是這台",
    "done": "已加入「{{name}}」。舊手機設好 PIN 後就會開始看家。",
    "go_cameras": "看攝影機",
    "expired": "綁定碼過期了。",
    "plan_limit": "方案的攝影機數已滿。移除不用的攝影機或升級方案後再加入。",
    "no_admin_home": "你沒有可以加設備的家（要是家的擁有者或管理員）。",
    "brand_warn": "「{{home}}」是其他品牌 App 建立的家。MyCam 加在這裡的話，偵測到移動時手機 App 收不到通知。建議先在手機 App 新增一個家，再把 MyCam 加在新家。",
    "brand_keep": "仍加在這個家",
    "add_old_phone": "用舊手機加入"
  },
  "leaf": {
    "cur": "地點",
    "cur_lc": "地點",
    "cur_pl": "地點",
    "cur_lc_pl": "地點"
  },
  "support": {
    "title": "問題回報",
    "no_right": "要組織管理員在「人員與存取 › 成員」幫你勾「問題回報」，才能在這裡回報問題、看本組織的回報。",
    "new": "新回報",
    "hint": "回報 VMS、設備、錄影或帳號的問題；同組織有「問題回報」權限的人也看得到、可以補充。",
    "filter": "篩選",
    "scope_all": "全部",
    "scope_mine": "我開的",
    "scope_watching": "我關注的",
    "scope_org": "本組織的",
    "load_failed": "讀不到回報清單，請稍後再試。",
    "empty": "還沒有回報。",
    "new_reply": "新回覆",
    "by": "{{name}} 開的 · {{org}}",
    "status_open": "已收到",
    "status_triaged": "確認中",
    "status_in_progress": "處理中",
    "status_resolved": "已解決",
    "status_closed": "已結案",
    "cat_video": "影像與串流",
    "cat_offline": "設備離線",
    "cat_recording": "錄影與回放",
    "cat_account": "帳號與權限",
    "cat_alert": "通知與警報",
    "cat_other": "其他",
    "new_title": "新回報",
    "new_hint": "送出後技術支援會在這裡回覆，也會寄信通知你。",
    "org": "組織",
    "category": "問題類型",
    "device": "哪一台設備（選填）",
    "device_none": "不指定設備",
    "subject": "主旨",
    "body": "發生了什麼",
    "body_ph": "什麼時候開始、在哪個地點、哪些畫面、做了什麼後出現…",
    "files": "截圖或檔案（最多 {{n}} 個）",
    "file_type": "{{name}}：只收圖片、文字、JSON、ZIP、PDF",
    "file_big": "{{name}}：單檔最多 20 MB",
    "file_many": "最多 {{n}} 個檔案",
    "remove": "移除",
    "context": "會自動附上的技術資訊",
    "context_hint": "VMS 版本、瀏覽器、目前頁面、組織、設備與最近的錯誤，幫技術支援更快找到原因。",
    "blocked": "送出前檢查發現：{{summary}}。可以修改後再送，或寫下理由照送。",
    "override": "照送的理由",
    "err_NOT_SUPPORT_REPORTER": "你在這個組織沒有「問題回報」權限，請找組織管理員。",
    "err_BAD_ORG": "只能從你所屬的組織回報。",
    "err_RATE_LIMITED": "一小時內回報太多次，請稍後再試。",
    "err_TICKET_CLOSED": "這個回報已結案超過 7 天，請開新回報。",
    "err_generic": "送出失敗（{{code}}），請稍後再試。",
    "upload_failed": "有 {{n}} 個附件沒傳上去，可以在下方留言補充。",
    "sending": "送出中…",
    "submit": "送出回報",
    "not_found": "找不到這個回報，或你沒有權限看。",
    "back": "回到問題回報",
    "me": "我",
    "member": "同事",
    "staff": "技術支援",
    "status_changed": "狀態已更新",
    "attachments": "附件",
    "watchers": "關注的人",
    "add_comment": "補充說明",
    "send": "送出",
    "report_device": "回報這台的問題"
  },
  "sso": {
    "sign_in_with": "以 {{idp}} 登入",
    "sign_in_hint": "{{org}} 的成員可以用公司帳號登入；也可以照常用密碼登入。",
    "finishing": "正在完成公司帳號驗證…",
    "back_home": "回到首頁",
    "continue": "繼續",
    "email_reminder": "你的 Kinio 帳號 email 是公司信箱，離職後公司信箱會失效；建議到〔我的帳號〕把 email 改成個人信箱。",
    "org_unavailable": "這個組織目前沒有可用的公司帳號登入。",
    "start_body": "用 {{org}} 的公司帳號（{{idp}}）登入。",
    "use_password": "改用 Kinio 帳號密碼登入",
    "step_up_title": "需要以公司帳號驗證",
    "step_up_body": "{{org}} 要求以公司帳號驗證，才能查看這個組織的資源。你的其他組織與個人的家照常可用。",
    "other_orgs": "回到我的其他組織",
    "verify_with": "以 {{idp}} 驗證",
    "break_glass_hint": "公司帳號系統無法使用？",
    "break_glass": "用 passkey 緊急進入",
    "err_default": "公司帳號驗證沒有完成（{{code}}），請重新開始。",
    "err_SSO_NOT_LINKED": "這個公司帳號還沒連到 Kinio 帳號：請先用 Kinio 帳號登入，再到組織頁「以公司帳號驗證」。",
    "err_SSO_ALREADY_LINKED": "這個公司帳號已經連到另一個 Kinio 帳號。",
    "err_binding": "這次登入不是從這個瀏覽器開始的，請重新開始。",
    "err_SSO_BINDING_MISSING": "這次登入不是從這個瀏覽器開始的，請重新開始。",
    "err_BREAK_GLASS_NOT_ALLOWED": "你不在這個組織的緊急進入名單內。",
    "err_PASSKEY_REQUIRED": "請先用 passkey 驗證。",
    "err_PASSKEY_CANCELED": "已取消 passkey 驗證。",
    "err_SSO_IDP_UNAVAILABLE": "連不上公司的帳號系統，請稍後再試。",
    "err_idp_error": "公司的帳號系統回報錯誤，請聯絡公司 IT。",
    "err_state": "這次登入已過期或已使用，請重新開始。",
    "ff_title": "設定你的 passkey",
    "ff_body": "你的帳號是用公司帳號建立的，還沒有自己的登入方式。設一把 passkey，之後就能用它驗證身分。",
    "ff_why": "有些組織要求兩步驟驗證，或某些操作要用你自己的帳號再驗證一次；公司帳號登入只能用在你的公司組織。設好 passkey 後這些都能用。",
    "ff_verified": "已用公司帳號驗證，請再按一次〔設定 passkey〕。",
    "ff_unsupported": "這個瀏覽器不支援 passkey，請改用最新版的 Chrome、Edge 或 Safari。",
    "ff_setup": "設定 passkey",
    "ff_later": "稍後再說",
    "ff_not_needed": "你的帳號已經有自己的登入方式，不需要再設定。",
    "ff_go": "設定 passkey",
    "ff_passkey_name": "第一把 passkey",
    "no_account_title": "先登入或註冊 Kinio 帳號",
    "no_account_body": "這個公司帳號還沒連到 Kinio 帳號。請先用你自己的 Kinio 帳號登入（還沒有就先註冊），再到組織頁按「以公司帳號驗證」。註冊後請先完成 email 驗證。",
    "no_account_action": "登入 / 註冊",
    "link_pending_body": "用公司帳號（{{idp}}）驗證之後，就能加入這個組織。",
    "link_pending_dismiss": "略過",
    "link_not_eligible": "這個組織還沒讓你以公司帳號加入。請組織管理員先邀請你（邀請寄到你的 Kinio 帳號 email），或確認公司名冊上的 email 跟你的 Kinio 帳號一樣。"
  },
  "ssoadm": {
    "title": "企業 SSO",
    "hint": "讓成員用公司帳號（Entra ID、Okta、Google…）驗證才能使用這個組織的資源。帳號仍屬個人：密碼、兩步驟驗證、個人的家公司碰不到。",
    "idp": "公司的 IdP",
    "protocol": "協定",
    "display_name": "顯示名稱（登入按鈕上的字）",
    "cert": "IdP 簽章憑證（PEM）",
    "create": "建立",
    "test": "測試連線",
    "activate": "啟用",
    "disable": "停用",
    "delete": "刪除 IdP",
    "delete_title": "刪除公司的 IdP？",
    "delete_body": "所有成員的公司帳號連結會一起失效；之後要重新設定、測試、啟用，成員再各自以公司帳號驗證一次。",
    "status_draft": "草稿",
    "status_active": "已啟用",
    "status_disabled": "已停用",
    "untested": "還沒測試這個版本",
    "pending": "有一份待測的設定：測試連線成功後才會換上。",
    "sp_values": "把下面的值填到 IdP 的應用程式設定：",
    "sp_redirect_uri": "Redirect URI",
    "sp_entity_id": "SP Entity ID",
    "sp_acs_url": "ACS URL",
    "sp_metadata_url": "SP metadata",
    "domains": "公司網域",
    "domains_hint": "驗證過的網域：登入框輸入這個網域的 email 會出現「以公司帳號登入」。只比對完全相同的網域；不改任何既有帳號。",
    "domain_pending": "待驗證",
    "domain_verified": "已驗證",
    "verify": "驗證",
    "add_domain": "新增網域",
    "require": "要求 SSO",
    "require_label": "要求成員以公司帳號驗證",
    "require_hint": "只在使用這個組織的資源時要求；個人的家與其他組織照常。MFA 交由你的 IdP 負責。",
    "require_title": "開啟要求 SSO？",
    "require_body": "沒有用公司帳號驗證的成員會被擋在這個組織外（不會被登出整個帳號）。委派給其他組織的節點，對方成員改為要求兩步驟驗證。break-glass 名單：{{bg}}。",
    "require_on": "開啟",
    "max_age": "驗證有效時間",
    "break_glass": "緊急進入（break-glass）",
    "break_glass_hint": "公司 IdP 故障時，名單上的人可以用 passkey 略過 SSO 進入；每次使用都會寫稽核並通知其他管理員。最多 2 人，只有擁有者能改。",
    "bg_none": "（沒有）",
    "err_default": "沒有完成（{{code}}）",
    "err_SSO_IDP_INVALID": "IdP 設定有問題或連不上（{{reason}}）",
    "err_SSO_IDP_UNTESTED": "請先〔測試連線〕走一次 IdP 登入，再啟用。",
    "err_SSO_REQUIRED_ON": "要求 SSO 開著，先關掉才能停用或刪除 IdP。",
    "err_SSO_NOT_CONFIGURED": "先設好並啟用公司的 IdP，才能要求 SSO。",
    "err_SSO_PROOF_REQUIRED": "你這次登入還沒有用公司帳號驗證；先驗證一次再開啟，免得把自己鎖在外面。",
    "err_DOMAIN_NOT_VERIFIED": "還查不到 TXT 記錄（DNS 生效可能要幾分鐘）。",
    "err_DOMAIN_TAKEN": "這個網域已由別的組織驗證；有爭議請聯絡客服。",
    "err_INVALID_ARGUMENT": "值不合法（免費信箱網域不能驗證）。",
    "err_REAUTH_REQUIRED": "請重新驗證身分。",
    "err_BAD_POLICY": "設定值不合法。",
    "scim": "SCIM 自動佈建",
    "scim_hint": "讓公司目錄（Entra ID、Okta）自動同步名冊：員工離職停用後，他在這個組織的權限會自動移除（帳號本身不受影響）。",
    "scim_endpoint": "Tenant URL（SCIM 端點）",
    "scim_counts": "名冊 {{users}} 人（{{unmatched}} 人還沒對到帳號）· 群組 {{groups}} 個",
    "scim_last_sync": "最後同步：{{at}}",
    "scim_never": "還沒有同步過",
    "scim_token_row": "token 建立於 {{at}}",
    "scim_token_used": "最後使用 {{at}}",
    "scim_new": "產生 token",
    "scim_new_shown": "這是唯一一次顯示這個 token，請現在複製到 IdP 的 Secret Token 欄位：",
    "scim_revoke": "撤銷",
    "scim_revoke_title": "撤銷這個 SCIM token？",
    "scim_revoke_body": "撤銷後 IdP 用這個 token 同步會失敗，名冊與成員不會被改動。",
    "err_CONFLICT": "最多 2 個有效的 token，請先撤銷一個。"
  },
  "ssolink": {
    "title": "公司帳號連結",
    "hint": "這些組織用你的公司帳號驗證。解除後，進這些組織要再用公司帳號驗證一次。",
    "unlink": "解除",
    "unlink_title": "解除與「{{org}}」的公司帳號連結？",
    "unlink_body": "你在這個組織的公司帳號驗證會一起失效。",
    "unlink_failed": "沒有解除成功，請重新驗證身分後再試。"
  },
  "aiByo": {
    "title": "自帶 AI",
    "help": "用你自己的 OpenAI / Anthropic / Gemini 帳號分析事件畫面：產生一句描述（可搜尋）與人 / 車 / 動物 / 包裹標籤。費用由供應商直接向你收，Kinio 不加價、不代付。",
    "provider": "服務",
    "provider_openai": "OpenAI",
    "provider_anthropic": "Anthropic Claude",
    "provider_gemini": "Google Gemini",
    "api_key": "API key",
    "key_help": "存好後只顯示最後 4 碼，任何人（包括 Kinio）都看不到完整 key。平台會先用它查一次可用模型（不花錢）確認有效。",
    "consent_summary": "開了自帶 AI 的攝影機，每個移動事件會送 1 張畫面到 {{provider}} 分析，結果回到事件與搜尋。",
    "consent_body": "送出的資料：事件當下的 1 張畫面（縮到長邊 1024 px），不送攝影機名稱。\n目的地：你選的服務（OpenAI / Anthropic / Google）的官方 API。\n保存與訓練：由你跟該服務的合約決定；Kinio 只保存分析結果，保存期同事件。\n費用：服務直接向你收；可設每小時 / 每天上限。\n告知責任：你是資料控制者，請告知被拍攝的人。\n隨時可撤回：刪除 key 後 60 秒內停止送出。\n不做人臉辨識：分析不會辨識或推測任何人的身分。",
    "agree": "我已閱讀並同意",
    "add": "驗證並儲存",
    "add_help": "要重新驗證身分。",
    "status_active": "使用中",
    "status_invalid": "key 無效",
    "status_disabled": "停用",
    "status_needs_reentry": "要重新輸入 key",
    "invalid_help": "服務回覆這把 key 無效或沒有權限，已停止使用。請換一把 key。",
    "last_used": "最後使用 {{at}}",
    "model": "模型",
    "usage": "本月呼叫 {{calls}} 次",
    "cost_note": "費用以服務的帳單為準。",
    "max_per_hour": "每小時上限",
    "max_per_day": "每天上限",
    "devices_help": "勾選要用自帶 AI 分析的攝影機（這些攝影機 Kinio 雲端 AI 不再分析、不扣額度）：",
    "rekey_placeholder": "貼上新的 key",
    "rekey": "換 key",
    "delete": "刪除",
    "delete_help": "刪除後 60 秒內停止送出；若擔心外洩，請到服務後台作廢這把 key。",
    "fail_auth": "key 無效",
    "fail_rate": "服務限流",
    "fail_quota": "額度用完",
    "fail_model": "模型不可用",
    "fail_timeout": "逾時",
    "fail_server": "服務錯誤",
    "fail_schema": "回覆格式不對",
    "fail_bad_request": "請求被拒",
    "err_BYO_AI_KEY_INVALID": "這把 key 無效或沒有權限。",
    "err_BYO_AI_MODEL_UNAVAILABLE": "這把 key 用不到這個模型。",
    "err_BYO_AI_DISABLED_BY_POLICY": "組織的安全政策沒有開放自帶雲端 AI。",
    "err_BYO_AI_CREDENTIAL_EXISTS": "已經有一把 key，請直接換 key。",
    "err_BYO_AI_PROVIDER_UNAVAILABLE": "暫時連不到服務或被限流，請稍後再試。",
    "err_ENTITLEMENT_REQUIRED": "目前的方案不包含自帶雲端 AI。",
    "err_AI_ALREADY_ASSIGNED": "這台攝影機已指派給本地 AI，請先解除。",
    "err_VERSION_CONFLICT": "資料已被別人改過，請重新整理。",
    "err_REAUTH_REQUIRED": "請重新驗證身分後再試。"
  },
  "email_verify": {
    "title": "先驗證你的 email",
    "body": "為了保護你的帳號，驗證 email 之後才能新增登入方式。驗證信會寄到 {{email}}。",
    "body_action": "為了保護你的帳號，驗證 email 之後才能做這件事。驗證信會寄到 {{email}}。",
    "send": "寄驗證信",
    "later": "稍後再說",
    "sent": "已寄出驗證信，到信箱點連結後再試一次。",
    "err_RATE_LIMITED": "寄太多次了，請稍後再試。",
    "err_default": "寄不出驗證信（{{code}}），請稍後再試。",
    "already": "你的 email 已經驗證了，請再試一次。",
    "body_no_email": "為了保護你的帳號，驗證 email 之後才能新增登入方式。",
    "body_action_no_email": "為了保護你的帳號，驗證 email 之後才能做這件事。"
  }
}
